<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="emp-main">
    <Menus :menu="menus" icon="https://dsmlib.logistics.systems/Icons/Employee.png" @menuClicked="menuClicked" />
    <div class="right-container">
      <TableBox
        style="padding: 5px"
        title="Employee Profile"
        :tableData="empList"
        :selectedRow.sync="selectedEmp"
        :loading="empLoading"
      />
    </div>

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popupEntryTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="entryRequired"
      :successMessages="entrySuccess"
      :messages="entryMessages"
      :errorMessages="entryError"
      @requiredClicked="entryRequiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div class="emp-no">
        <Input
          placeholder="Employee No."
          :inputValue.sync="empNo"
          :errorMessage.sync="empNoError"
          validator="masterfilecode,10"
          :isRequired="true"
          ref="employeeno"
          :isDisabled="viewMode || popupEntryTitle[0] == 'E'"
        />
      </div>

      <Tab style="height: 100%" :tabs="tabsItems" :tabIndex.sync="currentTab">
        <!-- Quick Entry -->
        <div slot="Quick Entry">
          <!-- Upper -->
          <BoxContainer title="General Details" id="box-container">
            <div class="details-3-column">
              <Input
                placeholder="Employee Name"
                :inputValue.sync="genDetails['empName']"
                ref="employeename"
                validator="text,50,,alphabetic,space"
                :errorMessage.sync="empNameError"
                :isRequired="true"
                :isDisabled="viewMode"
              />
              <DateTimePicker
                placeholder="Date Of Birth"
                :value.sync="genDetails['dateofbirth']"
                :isRequired="true"
                :isDisabled="viewMode"
                ref="dateofbirth"
                :errorMessage.sync="dateofbirthError"
                :showTime="false"
              />
              <DateTimePicker
                placeholder="Date Joined"
                :value.sync="genDetails['dateJoined']"
                :isRequired="true"
                :isDisabled="viewMode"
                ref="dateJoined"
                :errorMessage.sync="dateJoinedError"
                :showTime="false"
              />
            </div>

            <div class="details-3-column">
              <div style="display: flex; flex-direction: row">
                <div style="margin-right: 3px; align-self: center">NRIC (New): </div>
                <Input
                  style="width: 70px"
                  placeholder=""
                  validator="positiveInteger,6"
                  :inputValue.sync="genDetails['nricNew1']"
                  ref="nricnew1"
                  :errorMessage.sync="nricNewError1"
                  :isRequired="true"
                  :isDisabled="viewMode"
                />
                <div style="align-self: center">-</div>
                <Input
                  style="width: 50px"
                  placeholder=""
                  validator="positiveInteger,2"
                  :inputValue.sync="genDetails['nricNew2']"
                  ref="nricnew2"
                  :errorMessage.sync="nricNewError2"
                  :isRequired="true"
                  :isDisabled="viewMode"
                />
                <div style="align-self: center">-</div>
                <Input
                  style="width: 60px"
                  placeholder=""
                  validator="positiveInteger,4"
                  :inputValue.sync="genDetails['nricNew3']"
                  ref="nricnew3"
                  :errorMessage.sync="nricNewError3"
                  :isRequired="true"
                  :isDisabled="viewMode"
                />
              </div>
              <Dropdown
                placeholder="Gender"
                :items="genDetailsData['gender']"
                itemKey="Gender"
                ref="gender"
                :errorMessage.sync="genderError"
                :selectedObject.sync="genDetails['gender']"
                :isRequired="true"
                :isDisabled="viewMode"
              />
              <BoxContainer title="LHDN eInvoice Details">
                <div class="lhdn-tin">
                  <button @click="validateTaxPayerTin" :disabled="validateTINIcon != ''"> Validate </button>
                  <div v-if="validateTINIcon != ''" style="margin-right: -5px; margin-left: 5px">
                    <Tooltip :icon="validateTINIcon" :tooltipText="validateTINMsg" />
                  </div>
                  <Input
                    style="margin-left: 5px"
                    placeholder="Tax Identification No (TIN)"
                    :inputValue.sync="eInvoiceTIN"
                    :isDisabled="viewMode"
                    ref="eInvoiceTIN"
                    validator="text,13,uppercase,alphanumeric,none"
                  />
                </div>
              </BoxContainer>
            </div>
            <div class="details-3-column">
              <Dropdown
                placeholder="Nationality"
                :items="genDetailsData['nationality']"
                itemKey="Country"
                descKey="Country Code"
                ref="nationality"
                :errorMessage.sync="nationalityError"
                :selectedObject.sync="genDetails['nationality']"
                :isRequired="true"
                :isDisabled="viewMode"
              />

              <Dropdown
                placeholder="Race"
                :items="genDetailsData['race']"
                itemKey="Race"
                ref="race"
                :errorMessage.sync="raceError"
                :selectedObject.sync="genDetails['race']"
                :isRequired="true"
                :isDisabled="viewMode"
              />
            </div>
          </BoxContainer>
          <!-- Lower -->
          <BoxContainer title="Other Details" id="box-container" style="height: 250px">
            <div class="details-3-column">
              <InputQuery
                placeholder="Branch"
                :items="otherDetailsData['branch']"
                itemKey="Branch Code"
                descKey="Branch Name"
                ref="branch"
                :errorMessage.sync="branchError"
                :selectedObject.sync="otherDetails['branch']"
                :isRequired="true"
                :isDisabled="viewMode"
              />
              <Input
                placeholder="Job Title"
                :inputValue.sync="otherDetails['jobTitle']"
                ref="jobtitle"
                :errorMessage.sync="jobTitleError"
                :isRequired="true"
                :isDisabled="viewMode"
                validator="text,50"
              />
              <!-- <InputQuery placeholder="Driving Class" :items="otherDetailsData['drivingClass']" itemKey="Class" descKey="Class Description" ref="drivingClass" :errorMessage.sync="drivingClassError"
                  :selectedObject.sync="otherDetails['drivingClass']" :isRequired="true" :isDisabled="viewMode" /> -->
              <InputQuery
                placeholder="Employment Type"
                :errorMessage.sync="employmentTypeError"
                ref="employmentTypeError"
                :isRequired="true"
                :items="otherDetailsData['employmentType']"
                itemKey="EmploymentType"
                descKey="EmploymentTypeDesc"
                :selectedObject.sync="otherDetails['employmentType']"
                :isDisabled="viewMode"
              />
            </div>
            <div class="details-3-column">
              <Dropdown
                placeholder="Department"
                :items="otherDetailsData['dept']"
                itemKey="DeptDesc"
                descKey="ID"
                ref="department"
                :errorMessage.sync="deptError"
                :selectedObject.sync="otherDetails['dept']"
                :isRequired="true"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="Driving License No."
                validator="alphanumeric,15"
                :inputValue.sync="otherDetails['drivingLicenseNo']"
                ref="drivingLicenseNo"
                :errorMessage.sync="drivingLicenseNoError"
                :isRequired="dynamicRequired"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="Badge License No."
                validator="alphanumeric,15"
                :inputValue.sync="otherDetails['badgeLicenseNo']"
                ref="badgeLicenseNo"
                :errorMessage.sync="badgeLicenseNoError"
                :isRequired="dynamicRequired"
                :isDisabled="viewMode"
              />

              <Input
                validator="alphanumeric,25"
                placeholder="Port Pass No."
                :inputValue.sync="otherDetails['portPassNo']"
                ref="portPassNo"
                :errorMessage.sync="portPassNoError"
                :isDisabled="viewMode"
              />

              <Filters
                class="filters"
                :isDisabled="viewMode"
                placeholder="Driving Class"
                title="Driving Class"
                itemKey="Class"
                :tableData="otherDetailsData['drivingClass']"
                :selectedObject.sync="otherDetails['drivingClass']"
                :isRequired="dynamicRequired"
                noneSelectedText="None"
                noneSelectedConfirmButtonText="Select None"
                :errorMessage.sync="drivingClassError"
                itemDesc="Class Description"
                ref="filtersRef"
              />
            </div>
            <div class="details-3-column">
              <InputQuery
                placeholder="Commission Code"
                :items="otherDetailsData['commisionCode']"
                itemKey="Com Code"
                ref="commisionCode"
                :errorMessage.sync="commisionCodeError"
                descKey="Remark"
                :selectedObject.sync="otherDetails['commisionCode']"
                :isRequired="dynamicRequired"
                :isDisabled="viewMode"
              />
              <DateTimePicker
                placeholder="Driving License Expiry"
                :value.sync="otherDetails['expirydatedl']"
                :isRequired="dynamicRequired"
                :isDisabled="viewMode"
                ref="expirydatedl"
                :errorMessage.sync="expirydatedlError"
                :showTime="false"
              />

              <DateTimePicker
                placeholder="Badge License Expiry"
                :value.sync="otherDetails['expirydatebl']"
                :isRequired="dynamicRequired"
                :isDisabled="viewMode"
                ref="expirydatebl"
                :errorMessage.sync="expirydateblError"
                :showTime="false"
              />

              <DateTimePicker
                placeholder="Port Pass Expiry"
                :value.sync="otherDetails['expirydatepp']"
                :isDisabled="viewMode"
                ref="expirydatepp"
                :errorMessage.sync="portPassExpiryError"
                :showTime="false"
              />
            </div>
          </BoxContainer>
        </div>
        <!-- General Details -->
        <div slot="General Details" style="height: calc(100% - 100px); width: 100%; flex-direction: row; display: flex">
          <!-- <div style="flex-direction:column;   display: flex;" > -->
          <div class="details-3-column">
            <Input
              placeholder="Employee Name"
              :inputValue.sync="genDetails['empName']"
              ref="employeename"
              validator="text,50,,alphabetic,space"
              :errorMessage.sync="empNameError"
              :isRequired="true"
              :isDisabled="viewMode"
            />
            <div style="width: 100%; display: flex; justify-content: flex-centre">
              <Input placeholder="Status" :inputValue.sync="genDetails['status']" :isDisabled="true" />
              <button
                style="margin-left: 5px"
                @click="reverseTerminationIsClicked"
                :disabled="terminationStatusIsDisable"
                >Reinstate</button
              >
            </div>
            <Dropdown
              placeholder="Nationality"
              :items="genDetailsData['nationality']"
              itemKey="Country"
              descKey="Country Code"
              ref="nationality"
              :errorMessage.sync="nationalityError"
              :selectedObject.sync="genDetails['nationality']"
              :isRequired="true"
              :isDisabled="viewMode"
            />
            <div style="width: 100%; display: flex">
              <img src="https://dsmlib.logistics.systems/Icons/disableperson.png" />
              <CheckBox
                style="margin-left: 5px"
                title="Disabled"
                @checkBoxClicked="checkBoxClicked('OKU')"
                :isChecked="genDetails['disablecheck']"
                :isDisabled="viewMode"
              />
            </div>
            <div style="display: flex; flex-direction: row">
              <div style="margin-right: 3px; align-self: center">NRIC (New): </div>
              <Input
                style="width: 70px"
                placeholder=""
                validator="positiveInteger,6"
                :inputValue.sync="genDetails['nricNew1']"
                ref="nricnew1"
                :errorMessage.sync="nricNewError1"
                :isRequired="true"
                :isDisabled="viewMode"
              />
              <div style="align-self: center">-</div>
              <Input
                style="width: 50px"
                placeholder=""
                validator="positiveInteger,2"
                :inputValue.sync="genDetails['nricNew2']"
                ref="nricnew2"
                :errorMessage.sync="nricNewError2"
                :isRequired="true"
                :isDisabled="viewMode"
              />
              <div style="align-self: center">-</div>
              <Input
                style="width: 60px"
                placeholder=""
                validator="positiveInteger,4"
                :inputValue.sync="genDetails['nricNew3']"
                ref="nricnew3"
                :errorMessage.sync="nricNewError3"
                :isRequired="true"
                :isDisabled="viewMode"
              />
            </div>
            <DateTimePicker
              placeholder="Date Of Birth"
              :value.sync="genDetails['dateofbirth']"
              :isRequired="true"
              :isDisabled="viewMode"
              ref="dateofbirth"
              :errorMessage.sync="dateofbirthError"
              :showTime="false"
            />

            <Dropdown
              placeholder="Gender"
              :items="genDetailsData['gender']"
              itemKey="Gender"
              ref="gender"
              :errorMessage.sync="genderError"
              :selectedObject.sync="genDetails['gender']"
              :isRequired="true"
              :isDisabled="viewMode"
            />

            <Dropdown
              placeholder="Marital Status"
              :items="genDetailsData['maritalStat']"
              itemKey="Marital Status"
              descKey="Description"
              :selectedObject.sync="genDetails['maritalStat']"
              :isDisabled="viewMode"
            />

            <DateTimePicker
              placeholder="Date Joined"
              :value.sync="genDetails['dateJoined']"
              :isRequired="true"
              :isDisabled="viewMode"
              ref="dateJoined"
              :errorMessage.sync="dateJoinedError"
              :showTime="false"
            />
            <DateTimePicker
              placeholder="Date Confirmed"
              :value.sync="genDetails['dateConfirmed']"
              :errorMessage.sync="dateConfirmedError"
              ref="dateConfirmed"
              :isDisabled="viewMode"
              :showTime="false"
            />
          </div>

          <div class="details-3-column">
            <Input
              placeholder="Place of Birth"
              :inputValue.sync="genDetails['pob']"
              ref="pob"
              :errorMessage.sync="pobError"
              :isDisabled="viewMode"
            />

            <Input
              placeholder="NRIC (Old)"
              :inputValue.sync="genDetails['nricOld']"
              ref="nricold"
              :errorMessage.sync="nricOldError"
              :isDisabled="viewMode"
            />

            <Input placeholder="Age" :inputValue="ageValue" :isDisabled="true" />

            <Dropdown
              placeholder="Religion"
              :items="genDetailsData['religion']"
              itemKey="Religion"
              descKey="Description"
              :selectedObject.sync="genDetails['religion']"
              :isDisabled="viewMode"
            />

            <Dropdown
              placeholder="Ethnicity"
              :items="genDetailsData['ethnicity']"
              itemKey="Ethnic"
              descKey="Description"
              :selectedObject.sync="genDetails['ethnicity']"
              :isDisabled="viewMode"
            />

            <Dropdown
              placeholder="Race"
              :items="genDetailsData['race']"
              itemKey="Race"
              descKey="Description"
              ref="race"
              :errorMessage.sync="raceError"
              :selectedObject.sync="genDetails['race']"
              :isRequired="true"
              :isDisabled="viewMode"
            />

            <Input
              placeholder="Spouse Name"
              :inputValue.sync="genDetails['spouseName']"
              :isDisabled="viewMode"
              :errorMessage.sync="spouseNameError"
            />

            <DateTimePicker
              placeholder="Date Left"
              :value.sync="genDetails['dateLeft']"
              :isDisabled="!terminationStatusIsDisable || viewMode"
              :showTime="false"
            />

            <Input placeholder="Employment Duration" :inputValue="employmentValue" :isDisabled="true" />

            <BoxContainer title="LHDN eInvoice Details">
              <div class="lhdn-tin">
                <button @click="validateTaxPayerTin" :disabled="validateTINIcon != ''"> Validate </button>
                <div v-if="validateTINIcon != ''" style="margin-right: -5px; margin-left: 5px">
                  <Tooltip :icon="validateTINIcon" :tooltipText="validateTINMsg" />
                </div>
                <Input
                  style="margin-left: 5px"
                  placeholder="Tax Identification No (TIN)"
                  :inputValue.sync="eInvoiceTIN"
                  :isDisabled="viewMode"
                  ref="eInvoiceTIN"
                  validator="text,13,uppercase,alphanumeric,none"
                />
              </div>
            </BoxContainer>
          </div>

          <div class="details-3-column;">
            <Input
              textType="file"
              placeholder="Choose Employee Image"
              @fileChanged="imageChanged"
              ref="imageInput"
              :isDisabled="viewMode"
            />
            <div class="employee-image">
              <img v-if="genDetails['employeeImage']" :src="genDetails['employeeImage']" alt="no image" class="myimg" />
            </div>
          </div>
        </div>
        <!-- Other Details -->
        <div slot="Other Details" style="height: 100%; display: flex">
          <BoxContainer
            title="EPF & SOCSO"
            style="margin-right: 5px; flex-direction: row; width: 100%; height: fit-content"
          >
            <div class="details-2-column">
              <InputQuery
                placeholder="Employment Type"
                :errorMessage.sync="employmentTypeError"
                :isRequired="true"
                ref="employmentTypeError"
                :items="otherDetailsData['employmentType']"
                itemKey="EmploymentType"
                descKey="EmploymentTypeDesc"
                :selectedObject.sync="otherDetails['employmentType']"
                :isDisabled="viewMode"
              />

              <DateTimePicker
                placeholder="Contract Start Date"
                :value.sync="otherDetails['contractStart']"
                :isDisabled="viewMode"
                :showTime="false"
              />

              <DateTimePicker
                placeholder="Contract End Date"
                :value.sync="otherDetails['contractEnd']"
                :isDisabled="viewMode"
                :showTime="false"
              />

              <InputQuery
                placeholder="Branch"
                :items="otherDetailsData['branch']"
                itemKey="Branch Code"
                descKey="Branch Name"
                ref="branch"
                :errorMessage.sync="branchError"
                :selectedObject.sync="otherDetails['branch']"
                :isRequired="true"
                :isDisabled="viewMode"
              />

              <InputQuery
                placeholder="Department"
                :items="otherDetailsData['dept']"
                itemKey="ID"
                descKey="DeptDesc"
                ref="department"
                :errorMessage.sync="deptError"
                :selectedObject.sync="otherDetails['dept']"
                :isRequired="true"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="Job Title/Position"
                :inputValue.sync="otherDetails['jobTitle']"
                ref="jobtitle"
                :errorMessage.sync="jobTitleError"
                :isRequired="true"
                :isDisabled="viewMode"
                validator="text,50"
              />

              <InputQuery
                placeholder="Superior"
                :items="otherDetailsData['superior']"
                itemKey="Employee ID"
                descKey="Employee Name"
                :selectedObject.sync="otherDetails['superior']"
                :isDisabled="viewMode"
              />

              <InputQuery
                placeholder="Shift"
                :items="otherDetailsData['shift']"
                itemKey="Shift"
                :selectedObject.sync="otherDetails['shift']"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="Total Working Hour"
                :inputValue.sync="otherDetails['totalWorkingHrs']"
                ref="totalWorkingHrs"
                :regex="totalWorkingHrsRegex"
                :errorMessage.sync="totalWorkingHrsError"
                :isDisabled="viewMode"
              />
            </div>
            <div class="details-2-column">
              <Input
                placeholder="Income Tax No."
                :inputValue.sync="otherDetails['incomeTaxNo']"
                ref="incomeTaxNo"
                :errorMessage.sync="incomeTaxNoError"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="EPF No."
                :inputValue.sync="otherDetails['epfNo']"
                ref="epfNo"
                :errorMessage.sync="epfNoError"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="SOCSO No."
                :inputValue.sync="otherDetails['socsoNo']"
                ref="socsoNo"
                :errorMessage.sync="socsoNoError"
                :isDisabled="viewMode"
              />

              <InputQuery
                placeholder="Income Tax Category"
                :items="otherDetailsData['incomeTaxCategory']"
                itemKey="IncTaxCategory"
                :selectedObject.sync="otherDetails['incomeTaxCategory']"
                :isDisabled="viewMode"
              />

              <InputQuery
                placeholder="EPF Category"
                :items="otherDetailsData['epfCategory']"
                itemKey="EPFCategory"
                :selectedObject.sync="otherDetails['epfCategory']"
                :isDisabled="viewMode"
                descKey="Description"
              />

              <InputQuery
                placeholder="SOCSO Category"
                :items="otherDetailsData['socsoCategory']"
                itemKey="SocsoCategory"
                :selectedObject.sync="otherDetails['socsoCategory']"
                :isDisabled="viewMode"
                descKey="Description"
              />

              <InputQuery
                placeholder="SKBBK Lindungan 24 jam"
                :items="otherDetailsData['skbbkCategory']"
                itemKey="SocsoCategory"
                :selectedObject.sync="otherDetails['skbbkCategory']"
                :isDisabled="viewMode"
                descKey="Description"
              />
            </div>
          </BoxContainer>

          <div style="display: flex; flex-direction: column; width: 100%">
            <BoxContainer title="Driving Details" style="flex-direction: row; height: 230px">
              <div class="details-1-column">
                <Input
                  placeholder="Driving License No."
                  :inputValue.sync="otherDetails['drivingLicenseNo']"
                  ref="drivingLicenseNo"
                  :errorMessage.sync="drivingLicenseNoError"
                  :isRequired="dynamicRequired"
                  :isDisabled="viewMode"
                  validator="alphanumeric,15"
                />
                <!-- <InputQuery placeholder="Driving Class" :items="otherDetailsData['drivingClass']" itemKey="Class" descKey="Class Description" ref="drivingClass" :errorMessage.sync="drivingClassError"
                    :selectedObject.sync="otherDetails['drivingClass']" :isRequired="true" :isDisabled="viewMode" /> -->
                <Filters
                  class="filters"
                  :isDisabled="viewMode"
                  placeholder="Driving Class"
                  title="Driving Class"
                  itemKey="Class"
                  :tableData="otherDetailsData['drivingClass']"
                  :selectedObject.sync="otherDetails['drivingClass']"
                  :isRequired="dynamicRequired"
                  noneSelectedText="None"
                  noneSelectedConfirmButtonText="Select None"
                  :errorMessage.sync="drivingClassError"
                  itemDesc="Class Description"
                />
                <Input
                  validator="alphanumeric,15"
                  placeholder="Badge License No."
                  :inputValue.sync="otherDetails['badgeLicenseNo']"
                  ref="badgeLicenseNo"
                  :errorMessage.sync="badgeLicenseNoError"
                  :isRequired="dynamicRequired"
                  :isDisabled="viewMode"
                />
                <Input
                  validator="alphanumeric,25"
                  placeholder="Port Pass No."
                  :inputValue.sync="otherDetails['portPassNo']"
                  ref="portPassNo"
                  :errorMessage.sync="portPassNoError"
                  :isDisabled="viewMode"
                />
                <InputQuery
                  placeholder="Commission Code"
                  :items="otherDetailsData['commisionCode']"
                  itemKey="Com Code"
                  ref="commisionCode"
                  :errorMessage.sync="commisionCodeError"
                  descKey="Remark"
                  :selectedObject.sync="otherDetails['commisionCode']"
                  :isRequired="dynamicRequired"
                  :isDisabled="viewMode"
                />
              </div>
              <div class="details-1-column">
                <DateTimePicker
                  placeholder="Driving License Expiry"
                  :value.sync="otherDetails['expirydatedl']"
                  :isRequired="dynamicRequired"
                  :isDisabled="viewMode"
                  ref="expirydatedl"
                  :errorMessage.sync="expirydatedlError"
                  :showTime="false"
                />
                <DateTimePicker
                  style="margin-top: 110px"
                  placeholder="Badge License Expiry"
                  :value.sync="otherDetails['expirydatebl']"
                  :isRequired="dynamicRequired"
                  :isDisabled="viewMode"
                  ref="expirydatebl"
                  :errorMessage.sync="expirydateblError"
                  :showTime="false"
                />
                <DateTimePicker
                  placeholder="Port Pass Expiry"
                  :value.sync="otherDetails['expirydatepp']"
                  :errorMessage.sync="portPassExpiryError"
                  ref="expirydatepp"
                  :isDisabled="viewMode"
                  :showTime="false"
                />
                <!-- ref="portPassExpiry" -->
              </div>
            </BoxContainer>

            <BoxContainer title="Payroll Type">
              <div class="check-box-container" style="display: flex">
                <CheckBox
                  :isDisabled="viewMode"
                  title="Cash"
                  :isChecked.sync="cashChecked"
                  @checkBoxClicked="checkBoxClicked('CS')"
                  style="margin-right: 10px"
                />
                <CheckBox
                  :isDisabled="viewMode"
                  title="Cheque/Bank Transfer"
                  :isChecked.sync="chequeChecked"
                  @checkBoxClicked="checkBoxClicked('CH')"
                />
              </div>
              <InputQuery
                v-if="chequeChecked"
                placeholder="Payroll Bank"
                :items="otherDetailsData['payrollBank']"
                itemKey="Bank Code"
                descKey="Bank Name"
                :selectedObject.sync="otherDetails['payrollBank']"
                :isDisabled="viewMode"
              />
              <Input
                v-if="chequeChecked"
                placeholder="Payroll Account No."
                :inputValue.sync="otherDetails['payrollAccNo']"
                ref="payrollAccNo"
                :errorMessage.sync="payrollAccNoError"
                :isDisabled="viewMode"
              />
              <InputQuery
                placeholder="Overtime Formula"
                :items="otherDetailsData['otFormula']"
                itemKey="Formula Code"
                descKey="Description"
                :selectedObject.sync="otherDetails['otFormula']"
                :isDisabled="viewMode"
              />
            </BoxContainer>
          </div>
        </div>
        <!-- Contact Details -->
        <div slot="Contact Details" style="height: 100%">
          <div style="display: flex; height: fit-content">
            <BoxContainer class="details-2-column" title="Employee Contact" style="height: fit-content">
              <div style="display: flex; justify-content: space-around">
                <CheckBox
                  :isDisabled="viewMode"
                  title="Default"
                  :isChecked.sync="defaultChecked"
                  @checkBoxClicked="checkBoxClicked('Default')"
                  style="margin-left: 10px"
                />
                <CheckBox
                  :isDisabled="viewMode"
                  title="Postal"
                  :isChecked.sync="postalChecked"
                  @checkBoxClicked="checkBoxClicked('Postal')"
                  style="margin-left: 10px"
                />
                <CheckBox
                  :isDisabled="viewMode"
                  title="Same Default & Postal Contact Details"
                  :isChecked.sync="sameDefaultPostalChecked"
                  @checkBoxClicked="checkBoxClicked('SameDefaultPostal')"
                  style="margin-left: 10px"
                />
              </div>
              <div style="display: flex">
                <BoxContainer
                  v-if="defaultChecked || sameDefaultPostalChecked"
                  :title="defaultChecked ? 'Default' : 'Same Default and Postal'"
                  :style="{ width: postalChecked ? '50%' : '100%', marginRight: postalChecked ? '5px' : '0' }"
                >
                  <!-- <AddressForm :viewMode="viewMode" :data.sync="contactDetails['defaultAddressData']"  /> -->
                  <AddressFormV2
                    :viewMode="viewMode"
                    :address.sync="contactDetails['defaultAddressData']"
                    :addressErrors.sync="contactDetails['defaultAddressErrors']"
                    ref="defaultAddressForm"
                  />
                  <Input
                    placeholder="Phone No."
                    validator="text,20"
                    :inputValue.sync="contactDetails['defaultPhone']"
                    :errorMessage.sync="contactDetails['defaultPhoneError']"
                    ref="defaultPhone"
                    :isDisabled="viewMode"
                  />
                  <Input
                    placeholder="Mobile No."
                    validator="text,20"
                    :inputValue.sync="contactDetails['defaultMobile']"
                    :errorMessage.sync="contactDetails['defaultMobileError']"
                    ref="defaultMobile"
                    :isDisabled="viewMode"
                  />
                  <Input
                    placeholder="Email (1)"
                    validator="text,40"
                    :inputValue.sync="contactDetails['defaultEmail1']"
                    :errorMessage.sync="contactDetails['defaultEmail1Error']"
                    ref="defaultEmail1"
                    :isDisabled="viewMode"
                  />
                  <Input
                    placeholder="Email (2)"
                    validator="text,40"
                    :inputValue.sync="contactDetails['defaultEmail2']"
                    :errorMessage.sync="contactDetails['defaultEmail2Error']"
                    ref="defaultEmail2"
                    :isDisabled="viewMode"
                  />
                </BoxContainer>
                <BoxContainer v-if="postalChecked" title="Postal" :style="{ width: defaultChecked ? '50%' : '100%' }">
                  <!-- <AddressForm :viewMode="viewMode" :data.sync="contactDetails['postalAddressData']" /> -->
                  <AddressFormV2
                    :viewMode="viewMode"
                    :address.sync="contactDetails['postalAddressData']"
                    :addressErrors.sync="contactDetails['postalAddressErrors']"
                    ref="postalAddressForm"
                  />
                  <Input
                    placeholder="Phone No."
                    validator="text,20"
                    :inputValue.sync="contactDetails['postalPhone']"
                    :errorMessage.sync="contactDetails['postalPhoneError']"
                    ref="postalPhone"
                    :isDisabled="viewMode"
                  />
                  <Input
                    placeholder="Mobile No."
                    validator="text,20"
                    :inputValue.sync="contactDetails['postalMobile']"
                    :errorMessage.sync="contactDetails['postalMobileError']"
                    ref="postalMobile"
                    :isDisabled="viewMode"
                  />
                  <Input
                    placeholder="Email (1)"
                    validator="text,40"
                    :inputValue.sync="contactDetails['postalEmail1']"
                    :errorMessage.sync="contactDetails['postalEmail1Error']"
                    ref="postalEmail1"
                    :isDisabled="viewMode"
                  />
                  <Input
                    placeholder="Email (2)"
                    validator="text,40"
                    :inputValue.sync="contactDetails['postalEmail2']"
                    :errorMessage.sync="contactDetails['postalEmail2Error']"
                    ref="postalEmail2"
                    :isDisabled="viewMode"
                  />
                </BoxContainer>
              </div>
            </BoxContainer>

            <BoxContainer title="Next Of Kin Contact" class="details-2-column" style="height: fit-content">
              <Input
                placeholder="Name"
                validator="text,50"
                :inputValue.sync="contactDetails['kinName']"
                :errorMessage.sync="contactDetails['kinNameError']"
                ref="kinName"
                :isDisabled="viewMode"
              />
              <Input
                placeholder="Relationship"
                validator="text,20"
                :inputValue.sync="contactDetails['kinRelationship']"
                :errorMessage.sync="contactDetails['kinRelationshipError']"
                ref="kinRelationship"
                :isDisabled="viewMode"
              />
              <!-- <AddressForm :viewMode="viewMode" :data.sync="contactDetails['kinAddressData']" /> -->
              <AddressFormV2
                :viewMode="viewMode"
                :address.sync="contactDetails['kinAddressData']"
                :addressErrors.sync="contactDetails['kinAddressErrors']"
                ref="kinAddressForm"
              />
              <Input
                placeholder="Phone No."
                validator="text,20"
                :inputValue.sync="contactDetails['kinPhone']"
                :errorMessage.sync="contactDetails['kinPhoneError']"
                ref="kinPhone"
                :isDisabled="viewMode"
              />
              <!-- <div style="justifyContent: flex-end">
                  <button :disabled="false" style=" cursor: pointer; display: flex; justifyContent: space-between; alignItems:center; width: fit-content; height: fit-content;" @click="showNomineeButtonClicked">
                    <div style="border-radius:50%; width:28px; height:28px;">
                      <img :src="(!contactDetails['showNominee']) ? 'https://img.icons8.com/windows/18/000000/add-tab.png' : 'https://img.icons8.com/windows/18/000000/close-tab.png'" style="width: 25px; height: 25px; pointer-events: none;"/>
                    </div>
                    <div style="padding-left: 5px;">Nominee</div>
                  </button>
                  </div> -->
            </BoxContainer>
          </div>
          <div slot="Nominee Profile" class="slotWithTableBox">
            <BoxContainer title="Nominee Profile" style="flex-direction: row; display: flex; width: 100%; height: 100%">
              <div class="divWithTableBox" :style="{ width: showNomineeDetails ? '50%' : '100%' }">
                <div v-if="!viewMode" style="display: flex">
                  <button :disabled="viewBtn" @click="showNomineeButtonClicked">Add</button>
                  <button :disabled="viewBtn" @click="deleteNomineeClicked" style="margin-left: 5px">Delete</button>
                </div>
                <TableBox
                  title="Nominee Profile"
                  style="height: calc(100% - 57px)"
                  :additionalButtons="viewMode ? [] : editButtons"
                  :tableData="nomineeList"
                  :selectedRow.sync="selectedNominee"
                  :maxSelection="-1"
                  :hideColumns="['Action']"
                  @buttonClicked="editNomineeButtonClicked"
                />
              </div>
              <div v-if="showNomineeDetails" :style="{ marginLeft: '5px', width: showNomineeDetails ? '50%' : '0' }">
                <div style="display: flex; justify-content: flex-end; margin-bottom: 5px">
                  <button :disabled="viewBtn" @click="clearDetails('nominee')" class="clear-all-button">Clear</button>
                  <button :disabled="viewBtn" @click="saveNominee" class="save-button" style="margin-left: 5px"
                    >Save
                  </button>
                  <button
                    :disabled="viewBtn"
                    @click="showNomineeDetails = false"
                    style="margin-left: 5px"
                    class="cancel-button"
                    >Cancel</button
                  >
                </div>
                <div>
                  <Input
                    placeholder="Nominee Name"
                    :isRequired="true"
                    validator="text,40"
                    :errorMessage.sync="nomNameError"
                    :inputValue.sync="contactDetails['nomineeName']"
                    :isDisabled="viewMode"
                  />
                  <InputQuery
                    placeholder="Nominee Type"
                    :isRequired="true"
                    :items="contactDetailsData['nomineeType']"
                    itemKey="Nominee Type"
                    :errorMessage.sync="nomineeTypeError"
                    :selectedObject.sync="contactDetails['nomineeType']"
                    :isDisabled="viewMode"
                  />
                </div>
                <div>
                  <div style="display: flex; flex-direction: row">
                    <div style="margin-right: 3px; align-self: center">Nominee NRIC: </div>
                    <Input
                      style="width: 70px"
                      placeholder=""
                      validator="positiveInteger,6"
                      :inputValue.sync="contactDetails['nomineeNRIC1']"
                      :errorMessage.sync="nomNRICError1"
                      :isRequired="true"
                      :isDisabled="viewMode"
                    />
                    <div style="align-self: center">-</div>
                    <Input
                      style="width: 50px"
                      placeholder=""
                      validator="positiveInteger,2"
                      :inputValue.sync="contactDetails['nomineeNRIC2']"
                      :errorMessage.sync="nomNRICError2"
                      :isRequired="true"
                      :isDisabled="viewMode"
                    />
                    <div style="align-self: center">-</div>
                    <Input
                      style="width: 60px"
                      placeholder=""
                      validator="positiveInteger,4"
                      :inputValue.sync="contactDetails['nomineeNRIC3']"
                      :errorMessage.sync="nomNRICError3"
                      :isRequired="true"
                      :isDisabled="viewMode"
                    />
                  </div>
                  <Input
                    placeholder="Percentage"
                    :inputValue.sync="contactDetails['nomineePercentage']"
                    validator="decimal,18,4"
                    :errorMessage.sync="nomPercentageError"
                    ref="nomineePercentage"
                    :isDisabled="viewMode"
                    textAlign="right"
                  />
                </div>
                <div>
                  <Input
                    placeholder="Relationship"
                    :inputValue.sync="contactDetails['nomineeRelationship']"
                    validator="text,20"
                    :errorMessage.sync="nomRelationshipError"
                    :isDisabled="viewMode"
                  />
                </div>
              </div>
            </BoxContainer>
          </div>
        </div>
        <!-- Employment History -->
        <div
          slot="Employment History"
          class="slotWithTableBox"
          style="flex-direction: row; display: flex; width: 100%; height: 100%"
        >
          <div class="divWithTableBox" :style="{ width: showDetails ? '50%' : '100%' }">
            <div v-if="!viewMode" style="display: flex">
              <button :disabled="viewBtn" @click="addEmployment">Add</button>
              <button :disabled="viewBtn" @click="deleteEmpClicked" style="margin-left: 5px">Delete</button>
            </div>
            <TableBox
              title="Employment History"
              style="height: calc(100% - 57px)"
              :additionalButtons="viewMode ? [] : editButtons"
              :tableData="employmentList"
              :selectedRow.sync="selectedEmployment"
              :maxSelection="-1"
              :hideColumns="['Action', 'Sequence No', 'ID']"
              @buttonClicked="editEmploymentButtonClicked"
            />
          </div>

          <div v-if="showDetails" :style="{ marginLeft: '5px', width: showDetails ? '50%' : '0' }">
            <div style="display: flex; justify-content: flex-end; margin-bottom: 5px">
              <button :disabled="viewBtn" @click="clearDetails('employment history')" class="clear-all-button"
                >Clear</button
              >
              <button :disabled="viewBtn" @click="saveEmployment" class="save-button" style="margin-left: 5px"
                >Save
              </button>
              <button :disabled="viewBtn" @click="showDetails = false" style="margin-left: 5px" class="cancel-button"
                >Cancel</button
              >
            </div>
            <Input
              placeholder="Company Name"
              :inputValue.sync="employmentHistory['companyName']"
              :errorMessage.sync="companyNameError"
              :isDisabled="viewMode"
              :isRequired="true"
              validator="text,30"
            />
            <Input
              placeholder="Company Phone No."
              :inputValue.sync="employmentHistory['phoneNo']"
              :errorMessage.sync="phoneNoError"
              :isDisabled="viewMode"
              validator="text,20"
            />
            <Input
              placeholder="Posititon Held"
              :inputValue.sync="employmentHistory['position']"
              :errorMessage.sync="positionError"
              :isDisabled="viewMode"
              :isRequired="true"
              validator="text,20"
            />
            <div style="display: flex; width: 100%">
              <DateTimePicker
                style="width: 50%"
                placeholder="Date Joined"
                :value.sync="employmentHistory['dateJoined']"
                :errorMessage.sync="eDateJoinedError"
                :isRequired="true"
                :isDisabled="viewMode"
                :showTime="false"
              />
              <DateTimePicker
                style="width: 50%"
                placeholder="Date Left"
                :value.sync="employmentHistory['dateLeft']"
                :errorMessage.sync="eDateLeftError"
                :isRequired="true"
                :isDisabled="viewMode"
                :showTime="false"
              />
            </div>
            <RemarksBox
              style="height: 20%"
              title="Job Responsibilities"
              :freeText="true"
              :text.sync="employmentHistory['responsibilities']"
              :errorMessage.sync="responsibilitiesError"
              :isDisabled="viewMode"
              validator="text,300"
            />
            <Input
              placeholder="Reason For Leaving"
              :inputValue.sync="employmentHistory['reasonForLeaving']"
              :errorMessage.sync="reasonForLeavingError"
              :isDisabled="viewMode"
              validator="text,100"
            />
            <RemarksBox
              style="height: 20%"
              title="Remarks"
              :freeText="true"
              :text.sync="employmentHistory['remarks']"
              :errorMessage.sync="remarksError"
              :isDisabled="viewMode"
              validator="text,100"
            />
          </div>
        </div>
        <!-- Documents -->
        <div
          slot="Documents"
          class="slotWithTableBox"
          style="flex-direction: row; display: flex; width: 100%; height: 100%"
        >
          <div class="divWithTableBox" :style="{ width: showDocDetails ? '50%' : '100%' }">
            <div v-if="!viewMode" style="display: flex">
              <button :disabled="viewBtn" @click="addDocument">Add</button>
              <button :disabled="viewBtn" @click="deleteDocClicked" style="margin-left: 5px">Delete</button>
            </div>
            <TableBox
              title="Documents"
              style="height: calc(100% - 57px)"
              :additionalButtons="viewMode ? [] : editButtons"
              :tableData="documentsList"
              :selectedRow.sync="selectedDoc"
              :maxSelection="-1"
              :hideColumns="['Action', 'Attachment File', 'Sequence No', 'Document GUID', 'ID']"
              @buttonClicked="editDocButtonClicked"
            />
          </div>

          <div v-if="showDocDetails" :style="{ marginLeft: '5px', width: showDocDetails ? '50%' : '0' }">
            <div style="display: flex; justify-content: flex-end; margin-bottom: 5px">
              <button :disabled="viewBtn" @click="clearDetails('documents')" class="clear-all-button">Clear</button>
              <button :disabled="viewBtn" @click="saveDocument" class="save-button" style="margin-left: 5px"
                >Save</button
              >
              <button :disabled="viewBtn" @click="showDocDetails = false" class="cancel-button">Cancel</button>
            </div>
            <div style="display: flex; justify-content: flex-end; margin-bottom: 5px">
              <DateTimePicker
                style="width: 50%"
                placeholder="Date Received"
                :value.sync="documents['dateReceived']"
                :isDisabled="viewMode"
                :showTime="false"
              />
              <DateTimePicker
                style="margin-left: 25px; width: 50%"
                placeholder="Expiry Date"
                :value.sync="documents['expiryDate']"
                :isDisabled="viewMode"
                :showTime="false"
              />
            </div>
            <InputQuery
              placeholder="Doc Code"
              :items="getDocData['docCode']"
              :errorMessage.sync="docCodeError"
              itemKey="Doc Code"
              descKey="Description"
              :selectedObject.sync="documents['docCode']"
              :isDisabled="viewMode"
              :isRequired="true"
            />
            <InputQuery
              placeholder="Doc Type"
              :items="getDocData['docType']"
              :errorMessage.sync="docTypeError"
              itemKey="Doc Type"
              descKey="Description"
              :selectedObject.sync="documents['docType']"
              :isDisabled="viewMode"
              :isRequired="true"
            />
            <div style="display: flex">
              <Input
                style="width: 50%"
                placeholder="Reference No."
                :inputValue.sync="documents['refNo']"
                :errorMessage.sync="refNoError"
                :isDisabled="viewMode"
                :isRequired="true"
              />
              <DateTimePicker
                style="margin-left: 32px; width: 50%"
                placeholder="Doc Date"
                :value.sync="documents['docDate']"
                :isDisabled="viewMode"
                :showTime="false"
              />
            </div>
            <Input
              textType="file"
              placeholder="Select File"
              id="docFile"
              ref="docInput"
              :inputValue.sync="documents['docName']"
              :isDisabled="viewMode"
              @fileChanged="handleFileUpload"
            />
            <!--**************8-->
            <div v-if="docEditMode">
              <div> Attachment: {{ documents['docName'] }} </div>
            </div>
            <RemarksBox
              style="height: 50%"
              title="Remarks"
              :text.sync="documents['remarks']"
              :errorMessage.sync="dRemarksError"
              :maxLength="200"
              :isDisabled="viewMode"
            />
          </div>
        </div>
        <!-- Family Details -->
        <div slot="Family Details" style="height: calc(100% - 83px)">
          <BoxContainer title="Number  of children" style="flex-direction: row">
            <Input
              style="width: 50%; margin-right: 5px"
              placeholder="No. of Children"
              :errorMessage.sync="noOfChildrenError"
              validator="positiveInteger,2"
              ref="noOfChildren"
              :inputValue.sync="familyDetails['noOfChildren']"
              :isDisabled="viewMode"
            />
            <Input
              style="width: 50%"
              placeholder="No. of Children for Tax Rebate"
              :errorMessage.sync="noOfChildrenForTaxRebateError"
              validator="positiveInteger,2"
              ref="noOfChildrenForTaxRebate"
              :inputValue.sync="familyDetails['noOfChildrenForTaxRebate']"
              :isDisabled="viewMode"
            />
          </BoxContainer>

          <BoxContainer title="Kin Details" style="flex-direction: row; width: 100%; height: 100%">
            <div class="divWithTableBox" :style="{ width: showFamilyDetails ? '50%' : '100%' }">
              <div v-if="!viewMode" style="display: flex">
                <button :disabled="viewBtn" @click="addFamilyDetail">Add</button>
                <button :disabled="viewBtn" @click="deleteFamilyClicked" style="margin-left: 5px">Delete</button>
              </div>
              <TableBox
                title="Kin Profile"
                style="height: calc(100% - 57px)"
                :additionalButtons="viewMode ? [] : editButtons"
                :tableData="familyDetList"
                :selectedRow.sync="selectedFamilyDet"
                :maxSelection="-1"
                :hideColumns="['Action', 'Kin ID']"
                @buttonClicked="editFamilyButtonClicked"
              />
            </div>
            <div v-if="showFamilyDetails" :style="{ marginLeft: '5px', width: showFamilyDetails ? '50%' : '0' }">
              <div style="display: flex">
                <button :disabled="viewBtn" @click="clearDetails('family details')" class="clear-all-button"
                  >Clear</button
                >
                <button :disabled="viewBtn" @click="saveFamily" class="save-button" style="margin-left: 5px"
                  >Save</button
                >
                <button :disabled="viewBtn" @click="showFamilyDetails = false" class="cancel-button">Cancel</button>
              </div>
              <Input
                placeholder="Name"
                validator="text,50,"
                :inputValue.sync="familyDetails['kinName']"
                :errorMessage.sync="famNameError"
                :isDisabled="viewMode"
                :isRequired="true"
              />
              <div style="display: flex; flex-direction: row">
                <div style="margin-right: 3px; align-self: center">NRIC: </div>
                <Input
                  style="width: 70px"
                  placeholder=""
                  validator="positiveInteger,6"
                  :inputValue.sync="familyDetails['kinNric1']"
                  :errorMessage.sync="famNRICError1"
                  :isRequired="true"
                  :isDisabled="viewMode"
                />
                <div style="align-self: center">-</div>
                <Input
                  style="width: 50px"
                  placeholder=""
                  validator="positiveInteger,2"
                  :inputValue.sync="familyDetails['kinNric2']"
                  :errorMessage.sync="famNRICError2"
                  :isRequired="true"
                  :isDisabled="viewMode"
                />
                <div style="align-self: center">-</div>
                <Input
                  style="width: 60px"
                  placeholder=""
                  validator="positiveInteger,4"
                  :inputValue.sync="familyDetails['kinNric3']"
                  :errorMessage.sync="famNRICError3"
                  :isRequired="true"
                  :isDisabled="viewMode"
                />
              </div>
              <InputQuery
                placeholder="Relationship"
                :items="familyDetailsData['kinRelationship']"
                itemKey="Relationship"
                :selectedObject.sync="familyDetails['kinRelationship']"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="Tel No."
                validator="text,20"
                :inputValue.sync="familyDetails['kinTel']"
                :errorMessage.sync="famTelError"
                :isDisabled="viewMode"
              />

              <Input
                placeholder="Mobile No."
                validator="text,20"
                :inputValue.sync="familyDetails['kinMobile']"
                :errorMessage.sync="famMobileError"
                :isDisabled="viewMode"
              />

              <InputQuery
                placeholder="Gender"
                :items="familyDetailsData['kinGender']"
                itemKey="Gender"
                :selectedObject.sync="familyDetails['kinGender']"
                :isDisabled="viewMode"
              />

              <DateTimePicker
                placeholder="Date of Birth"
                :value.sync="familyDetails['kindob']"
                :isDisabled="viewMode"
                :showTime="false"
                :maxDate="new Date()"
              />
              <Input
                placeholder="Birth Certificate No."
                validator="text,14"
                :inputValue.sync="familyDetails['kinBirthCertNo']"
                :errorMessage.sync="famBirthCertNoError"
                :isDisabled="viewMode"
              />
              <div class="checkbox-container">
                <div class="checkbox-content">
                  <CheckBox
                    :isDisabled="viewMode"
                    style="margin: 8px 5px 8px 0"
                    title="Working"
                    @checkBoxClicked="checkBoxClicked('Working')"
                    :isChecked.sync="familyDetails['kinIsWorkingCB']"
                  />
                  <CheckBox
                    :isDisabled="viewMode"
                    style="margin: 8px 5px"
                    title="Disabled"
                    @checkBoxClicked="checkBoxClicked('Disabled')"
                    :isChecked.sync="familyDetails['kinIsDisabledCB']"
                  />
                  <CheckBox
                    :isDisabled="viewMode"
                    style="margin: 8px 5px"
                    title="Living Together"
                    @checkBoxClicked="checkBoxClicked('Living Together')"
                    :isChecked.sync="familyDetails['kinIsLivingTgtCB']"
                  />
                  <CheckBox
                    :isDisabled="viewMode"
                    style="margin: 8px 0 8px 5px"
                    title="Emergency Contact"
                    @checkBoxClicked="checkBoxClicked('Emergency Contact')"
                    :isChecked.sync="familyDetails['kinIsEmergencyContactCB']"
                  />
                  <CheckBox
                    :isDisabled="viewMode"
                    style="margin: 8px 0 8px 5px"
                    title="Diploma/Degree Level"
                    @checkBoxClicked="checkBoxClicked('Diploma/Degree Level')"
                    :isChecked.sync="familyDetails['kinIsEducatedCB']"
                  />
                </div>
              </div>
            </div>
          </BoxContainer>
        </div>
        <!-- Career -->
        <div slot="Career" class="slotWithTableBox">
          <BoxContainer title="Career">
            <div>
              <InputQuery
                placeholder="Grade"
                :items="careerData['grade']"
                itemKey="Grade Type"
                descKey="Grade Description"
                :selectedObject.sync="grade"
                :isDisabled="viewModeCareer"
              />
              <Input
                placeholder="Gross Salary (RM)"
                ref="grossSalary"
                validator="decimal,14,4"
                :errorMessage.sync="grossSalaryError"
                :inputValue.sync="grossSalary"
                :isDisabled="viewModeCareer"
              />
            </div>
            <div>
              <RemarksBox
                style="height: 50%"
                title="Qualification"
                :maxLength="200"
                ref="qualification"
                :errorMessage.sync="qualificationError"
                :text.sync="qualification"
                :isDisabled="viewMode"
              />
            </div>
          </BoxContainer>
          <BoxContainer title="Career History" style="flex-direction: row; width: 100%; height: 100%">
            <div class="divWithTableBox" :style="{ width: showCareer ? '50%' : '100%' }">
              <div v-if="!viewMode" style="display: flex">
                <button :disabled="true" @click="addCareer">Add</button>
                <button :disabled="viewBtn" @click="deleteCareerClicked" style="margin-left: 5px">Delete</button>
              </div>
              <TableBox
                title="Career History"
                style="height: calc(100% - 57px)"
                :additionalButtons="viewMode ? [] : editButtons"
                :tableData="careerList"
                :selectedRow.sync="selectedcareer"
                :maxSelection="-1"
                :hideColumns="['career_action', 'Sequence No']"
                @buttonClicked="editCareerButtonClicked"
              />
            </div>
            <div v-if="showCareer" :style="{ marginLeft: '5px', width: showCareer ? '50%' : '0' }">
              <div style="display: flex">
                <button :disabled="viewBtn" @click="clearDetails('career')" class="clear-all-button">Clear</button>
                <button :disabled="viewBtn" @click="saveCareer" class="save-button" style="margin-left: 5px"
                  >Save</button
                >
                <button :disabled="viewBtn" @click="showCareer = false" class="cancel-button">Cancel</button>
              </div>
              <Input placeholder="Code" :inputValue.sync="career['code']" :isDisabled="true" />
              <Input placeholder="Remarks" :inputValue.sync="career['remarks']" :isDisabled="true" />
              <Input placeholder="Notes" :inputValue.sync="career['notes']" :isDisabled="viewMode" />
              <DateTimePicker
                placeholder="Effective Date"
                :value.sync="career['effectiveDate']"
                :isDisabled="viewMode"
                :showTime="false"
              />
            </div>
          </BoxContainer>
        </div>
        <!-- Education -->
        <div
          slot="Education"
          class="slotWithTableBox"
          style="flex-direction: row; display: flex; width: 100%; height: 100%"
        >
          <div class="divWithTableBox" :style="{ width: showEducation ? '50%' : '100%' }">
            <div v-if="!viewMode" style="display: flex">
              <button :disabled="viewBtn" @click="addEducation">Add</button>
              <button :disabled="viewBtn" @click="deleteEduClicked" style="margin-left: 5px">Delete</button>
            </div>
            <TableBox
              title="Education History"
              style="height: calc(100% - 57px)"
              :additionalButtons="viewMode ? [] : editButtons"
              :tableData="educationList"
              :selectedRow.sync="selectedEducation"
              :maxSelection="-1"
              :hideColumns="['Action', 'Sequence No', 'ID']"
              @buttonClicked="editEduButtonClicked"
            />
          </div>
          <div v-if="showEducation" :style="{ marginLeft: '5px', width: showEducation ? '50%' : '0' }">
            <div style="display: flex">
              <button :disabled="viewBtn" @click="clearDetails('education')" class="clear-all-button">Clear</button>
              <button :disabled="viewBtn" @click="saveEducation" class="save-button" style="margin-left: 5px"
                >Save</button
              >
              <button :disabled="viewBtn" @click="showEducation = false" class="cancel-button">Cancel</button>
            </div>
            <Input
              class="content-1-column"
              placeholder="Company Code"
              :errorMessage.sync="companyCodeError"
              :inputValue.sync="education['companyCode']"
              :isDisabled="viewMode"
            />
            <Input
              placeholder="Institute Name"
              :errorMessage.sync="instituteNameError"
              :inputValue.sync="education['instituteName']"
              :isDisabled="viewMode"
              :isRequired="true"
            />

            <InputQuery
              placeholder="Institute Category"
              :errorMessage.sync="instituteCategoryError"
              :items="educationData['instituteCategory']"
              itemKey="Institute Category"
              :selectedObject.sync="education['instituteCategory']"
              :isDisabled="viewMode"
              :isRequired="true"
            />

            <InputQuery
              placeholder="Country"
              :errorMessage.sync="countryError"
              :items="educationData['country']"
              itemKey="Country Code"
              descKey="Country"
              :selectedObject.sync="education['country']"
              :isDisabled="viewMode"
              :isRequired="true"
            />

            <InputQuery
              placeholder="Qualification"
              :items="educationData['qualification']"
              itemKey="Qualification"
              :selectedObject.sync="education['qualification']"
              :isDisabled="viewMode"
            />

            <div style="display: flex; width: 100%">
              <DateTimePicker
                style="margin-right: 5px"
                placeholder="From"
                :errorMessage.sync="fromError"
                :value.sync="education['from']"
                :isDisabled="viewMode"
                :showTime="false"
                :isRequired="true"
              />
              <DateTimePicker
                placeholder="To"
                :errorMessage.sync="toError"
                :value.sync="education['to']"
                :isDisabled="viewMode"
                :showTime="false"
                :isRequired="true"
              />
            </div>
            <DateTimePicker
              placeholder="Year of Graduate"
              :errorMessage.sync="graduateError"
              :value.sync="education['graduateYear']"
              :isDisabled="viewMode"
              :showTime="false"
              :isRequired="true"
            />
            <Input
              placeholder="Grade"
              :errorMessage.sync="gradeError"
              :inputValue.sync="education['grade']"
              :isDisabled="viewMode"
            />
            <Input
              placeholder="Major"
              :errorMessage.sync="majorError"
              :inputValue.sync="education['major']"
              :isDisabled="viewMode"
            />
            <RemarksBox
              style="height: 25%"
              title="Remarks"
              :freeText="true"
              :errorMessage.sync="eRemarksError"
              :text.sync="education['remarks']"
              :isDisabled="viewMode"
            />
          </div>
        </div>
      </Tab>
    </PopupEntry>

    <PopupV2
      :show="showDeletePopup"
      title="Delete Employee"
      @buttonClicked="deletePopupButtonClicked"
      :buttons="deletePopupButtons"
    >
      <div
        >Are you sure you want to delete Employee
        {{ selectedEmp.length > 0 ? selectedEmp[0]['Employee ID'] : '' }}?</div
      >
    </PopupV2>

    <!-- <PopupV2 :show="showDeletePopup" title="Edit Terminated Employee" @buttonClicked="terminateButtonClicked" :buttons="deletePopupButtons">
      <div>This Employee already Terminated. Are you sure to edit the employee {{ selectedEmp.length > 0 ? selectedEmp[0]['Employee ID'] : '' }}?</div>
    </PopupV2 > -->

    <PopupV2
      :show="showDeleteCareerPopupWithRemarks"
      title="Delete Career History"
      @buttonClicked="deleteCareerPopupClicked"
      :buttons="deletePopupButtons"
    >
      <div>Please state reason to delete {{ selectedcareer.length > 0 ? selectedcareer[0]['Career ID'] : '' }}?</div>
      <Input
        placeholder="Delete Remarks"
        :inputValue.sync="career['deleteRemarks']"
        :errorMessage.sync="deleteRemarksError"
        :isRequired="true"
      />
    </PopupV2>

    <PopupV2
      :show="showDeleteEduPopupWithRemarks"
      title="Delete Education History"
      @buttonClicked="deleteEduPopupClicked"
      :buttons="deletePopupButtons"
    >
      <div>Please state reason to delete {{ selectedEducation.length > 0 ? selectedEducation[0]['seqNo'] : '' }}?</div>
      <Input
        placeholder="Delete Remarks"
        :inputValue.sync="education['deleteRemarks']"
        :errorMessage.sync="deleteRemarksError"
        :isRequired="true"
      />
    </PopupV2>

    <PopupV2
      :show="showTerminatePopup"
      icon="https://dsmlib.logistics.systems/Icons/terminate-employee.png"
      title="Terminate Employee"
      :buttons="terminatePopupButtons"
      :isFullScreen="true"
      @buttonClicked="terminateButtonClicked"
      width="500px"
    >
      <!-- <div style="text-align: left"> -->
      <DateTimePicker
        ref="terminateDateTimePicker"
        :value.sync="terminateDate"
        placeholder="Terminate Date"
        :errorMessage.sync="terminateDateError"
        :isRequired="true"
        :showTime="false"
      />
      <InputQuery
        itemKey="Type"
        descKey="Type Description"
        :items="terminateType"
        placeholder="Terminate Type"
        :selectedObject.sync="selectedTerminateType"
        :isDisabled="false"
        :errorMessage.sync="terminateTypeError"
        :isRequired="true"
      />
      <RemarksBox title="Terminate Remarks" :text.sync="terminateRemarksText" :maxLength="200" />
      <!-- </div> -->
    </PopupV2>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      //#region TerminatePopup
      terminateEmployeeNo: '',
      showTerminatePopup: false,
      terminatePopupButtons: [
        { color: 'lightgreen', text: 'Ok' },
        { color: 'IndianRed', text: 'Cancel' },
      ],
      // DateTimePicker
      terminateDate: null,
      terminateDateError: '',

      // InputQuery
      terminateTypeError: '',
      selectedTerminateType: null,

      //RemarksBox
      terminateRemarksText: '',
      //#endregion
      //#region General
      showDeletePopup: false,
      showDeleteCareerPopupWithRemarks: false,
      showDeleteEduPopupWithRemarks: false,
      menus: [
        {
          title: 'New Employee',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Employee',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
        {
          title: 'Delete Employee',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: false,
        },
        {
          title: 'View Employee',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },
        {
          title: 'New Duplicate',
          icon: 'https://dsmlib.logistics.systems/Icons/copy-80px.png',
          key: 'MnuDuplicate',
          visible: true,
          enabled: false,
        },
        {
          title: 'Terminate Employee',
          icon: 'https://dsmlib.logistics.systems/Icons/terminate-employee.png',
          key: 'MnuTerminate',
          visible: true,
          enabled: false,
        },
      ],

      statusField: false,

      empLoading: false,
      empList: [],
      selectedEmp: [],
      deleteRemarksError: '',
      deleteRemarks: '',
      deletePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      viewModeCareer: false,
      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],

      empNoError: '',
      empNameError: '',
      statusError: '',
      nationalityError: '',
      nricNewError1: '',
      nricNewError2: '',
      nricNewError3: '',
      employmentTypeError: '',
      genderError: '',
      raceError: '',
      deptError: '',
      jobTitleError: '',
      dateofbirthError: '',
      dateJoinedError: '',
      dateConfirmedError: '',
      branchError: '',
      drivingLicenseNoError: '',
      expirydatedlError: '',
      drivingClassError: '',
      badgeLicenseNoError: '',
      expirydateblError: '',
      portPassNoError: '',
      portPassExpiryError: '',
      commisionCodeError: '',
      payrollAccNoError: '',
      pobError: '',
      nricOldError: '',
      spouseNameError: '',
      totalWorkingHrsError: '',
      incomeTaxNoError: '',
      epfNoError: '',
      socsoNoError: '',
      noOfChildrenError: '',
      noOfChildrenForTaxRebateError: '',

      companyNameError: '',
      phoneNoError: '',
      positionError: '',
      responsibilitiesError: '',
      reasonForLeavingError: '',
      remarksError: '',
      eDateJoinedError: '',
      eDateLeftError: '',

      docCodeError: '',
      docTypeError: '',
      refNoError: '',
      dRemarksError: '',

      nomNameError: '',
      nomNRICError1: '',
      nomNRICError2: '',
      nomNRICError3: '',
      nomPercentageError: '',
      nomineeTypeError: '',
      nomRelationshipError: '',

      famNameError: '',
      famNRICError1: '',
      famNRICError2: '',
      famNRICError3: '',
      famTelError: '',
      famMobileError: '',
      famBirthCertNoError: '',

      grossSalaryError: '',
      qualificationError: '',

      companyCodeError: '',
      instituteNameError: '',
      instituteCategoryError: '',
      countryError: '',
      fromError: '',
      toError: '',
      graduateError: '',
      gradeError: '',
      majorError: '',
      eRemarksError: '',

      totalWorkingHrsRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false,
      },

      empNo: '',
      action: '',
      terminationStatusIsDisable: false,
      lastUpdate: '',

      tabsItems: [
        { title: 'Quick Entry', disabled: false },
        { title: 'General Details', disabled: false },
        { title: 'Other Details', disabled: false },
        { title: 'Contact Details', disabled: false },
        { title: 'Employment History', disabled: false },
        { title: 'Documents', disabled: false },
        { title: 'Family Details', disabled: false },
        { title: 'Career', disabled: false },
        { title: 'Education', disabled: false },
      ],
      currentTab: 0,
      refToTabIndex: {
        employeeno: -1,
        employeename: 0,
        nationality: 0,
        nricnew: 0,
        gender: 0,
        race: 0,
        department: 0,
        jobtitle: 0,
        drivingClass: 0,
        commisionCode: 0,
        employmentTypeError: 0,
        dateofbirth: 1,
        dateJoined: 1,
        status: 1,
        pob: 1,
        nricOld: 1,
        spouseError: 1,
        totalWorkingHrs: 2,
        portPassNo: 2,
        payrollAccNo: 2,
        defaultAddr1: 3,
        defaultAddr2: 3,
        defaultAddr3: 3,
        defaultAddr4: 3,
        defaultCity: 3,
        defaultPhone: 3,
        defaultMobile: 3,
        defaultEmail1: 3,
        defaultEmail2: 3,
        postalAddr1: 3,
        postalAddr2: 3,
        postalAddr3: 3,
        postalAddr4: 3,
        postalCity: 3,
        postalPhone: 3,
        postalMobile: 3,
        postalEmail1: 3,
        postalEmail2: 3,
        kinName: 3,
        kinRelationship: 3,
        kinAddr1: 3,
        kinAddr2: 3,
        kinAddr3: 3,
        kinAddr4: 3,
        kinCity: 3,
        kinPhone: 3,
        noOfChildren: 6,
        noOfChildrenForTaxRebate: 6,
        grossSalary: 7,
        qualification: 7,
      },
      //#endregion
      // #region General Details data
      viewBtn: false,

      genDetails: {
        empName: '',
        employeeImage: null,
        employeeImage64: null,
        employeeImageID: '',
        employeeImageAction: '',
        status: '',
        nationality: null,
        disablecheck: false,
        nricNew: '',
        nricNew1: '',
        nricNew2: '',
        nricNew3: '',
        nricOld: '',
        pob: '',
        dateofbirth: null,
        age: '',
        gender: null,
        religion: null,
        race: null,
        ethnicity: null,
        maritalStat: null,
        spouseName: '',
        dateJoined: null,
        dateLeft: null,
        dateConfirmed: null,
        employmentDur: '',
      },
      genDetailsData: {
        nationality: [],
        gender: [],
        religion: [],
        race: [],
        ethnicity: [],
        maritalStat: [],
      },
      // #endregion

      // #region Other Details data
      cashChecked: false,
      chequeChecked: false,
      newAttachments: [],
      otherDetails: {
        employmentType: null,
        contractStart: null,
        contractEnd: null,
        branch: null,
        dept: null,
        jobTitle: '',
        superior: null,
        shift: null,
        totalWorkingHrs: '',
        incomeTaxNo: '',
        epfNo: '',
        socsoNo: '',
        incomeTaxCategory: null,
        epfCategory: null,
        socsoCategory: null,
        skbbkCategory: null,

        drivingLicenseNo: '',
        expirydatedl: null,
        drivingClass: [],
        badgeLicenseNo: '',
        expirydatebl: null,
        portPassNo: '',
        expirydatepp: null,
        commisionCode: null,
        payrollTypes: '',
        payrollAccNo: '',
        otFormula: null,
      },
      otherDetailsData: {
        employmentType: [],
        branch: [],
        dept: [],
        superior: [],
        shift: [],
        incomeTaxCategory: [],
        epfCategory: [],
        socsoCategory: [],
        skbbkCategory: [], //Using another list for readability and separation
        // employeeImage:[],
        drivingClass: [],
        commisionCode: [],
        payrollTypes: [],
        payrollBank: [],
        otFormula: [],
      },
      // #endregion

      // #region Contact Details data
      defaultChecked: true,
      postalChecked: false,
      sameDefaultPostalChecked: false,

      showNomineeDetails: false,

      nomEditIndex: -1,
      nomineeList: [],
      deletedNomineeList: [],
      selectedNominee: [],
      contactDetails: {
        defaultAddressData: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
        },
        defaultAddressErrors: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
        },
        defaultPhone: '',
        defaultPhoneError: '',
        defaultMobile: '',
        defaultMobileError: '',
        defaultEmail1: '',
        defaultEmail1Error: '',
        defaultEmail2: '',
        defaultEmail2Error: '',

        postalAddressData: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
        },
        postalAddressErrors: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
        },
        postalPhone: '',
        postalPhoneError: '',
        postalMobile: '',
        postalMobileError: '',
        postalEmail1: '',
        postalEmail1Error: '',
        postalEmail2: '',
        postalEmail2Error: '',

        kinName: '',
        kinNameError: '',
        kinRelationship: '',
        kinRelationshipError: '',
        kinAddressData: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
        },
        kinAddressErrors: {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
        },
        kinPhone: '',
        kinPhoneError: '',

        showNominee: false,
        nomineeName: '',
        nomineeNRIC1: '',
        nomineeNRIC2: '',
        nomineeNRIC3: '',
        nomineeType: null,
        nomineePercentage: '',

        nomineeRelationship: '',
      },
      contactDetailsData: {
        nomineeType: [],
      },
      // #endregion

      // #region Employment History data

      editButtons: [{ text: 'Edit', index: 0, width: 60 }],
      empEditIndex: -1,
      employmentList: [],
      deletedEmploymentList: [],
      selectedEmployment: [],
      showDetails: false,

      employmentHistory: {
        seqNo: '',
        companyName: '',
        phoneNo: '',
        position: '',
        responsibilities: '',
        reasonForLeaving: '',
        remarks: '',
        dateJoined: '',
        dateLeft: '',
        //temporary id
        empID: '',
      },

      // #endregion

      // #region Documents data
      docEditMode: false,
      showDocDetails: false,
      docEditIndex: -1,
      documentsList: [],
      deletedDocumentsList: [],
      selectedDoc: [],
      documents: {
        dateReceived: '',
        docCode: null,
        refNo: '',
        expiryDate: '',
        docType: null,
        docDate: '',
        docName: '',
        remarks: '',
        timeReceive: '',
        docGuid: '',
        filetype: '',
        attachmentFile: [],
        //temporary id
        docID: '',
      },
      getDocData: {
        docCode: [],
        docType: [],
      },
      // #endregion

      // #region Family Details dat
      familyDetEditIndex: -1,
      familyDetList: [],
      deletedFamilyDetList: [],
      selectedFamilyDet: [],
      showFamilyDetails: false,

      familyDetails: {
        noOfChildren: '',
        noOfChildrenForTaxRebate: '',
        kinName: '',
        kinNric: '',
        kinNric1: '',
        kinNric2: '',
        kinNric3: '',
        kinRelationship: null,
        kinGender: null,
        kinTel: '',
        kinMobile: '',
        kindob: '',
        kinBirthCertNo: '',
        kinIsWorking: '',
        kinIsDisabled: '',
        kinIsLivingTgt: '',
        kinIsEmergencyContact: '',
        kinIsWorkingCB: false,
        kinIsDisabledCB: false,
        kinIsLivingTgtCB: false,
        kinIsEmergencyContactCB: false,
        kinIsEducatedCB: false,
        kinIsEducated: false,
        seqNo: '',
      },
      familyDetailsData: {
        kinRelationship: [],
        kinGender: [],
      },
      // #endregion

      // #region Career data
      careerEditIndex: -1,
      careerList: [],
      deletedCareerList: [],
      selectedcareer: [],
      showCareer: false,
      grade: null,
      grossSalary: '',
      qualification: '',
      career: {
        seqNo: '',
        effectiveDate: '',
        code: '',
        remarks: '',
        notes: '',
        dateUpdate: '',
        userID: '',
        deleteRemarks: '',
      },
      careerData: {
        grade: [],
      },
      // #endregion

      // #region Education data
      educationEditIndex: -1,
      educationList: [],
      deletedEducationList: [],
      selectedEducation: [],
      showEducation: false,

      education: {
        companyCode: '',
        instituteName: '',
        instituteCategory: null,
        country: null,
        qualification: null,
        from: null,
        to: null,
        graduateYear: null,
        grade: '',
        major: '',
        remarks: '',
        seqNo: '',
        deleteRemarks: '',
      },
      educationData: {
        instituteCategory: [],
        country: [],
        qualification: [],
      },
      // #endregion

      terminateType: [],

      //LHDN eInvoice Details section (TIN)
      validateTINIcon: '',
      validateTINMsg: 'Not Validated',
      eInvoiceTIN: '',
    };
  },
  computed: {
    ageValue: function () {
      if (!this.genDetails['dateofbirth']) {
        return '';
      }

      // var age  = new Date().getFullYear() - this.genDetails['dateofbirth'].getFullYear();
      // var m = new Date().getMonth() - this.genDetails['dateofbirth'].getMonth();

      // if (m < 0 || (m === 0 && new Date().getDate() < this.genDetails['dateofbirth'].getDate())){
      //   age --;
      // }

      // return `${age}`;

      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      const utc1 = Date.UTC(
        this.genDetails['dateofbirth'].getFullYear(),
        this.genDetails['dateofbirth'].getMonth(),
        this.genDetails['dateofbirth'].getDate(),
      );
      const utc2 = Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

      const numOfDays = Math.floor((utc2 - utc1) / _MS_PER_DAY);

      const years = Math.floor(numOfDays / 365);
      const months = Math.floor((numOfDays % 365) / 30);
      const days = Math.floor((numOfDays % 365) % 30);

      const result = `${years} years ${months} months ${days} days`;
      return `${result}`;
    },
    employmentValue: function () {
      if (!this.genDetails['dateJoined']) {
        return '';
      }

      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      const utc1 = Date.UTC(
        this.genDetails['dateJoined'].getFullYear(),
        this.genDetails['dateJoined'].getMonth(),
        this.genDetails['dateJoined'].getDate(),
      );
      const utc2 = Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

      const numOfDays = Math.floor((utc2 - utc1) / _MS_PER_DAY);

      const years = Math.floor(numOfDays / 365);
      const months = Math.floor((numOfDays % 365) / 30);
      const days = Math.floor((numOfDays % 365) % 30);

      const result = `${years} years ${months} months ${days} days`;
      return `${result}`;
    },
    dynamicRequired() {
      const { dept } = this.otherDetails || {};
      return dept?.['LicenseInfoCompulsory'].trim() == '1' ?? false;
    },
  },
  watch: {
    cashChecked: function (val) {
      if (val) {
        this.chequeChecked = false;
      }
      if (!val && !this.chequeChecked) {
        this.$nextTick(() => {
          this.cashChecked = true;
        });
      }
    },
    chequeChecked: function (val) {
      if (val) {
        this.cashChecked = false;
      }
      if (!val && !this.cashChecked) {
        this.$nextTick(() => {
          this.cashChecked = true;
        });
      }
    },
    defaultChecked: function (val) {
      if (val) {
        this.sameDefaultPostalChecked = false;
      }
      if (!val && !this.postalChecked && !this.sameDefaultPostalChecked) {
        this.$nextTick(() => (this.defaultChecked = true));
      }
    },
    postalChecked: function (val) {
      if (val) {
        this.sameDefaultPostalChecked = false;
      }
      if (!val && !this.defaultChecked && !this.sameDefaultPostalChecked) {
        this.$nextTick(() => (this.defaultChecked = true));
      }
    },
    sameDefaultPostalChecked: function (val) {
      if (val) {
        this.defaultChecked = false;
        this.postalChecked = false;
      }

      if (!val && !this.postalChecked && !this.defaultChecked) {
        this.$nextTick(() => (this.defaultChecked = true));
      }
    },
    popupEntryShow: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        const closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Employee Creation',
          `You have not created an Employee profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },
    eInvoiceTIN: function () {
      this.validateTINIcon = '';
    },
    'genDetails.nricNew1': function() {
      this.validateTINIcon = '';
    },
    'genDetails.nricNew2': function() {
      this.validateTINIcon = '';
    },
    'genDetails.nricNew3': function() {
      this.validateTINIcon = '';
    },
  },
  methods: {
    terminateButtonClicked: async function (e) {
      switch (e) {
        case 'Ok': {
          if (!this.terminateDate) {
            this.terminateDateError = 'Terminate Date is required!';
            break;
          }
          const formattedDateTime = this.terminateDate.formatString('yyyy-MM-dd');
          if (formattedDateTime.length > 10) {
            this.terminateDateError = 'Invalid Date';
            break;
          }
          if (!this.selectedTerminateType) {
            this.terminateTypeError = 'Terminate Type is required!';
            break;
          }

          const filteredTerminateType = !this.selectedTerminateType ? '' : this.selectedTerminateType['Type'];
          const filteredRemarks = !this.terminateRemarksText ? '' : this.terminateRemarksText;

          const dataToTerminate = {
            employeeno: this.terminateEmployeeNo,
            terminatedate: formattedDateTime,
            terminatetype: filteredTerminateType,
            terminateremarks: filteredRemarks,
          };

          const result = await this.$apiCallV2(`/Employee/TerminateEmployee`, dataToTerminate);

          this.showTerminatePopup = false;

          if (!Array.isArray(result)) {
            this.$showAlert('error', 'An error occurred', 'Please try again later');
          } else if (result[0]['Results'] > 1) {
            this.$showAlert('error', 'An error occurred ', `${result[0]['ErrMsg']}`);
          } else if (result[0]['Results'] == 0) {
            this.$showAlert('success', 'Success', `Successful Termination ${result[0]['ErrMsg']}`);
            this.empList = [];
            this.$nextTick(async () => await this.getEmployees());
          }
          break;
        }
        case 'Cancel': {
          this.showTerminatePopup = false;
          this.empList = [];
          this.$nextTick(async () => await this.getEmployees());
          break;
        }
      }
    },
    //#region Nominee
    showNomineeButtonClicked: function () {
      this.showNomineeDetails = true;
      this.nomEditIndex = -1;
      this.clearDetails('nominee');
    },
    editNomineeButtonClicked: function (_btn, data) {
      if (this.viewMode) return;
      this.showNomineeDetails = true;
      this.nomEditIndex = this.nomineeList.map((n) => n['NRIC']).indexOf(data['NRIC']);
      this.populateNomineeEditData(data);
    },
    populateNomineeEditData: function (data) {
      this.contactDetails['nomineeName'] = data['Name'];
      const nric = data['NRIC'].split('-');
      this.contactDetails['nomineeNRIC1'] = nric[0];
      this.contactDetails['nomineeNRIC2'] = nric[1];
      this.contactDetails['nomineeNRIC3'] = nric[2];
      this.contactDetails['nomineePercentage'] = data['Percentage'];
      this.contactDetails['nomineeRelationship'] = data['Relationship'];
      this.contactDetails['nomineeType'] = this.contactDetailsData['nomineeType'].find((i) => {
        return i['#'].trim() == data['Type'];
      });
    },
    checkNomineeFields: function () {
      let error = false;
      if (!this.contactDetails['nomineeName'].trim()) {
        this.nomNameError = 'Nominee Name is required!';
        error = true;
      } else if (this.contactDetails['nomineeName'].length > 40) {
        this.nomNameError = 'Nominee Name cannot exceed 40 characters!';
        error = true;
        //This is for checking if there are any front or back spaces
      } else {
        if (!this.contactDetails['nomineeNRIC1']) {
          this.nomNRICError1 = 'IC No. is required!';
          error = true;
        } else if (this.contactDetails['nomineeNRIC1'].length != 6) {
          this.nomNRICError1 = 'Invalid IC No.!';
          error = true;
        }
        if (!this.contactDetails['nomineeNRIC2']) {
          this.nomNRICError2 = 'IC No. is required!';
          error = true;
        } else if (this.contactDetails['nomineeNRIC2'].length != 2) {
          this.nomNRICError2 = 'Invalid IC No.!';
          error = true;
        }
        if (!this.contactDetails['nomineeNRIC3']) {
          this.nomNRICError3 = 'IC No. is required!';
          error = true;
        } else if (this.contactDetails['nomineeNRIC3'].length < 4) {
          this.nomNRICError3 = 'Invalid IC No.!';
          error = true;
        }
      }
      if (this.contactDetails['nomineeType'] == null) {
        this.nomineeTypeError = 'Nominee Type is required!';
        error = true;
      }
      if (
        this.contactDetails['nomineePercentage'] &&
        !this.contactDetails['nomineePercentage'].match(/^\$?\d+(,\d{3})*(\.\d{1,4})?$/)
      ) {
        this.nomPercentageError = 'Invalid value or format! Please enter number only.';
        error = true;
      } else if (Number(this.contactDetails['nomineePercentage']) > 9000000000000000000) {
        this.nomPercentageError = 'Nominee Percentage value too big!';
        error = true;
      }
      if (this.contactDetails['nomineeRelationship'].length > 20) {
        this.nomRelationshipError = 'Nominee Relationship cannot exceed 20 characters!';
        error = true;
      }
      return error;
    },
    saveNominee: function () {
      if (this.viewMode) return;

      if (this.checkNomineeFields()) {
        return;
      }
      this.contactDetails['nomineeNRIC'] =
        `${this.contactDetails['nomineeNRIC1']}-${this.contactDetails['nomineeNRIC2'].length == 1 ? '0' + this.contactDetails['nomineeNRIC2'] : this.contactDetails['nomineeNRIC2']}-${this.contactDetails['nomineeNRIC3']}`;
      //Check for duplicate Nominee NRIC
      if (
        !(
          this.nomEditIndex > -1 &&
          this.contactDetails['nomineeNRIC'].trim() == this.nomineeList[this.nomEditIndex].NRIC.trim()
        )
      ) {
        for (const n of this.nomineeList) {
          if (this.contactDetails['nomineeNRIC'].trim() === n.NRIC.trim()) {
            this.$showAlert(
              'error',
              'Cannot Save Nominee Profile',
              'This nominee already exists. Please ensure the NRIC for each Nominee Profile is unique.',
            );
            return;
          }
        }
      }

      const temp = this.nomineeList;
      this.nomineeList = [];
      const nominee = {
        //Check for newly added rows, they do not have the key seqNo. If that's the case, set 'Action' to 'N'.
        Action: this.nomEditIndex > -1 ? 'E' : 'N',
        Name: !this.contactDetails['nomineeName'].trim() ? '' : this.contactDetails['nomineeName'].trim(),
        NRIC: !this.contactDetails['nomineeNRIC'] ? '' : this.contactDetails['nomineeNRIC'],
        Percentage: !this.contactDetails['nomineePercentage'] ? '' : this.contactDetails['nomineePercentage'],
        Relationship: !this.contactDetails['nomineeRelationship'] ? '' : this.contactDetails['nomineeRelationship'],
        Type: !this.contactDetails['nomineeType'] ? '' : this.contactDetails['nomineeType']['#'],
      };

      this.$nextTick(() => {
        if (this.nomEditIndex > -1) {
          temp.splice(this.nomEditIndex, 1, nominee);
        } else {
          temp.push(nominee);
        }
        this.nomineeList = temp;

        this.clearDetails('nominee');
        this.showNomineeDetails = false;
        this.nomEditIndex = -1;

        this.selectedNominee = [];
      });
    },
    deleteNomineeClicked: function () {
      if (this.selectedNominee.length == 0) {
        this.$showAlert('error', 'No Nominee Profile Selected', 'Please select at least 1 nominee profile to delete.');
      } else {
        const tempdeleted = this.deletedNomineeList;
        this.deletedNomineeList = [];

        for (const n of this.selectedNominee) {
          const nominee = {
            Action: 'D',
            Name: n['Name'],
            NRIC: n['NRIC'],
            Percentage: n['Percentage'],
            Relationship: n['Relationship'],
            Type: n['Type'],
          };
          tempdeleted.push(nominee);
        }

        const temp = this.nomineeList;
        this.selectedNominee.forEach((s) => {
          const index = temp.map((n) => n['NRIC']).indexOf(s['NRIC']);
          temp.splice(index, 1);
        });
        this.nomineeList = [];

        this.$nextTick(() => {
          this.deletedNomineeList = tempdeleted;
          this.nomineeList = temp;
          this.selectedNominee = [];
        });
      }
    },
    //#endregion

    //#region Employment
    addEmployment: function () {
      this.showDetails = true;
      this.empEditIndex = -1;
      this.clearDetails('employment history');
    },
    editEmploymentButtonClicked: function (_btn, data) {
      if (this.viewMode) return;
      this.showDetails = true;
      this.empEditIndex = this.employmentList.map((n) => n['ID']).indexOf(data['ID']);
      this.populateEmpEditData(data);
    },
    populateEmpEditData: function (data) {
      this.employmentHistory['companyName'] = data['Company'];
      this.employmentHistory['phoneNo'] = data['Company Tel No'];
      this.employmentHistory['position'] = data['Position'];
      this.employmentHistory['responsibilities'] = data['Job Responsibilities'];
      this.employmentHistory['reasonForLeaving'] = data['Reason Leaving'];
      this.employmentHistory['remarks'] = data['Remarks'];
      this.employmentHistory['dateJoined'] = data['Date Joined'] ? data['Date Joined'].toDate() : '';
      this.employmentHistory['dateLeft'] = data['Date Left'] ? data['Date Left'].toDate() : '';
      this.employmentHistory['seqNo'] = data['Sequence No'];
      this.employmentHistory['empID'] = data['ID'];
    },
    checkEmploymentFields: function () {
      let error = false;
      if (!this.employmentHistory['companyName'].trim()) {
        this.companyNameError = 'Company Name is required!';
        error = true;
      } else if (this.employmentHistory['companyName'].length > 30) {
        this.companyNameError = 'Company Name cannot exceed 30 characters!';
        error = true;
      }
      if (this.employmentHistory['phoneNo'].length > 20) {
        this.phoneNoError = 'Company Phone No. cannot exceed 20 characters!';
        error = true;
      }
      if (!this.employmentHistory['position'].trim()) {
        this.positionError = 'Position Held is required!';
        error = true;
      } else if (this.employmentHistory['position'].length > 20) {
        this.positionError = 'Position Held cannot exceed 20 characters!';
        error = true;
      }
      if (this.employmentHistory['responsibilities'].length > 300) {
        this.responsibilitiesError = 'Job Responsibilities cannot exceed 300 characters!';
        error = true;
      }
      if (this.employmentHistory['reasonForLeaving'].length > 100) {
        this.reasonForLeavingError = 'Reason For Leaving cannot exceed 100 characters!';
        error = true;
      }
      if (this.employmentHistory['remarks'].length > 100) {
        this.remarksError = 'Remarks cannot exceed 100 characters!';
        error = true;
      }
      if (!this.employmentHistory['dateJoined']) {
        this.eDateJoinedError = 'Date Joined is required!';
        error = true;
      }
      if (!this.employmentHistory['dateLeft']) {
        this.eDateLeftError = 'Date Left is required!';
        error = true;
      }
      return error;
    },
    saveEmployment: function () {
      if (this.viewMode) return;
      if (!this.checkEmploymentFields()) {
        const temp = this.employmentList;
        this.employmentList = [];

        let highestID = 1;
        for (const e of temp) {
          if (e['ID'] > highestID) {
            highestID = e['ID'];
          }
        }

        const employment = {
          //Check for newly added rows, they have empty seqNo. If that's the case, set 'Action' to 'N'.
          Action: this.empEditIndex > -1 && this.employmentHistory['seqNo'] != '' ? 'E' : 'N',
          Company: !this.employmentHistory['companyName'] ? '' : this.employmentHistory['companyName'],
          'Company Tel No': !this.employmentHistory['phoneNo'] ? '' : this.employmentHistory['phoneNo'],
          Position: !this.employmentHistory['position'] ? '' : this.employmentHistory['position'],
          'Job Responsibilities':
            !this.employmentHistory['responsibilities'] ? '' : this.employmentHistory['responsibilities'],
          'Reason Leaving':
            !this.employmentHistory['reasonForLeaving'] ? '' : this.employmentHistory['reasonForLeaving'],
          Remarks: !this.employmentHistory['remarks'] ? '' : this.employmentHistory['remarks'],
          'Date Joined':
            this.employmentHistory['dateJoined'] ?
              this.employmentHistory['dateJoined'].formatString('yyyy-MM-dd')
            : null,
          'Date Left':
            this.employmentHistory['dateLeft'] ? this.employmentHistory['dateLeft'].formatString('yyyy-MM-dd') : null,
          'Sequence No': !this.employmentHistory['seqNo'] ? '' : this.employmentHistory['seqNo'],
          ID: !this.employmentHistory['empID'] ? ++highestID : this.employmentHistory['empID'],
        };

        this.$nextTick(() => {
          if (this.empEditIndex > -1) {
            temp.splice(this.empEditIndex, 1, employment);
          } else {
            temp.push(employment);
          }
          this.employmentList = temp;
          this.clearDetails('employment history');
          this.showDetails = false;
          this.empEditIndex = -1;

          this.selectedEmployment = [];
        });
      }
    },
    deleteEmpClicked: function () {
      if (this.selectedEmployment.length == 0) {
        this.$showAlert(
          'error',
          'No Employment History Selected',
          'Please select at least 1 employment history to delete.',
        );
      } else {
        const tempdeleted = this.deletedEmploymentList;
        this.deletedEmploymentList = [];

        for (const e of this.selectedEmployment) {
          const employment = {
            Action: 'D',
            Company: e['Company'],
            'Company Tel No': e['Company Tel No'],
            Position: e['Position'],
            'Job Responsibilities': e['Job Responsibilities'],
            'Reason Leaving': e['Reason Leaving'],
            Remarks: e['Remarks'],
            'Date Joined': e['Date Joined'],
            'Date Left': e['Date Left'],
            'Sequence No': e['Sequence No'],
          };
          if (e['Sequence No'] != '') {
            tempdeleted.push(employment);
          }
        }

        const temp = this.employmentList;
        this.selectedEmployment.forEach((s) => {
          const index = temp.map((n) => n['ID']).indexOf(s['ID']);
          temp.splice(index, 1);
        });
        this.employmentList = [];

        this.$nextTick(() => {
          this.deletedEmploymentList = tempdeleted;
          this.employmentList = temp;
          this.selectedEmployment = [];
        });
      }
    },
    //#endregion

    //#region Documents
    addDocument: function () {
      // this.clearDetails();
      this.showDocDetails = true;
      this.docEditMode = false;
      this.docEditIndex = -1;
      this.clearDetails('documents');
    },
    editDocButtonClicked: function (_btn, data) {
      if (this.viewMode) return;
      this.showDocDetails = true;
      this.docEditMode = true;
      this.docEditIndex = this.documentsList.map((n) => n['ID']).indexOf(data['ID']);
      this.populateDocEditData(data);
      this.handleFileUpload;
    },
    populateDocEditData: function (data) {
      this.documents['dateReceived'] = data['Date Received'].toDate();
      this.documents['docCode'] = this.getDocData['docCode'].find((i) => {
        return i['Doc Code'].trim() == data['Document Code'].trim();
      });
      this.documents['refNo'] = data['Ref No'];
      this.documents['expiryDate'] = data['Expiry Date'].toDate();
      this.documents['docType'] = this.getDocData['docType'].find((i) => {
        return i['Description'].trim() == data['Document Type'].trim();
      });
      this.documents['docDate'] = data['Document Date'].toDate();
      this.documents['docName'] = data['Document Name'];
      this.documents['remarks'] = data['Remarks'];
      this.documents['attachmentFile'] = data['Attachment File'];
      this.documents['docGuid'] = data['Document GUID'];
      this.documents['filetype'] = data['ImageType'] ? '' : data['File Type'];
      this.documents['timeReceive'] = data['Time Received'];
      //temporary id
      this.documents['docID'] = data['ID'];
    },
    checkDocumentFields: function () {
      let error = false;
      if (!this.documents['docCode']) {
        this.docCodeError = 'Document Code is required!';
        error = true;
      }
      if (!this.documents['docType']) {
        this.docTypeError = 'Document Type is required!';
        error = true;
      }
      if (!this.documents['refNo'].trim()) {
        this.refNoError = 'Ref No. is required!';
        error = true;
      } else if (this.documents['refNo'].length > 35) {
        this.refNoError = 'Ref No. cannot exceed 35 characters!';
        error = true;
      }
      if (!this.documents['docName']) {
        this.$showAlert('error', 'No attachment added!', 'Please add an attachment to save.');
        error = true;
      }
      if (this.documents['remarks'].length > 200) {
        this.dRemarksError = 'Remarks cannot exceed 200 characters!';
        error = true;
      }
      return error;
    },
    saveDocument: function () {
      if (this.viewMode) return;
      if (!this.checkDocumentFields()) {
        const temp = this.documentsList;
        this.documentsList = [];
        const current = new Date();
        const tempreceivetime = `${current.getHours()}${current.getMinutes()}`;
        let highestID = 1;
        for (const d of temp) {
          if (d['ID'] > highestID) {
            highestID = d['ID'];
          }
        }

        const document = {
          //Check for newly added rows, they have empty docGuid. If that's the case, set 'Action' to 'N'.
          Action: this.docEditIndex > -1 && this.documents['docGuid'] ? 'E' : 'N',
          'Date Received':
            !this.documents['dateReceived'] ? '' : this.documents['dateReceived'].formatString('yyyy-MM-dd'),
          'Time Received': !this.documents['timeReceive'] ? tempreceivetime.toString() : this.documents['timeReceive'],
          'Document Code': !this.documents['docCode'] ? '' : this.documents['docCode']['Doc Code'],
          'Ref No': !this.documents['refNo'] ? '' : this.documents['refNo'],
          'Expiry Date': this.documents['expiryDate'] ? this.documents['expiryDate'].formatString('yyyy-MM-dd') : null,
          'Document Type': !this.documents['docType'] ? '' : this.documents['docType']['Description'],
          'Document Name': !this.documents['docName'] ? '' : this.documents['docName'],
          'Document Date': !this.documents['docDate'] ? '' : this.documents['docDate'].formatString('yyyy-MM-dd'),
          Remarks: !this.documents['remarks'] ? '' : this.documents['remarks'],
          'Attachment File': !this.documents['attachmentFile'] ? '' : this.documents['attachmentFile'],
          'Document GUID': !this.documents['docGuid'] ? '' : this.documents['docGuid'],
          'File Type': !this.documents['filetype'] ? '' : this.documents['filetype'],
          ID: !this.documents['docID'] ? ++highestID : this.documents['docID'],
        };
        this.$nextTick(() => {
          if (this.docEditIndex > -1) {
            temp.splice(this.docEditIndex, 1, document);
          } else {
            temp.push(document);
          }
          this.documentsList = temp;
          this.clearDetails('documents');
          this.showDocDetails = false;
          this.docEditIndex = -1;

          this.selectedDoc = [];
        });
      }
    },
    deleteDocClicked: function () {
      if (this.selectedDoc.length == 0) {
        this.$showAlert('error', 'No Document Selected', 'Please select at least 1 document to delete.');
      } else {
        const tempdeleted = this.deletedDocumentsList;
        this.deletedDocumentsList = [];

        for (const d of this.selectedDoc) {
          const document = {
            Action: 'D',
            'Date Received': d['Date Received'],
            'Time Received': d['Date Received'],
            'Ref No': d['Ref No'],
            'Expiry Date': d['Expiry Date'],
            'Document Type': d['Document Type'],
            'Document Name': d['Document Name'],
            'Document Date': d['Document Date'],
            Remarks: d['Remarks'],
            'Attachment File': d['Attachment File'],
            'Sequence No': d['Sequence No'],
            'Document GUID': d['Document GUID'],
          };

          if (d['Document GUID']) {
            tempdeleted.push(document);
          }
        }
        const temp = this.documentsList;
        this.selectedDoc.forEach((s) => {
          const index = temp.map((n) => n['ID']).indexOf(s['ID']);
          temp.splice(index, 1);
        });
        this.documentsList = [];

        this.$nextTick(() => {
          this.deletedDocumentsList = tempdeleted;
          this.documentsList = temp;
          this.selectedDoc = [];
        });
      }
    },
    //#endregion

    //#region  Family
    addFamilyDetail: function () {
      this.showFamilyDetails = true;
      this.familyDetEditIndex = -1;
      this.clearDetails('family details');
    },
    editFamilyButtonClicked: function (_btn, data) {
      if (this.viewMode) return;
      this.showFamilyDetails = true;
      this.familyDetEditIndex = this.familyDetList.map((n) => n['NRIC']).indexOf(data['NRIC']);
      this.populateFamilyEditData(data);
    },
    populateFamilyEditData: function (data) {
      this.familyDetails['kinName'] = data['Name'];
      const nric = data['NRIC'].split('-');
      this.familyDetails['kinNric1'] = nric[0];
      this.familyDetails['kinNric2'] = nric[1];
      this.familyDetails['kinNric3'] = nric[2];
      this.familyDetails['kinRelationship'] = this.familyDetailsData['kinRelationship'].find((i) => {
        return i['Relationship'].trim() == data['Relationship'].trim();
      });
      this.familyDetails['kinTel'] = data['Tel No'];
      this.familyDetails['kinMobile'] = data['Mobile No'];
      this.familyDetails['kinGender'] = this.familyDetailsData['kinGender'].find((i) => {
        return i['Gender'].trim() == data['Gender'].trim();
      });
      this.familyDetails['kindob'] = data['Date of Birth'] ? data['Date of Birth'].toDate() : null;
      this.familyDetails['kinBirthCertNo'] = data['Birth Certificate No'];
      if (data['Working'] == 'YES') {
        this.familyDetails['kinIsWorking'] = 'YES';
        this.familyDetails['kinIsWorkingCB'] = true;
      } else {
        this.familyDetails['kinIsWorking'] = '';
        this.familyDetails['kinIsWorkingCB'] = false;
      }

      if (data['Disabled'] == 'YES') {
        this.familyDetails['kinIsDisabled'] = 'YES';
        this.familyDetails['kinIsDisabledCB'] = true;
      } else {
        this.familyDetails['kinIsDisabled'] = '';
        this.familyDetails['kinIsDisabledCB'] = false;
      }

      if (data['Living Together'] == 'YES') {
        this.familyDetails['kinIsLivingTgt'] = 'YES';
        this.familyDetails['kinIsLivingTgtCB'] = true;
      } else {
        this.familyDetails['kinIsLivingTgt'] = '';
        this.familyDetails['kinIsLivingTgtCB'] = false;
      }

      if (data['Emergency Contact'] == 'YES') {
        this.familyDetails['kinIsEmergencyContact'] = 'YES';
        this.familyDetails['kinIsEmergencyContactCB'] = true;
      } else {
        this.familyDetails['kinIsEmergencyContact'] = '';
        this.familyDetails['kinIsEmergencyContactCB'] = false;
      }
      if (data['Diploma/Degree Level'] == 'YES') {
        this.familyDetails['kinIsEducated'] = 'YES';
        this.familyDetails['kinIsEducatedCB'] = true;
      } else {
        this.familyDetails['kinIsEducated'] = '';
        this.familyDetails['kinIsEducatedCB'] = false;
      }

      this.familyDetails['seqNo'] = data['Kin ID'];
    },
    checkFamilyFields: function () {
      let error = false;
      if (!this.familyDetails['kinName'].trim()) {
        this.famNameError = 'Name is required!';
        error = true;
      } else if (this.familyDetails['kinName'].length > 50) {
        this.famNameError = 'Name cannot exceed 50 characters!';
        error = true;
      }
      if (!this.familyDetails['kinNric1'] && !this.familyDetails['kinNric2'] && !this.familyDetails['kinNric3']) {
        this.famNRICError1 = 'IC No. is required!';
        error = true;
      } else {
        if (!this.familyDetails['kinNric1']) {
          this.famNRICError1 = 'IC No. is required!';
          error = true;
        } else if (this.familyDetails['kinNric1'].length != 6) {
          this.famNRICError1 = 'Invalid IC No.!';
          error = true;
        }
        if (!this.familyDetails['kinNric2']) {
          this.famNRICError2 = 'IC No. is required!';
          error = true;
        } else if (this.familyDetails['kinNric2'].length != 2) {
          this.famNRICError2 = 'Invalid IC No.!';
          error = true;
        }
        if (!this.familyDetails['kinNric3']) {
          this.famNRICError3 = 'IC No. is required!';
          error = true;
        } else if (this.familyDetails['kinNric3'].length < 4) {
          this.famNRICError3 = 'Invalid IC No.!';
          error = true;
        }
      }
      if (this.familyDetails['kinTel'].length > 20) {
        this.famTelError = 'Tel No. cannot exceed 20 characters!';
        error = true;
      }
      if (this.familyDetails['kinMobile'].length > 20) {
        this.famMobileError = 'Mobile No. cannot exceed 20 characters!';
        error = true;
      }
      if (this.familyDetails['kinBirthCertNo'].length > 14) {
        this.famBirthCertNoError = 'Birth Certificate No. cannot exceed 14 characters!';
        error = true;
      }
      return error;
    },
    saveFamily: function () {
      if (this.viewMode) return;
      if (this.checkFamilyFields()) {
        return;
      }

      this.familyDetails['kinNric'] =
        `${this.familyDetails['kinNric1']}-${this.familyDetails['kinNric2'].length == 1 ? '0' + this.familyDetails['kinNric2'] : this.familyDetails['kinNric2']}-${this.familyDetails['kinNric3']}`;
      //Check for duplicate kin profile
      if (
        !(
          this.familyDetEditIndex > -1 &&
          this.familyDetails['kinNric'].trim() == this.familyDetList[this.familyDetEditIndex].NRIC.trim()
        )
      ) {
        for (const f of this.familyDetList) {
          if (this.familyDetails['kinNric'].trim() === f.NRIC.trim()) {
            this.$showAlert(
              'error',
              'Cannot Save Kin Profile',
              'This kin already exists. Please ensure the NRIC for each Kin Profile is unique.',
            );
            return;
          }
        }
      }

      const temp = this.familyDetList;
      this.familyDetList = [];

      const family = {
        Action: this.familyDetEditIndex > -1 && this.familyDetails['seqNo'] != '' ? 'E' : 'N',
        Name: !this.familyDetails['kinName'] ? '' : this.familyDetails['kinName'],
        NRIC: !this.familyDetails['kinNric'] ? '' : this.familyDetails['kinNric'],
        Relationship:
          !this.familyDetails['kinRelationship'] ? '' : this.familyDetails['kinRelationship']['Relationship'],
        'Tel No': !this.familyDetails['kinTel'] ? '' : this.familyDetails['kinTel'],
        'Mobile No': !this.familyDetails['kinMobile'] ? '' : this.familyDetails['kinMobile'],
        Gender: !this.familyDetails['kinGender'] ? '' : this.familyDetails['kinGender']['Gender'],
        'Date of Birth': !this.familyDetails['kindob'] ? '' : this.familyDetails['kindob'].formatString('yyyy-MM-dd'),
        'Birth Certificate No': !this.familyDetails['kinBirthCertNo'] ? '' : this.familyDetails['kinBirthCertNo'],
        Working: !this.familyDetails['kinIsWorking'] ? '' : this.familyDetails['kinIsWorking'],
        Disabled: !this.familyDetails['kinIsDisabled'] ? '' : this.familyDetails['kinIsDisabled'],
        'Living Together': !this.familyDetails['kinIsLivingTgt'] ? '' : this.familyDetails['kinIsLivingTgt'],
        'Emergency Contact':
          !this.familyDetails['kinIsEmergencyContact'] ? '' : this.familyDetails['kinIsEmergencyContact'],
        'Diploma/Degree Level': !this.familyDetails['kinIsEducated'] ? '' : this.familyDetails['kinIsEducated'],
        'Kin ID': !this.familyDetails['seqNo'] ? '' : this.familyDetails['seqNo'],
      };

      this.$nextTick(() => {
        if (this.familyDetEditIndex > -1) {
          temp.splice(this.familyDetEditIndex, 1, family);
        } else {
          temp.push(family);
        }
        this.familyDetList = temp;

        this.clearDetails('family details');
        this.showFamilyDetails = false;
        this.familyDetEditIndex = -1;

        this.selectedFamilyDet = [];
      });
    },
    deleteFamilyClicked: function () {
      if (this.selectedFamilyDet.length == 0) {
        this.$showAlert('error', 'No Family Details Selected', 'Please select at least 1 family details to delete.');
      } else {
        const tempdeleted = this.deletedFamilyDetList;
        this.deletedFamilyDetList = [];
        for (const f of this.selectedFamilyDet) {
          const family = {
            Action: 'D',
            Name: f['Name'],
            NRIC: f['NRIC'],
            Relationship: f['Relationship'],
            'Tel No': f['Tel No'],
            'Mobile No': f['Mobile No'],
            Gender: f['Gender'],
            'Date of Birth': f['Date Of Birth'],
            'Birth Certificate No': f['Birth Certificate No'],
            Working: f['Working'],
            Disabled: f['Disable'],
            'Living Together': f['Living Together'],
            'Emergency Contact': f['Emergency Contact'],
            'Kin ID': f['Kin ID'],
          };
          if (f['Kin ID'] != '') {
            tempdeleted.push(family);
          }
        }
        const temp = this.familyDetList;
        this.selectedFamilyDet.forEach((s) => {
          const index = temp.map((n) => n['NRIC']).indexOf(s['NRIC']);
          temp.splice(index, 1);
        });
        this.familyDetList = [];

        this.$nextTick(() => {
          this.deletedFamilyDetList = tempdeleted;
          this.familyDetList = temp;
          this.selectedFamilyDet = [];
        });
      }
    },
    //#endregion

    //#region  Career
    addCareer: function () {
      this.showCareer = true;
      this.careerEditIndex = -1;
      this.clearDetails('career');
    },
    editCareerButtonClicked: function (_btn, data) {
      if (this.viewMode) return;
      this.showCareer = true;
      this.careerEditIndex = this.careerList.map((n) => n['Career ID']).indexOf(data['Career ID']);
      this.populateCareerEditData(data);
    },
    populateCareerEditData: function (data) {
      this.career['effectiveDate'] = data['Effective Date'].toDate();
      this.career['code'] = data['Career Code'];
      this.career['remarks'] = data['Remarks'];
      this.career['notes'] = data['Notes'];
      this.career['dateUpdate'] = new Date().formatString('yyyy-MM-dd');
      this.career['userID'] = data['UserID'];
      this.career['careerid'] = data['Career ID'];
    },
    saveCareer: function () {
      if (this.viewMode) return;
      if (this.careerList.length == 0) {
        this.$showAlert('error', 'No Data found!', 'Please fill in the details to save');
      } else {
        const temp = this.careerList;
        this.careerList = [];
        const career = {
          career_action: 'E',
          'Sequence No': !this.career['seqNo'] ? '' : this.career['seqNo'],
          'Effective Date':
            !this.career['effectiveDate'] ? '' : this.career['effectiveDate'].formatString('yyyy-MM-dd'),
          'Career ID': !this.career['careerid'] ? '' : this.career['careerid'],
          'Career Code': !this.career['code'] ? '' : this.career['code'],
          Remarks: !this.career['remarks'] ? '' : this.career['remarks'],
          Notes: !this.career['notes'] ? '' : this.career['notes'],
          'Date Update': !this.career['dateUpdate'] ? '' : this.career['dateUpdate'],
          UserID: !this.career['userID'] ? '' : this.career['userID'],
        };

        this.$nextTick(() => {
          if (this.careerEditIndex > -1) {
            temp.splice(this.careerEditIndex, 1, career);
          } else {
            temp.push(career);
          }
          this.careerList = temp;

          this.clearDetails('career');
          this.showCareer = false;
          this.careerEditIndex = -1;

          this.selectedcareer = [];
        });
      }
    },

    deleteCareerClicked: function () {
      if (this.selectedcareer.length == 0) {
        this.$showAlert('error', 'No Career History Selected', 'Please select at least 1 career history to delete.');
      } else {
        this.showDeleteCareerPopupWithRemarks = true;
      }
    },
    deleteCareerPopupClicked: async function (e) {
      switch (e) {
        case 'Delete': {
          const originalRemarks = this.career['deleteRemarks'];
          if (!originalRemarks.trim()) {
            this.deleteRemarksError = 'Delete remarks are required!';
            this.entryRequired.push({ key: 'deleteRemarks', value: 'Please enter delete remarks!' });
            return; // Stop execution if remarks are missing
          }
          // const tempdeleted = this.deletedCareerList;
          this.deletedCareerList = [];

          const tempdeleted = [];
          for (const c of this.selectedcareer) {
            const career = {
              career_action: 'D',
              'Career ID': c['Career ID'],
              'Delete remarks': this.career['deleteRemarks'],
              Notes: c['Notes1'],
              CareerDate: c['CareerDate'],
            };
            if (c['Career ID']) {
              tempdeleted.push(career);
            }
          }
          const temp = this.careerList;
          this.selectedcareer.forEach((s) => {
            const index = temp.map((n) => n['Career ID']).indexOf(s['Career ID']);
            temp.splice(index, 1);
          });
          this.careerList = [];

          await this.$nextTick();
          this.deletedCareerList = tempdeleted;
          this.careerList = temp;
          this.entryRequired = [];

          this.career['deleteRemarks'] = '';
          this.deleteRemarksError = '';
          this.showDeleteCareerPopupWithRemarks = false;

          break;
        }
        case 'Cancel':
          this.career['deleteRemarks'] = '';
          this.deleteRemarksError = '';
          this.selectedcareer = [];
          this.showDeleteCareerPopupWithRemarks = false;
          break;
      }
    },
    //#endregion

    //#region Education
    addEducation: function () {
      this.showEducation = true;
      this.educationEditIndex = -1;
      this.clearDetails('education');
    },
    editEduButtonClicked: function (_btn, data) {
      if (this.viewMode) return;
      this.showEducation = true;
      this.educationEditIndex = this.educationList.map((n) => n['ID']).indexOf(data['ID']);
      this.populateEduEditData(data);
    },
    populateEduEditData: function (data) {
      this.education['companyCode'] = data['Company Code'];
      this.education['instituteName'] = data['Institute Name'];
      this.education['instituteCategory'] = this.educationData['instituteCategory'].find((i) => {
        return i['Institute Category'].trim() == data['Institute Category'].trim();
      });
      this.education['country'] = this.educationData['country'].find((i) => {
        return i['Country Code'].trim() == data['Country'].trim();
      });
      this.education['qualification'] = this.educationData['qualification'].find((i) => {
        return i['Qualification'].trim() == data['Qualification'].trim();
      });
      this.education['from'] = !data['From'] ? new Date() : data['From'].toDate();
      this.education['to'] = !data['To'] ? new Date() : data['To'].toDate();
      this.education['graduateYear'] = !data['Year of Graduate'] ? new Date() : data['Year of Graduate'].toDate();
      this.education['grade'] = data['Grade'];
      this.education['major'] = data['Major'];
      this.education['remarks'] = data['Remarks'];
      this.education['seqNo'] = data['Sequence No'];
      //temporary id
      this.education['eduID'] = data['ID'];
    },

    checkEducationFields: function () {
      let error = false;
      if (this.education['companyCode'].length > 2) {
        this.companyCodeError = 'Company Code cannot exceed 2 characters!';
        error = true;
      }
      if (!this.education['instituteName'].trim()) {
        this.instituteNameError = 'Institute Name is required!';
        error = true;
      } else if (this.education['instituteName'].length > 200) {
        this.instituteNameError = 'Institute Name cannot exceed 200 characters!';
        error = true;
      }
      if (!this.education['instituteCategory']) {
        this.instituteCategoryError = 'Institute Category is required!';
        error = true;
      }
      if (!this.education['country']) {
        this.countryError = 'Country is required!';
        error = true;
      }
      if (!this.education['from']) {
        this.fromError = 'From is required!';
        error = true;
      }
      if (!this.education['to']) {
        this.toError = 'To is required!';
        error = true;
      }
      //check From is lesser than To
      if (this.education['from'] > this.education['to']) {
        this.toError = 'To date must be greater than From date!';
        error = true;
      }
      if (!this.education['graduateYear']) {
        this.graduateError = 'Year of Graduate is required!';
        error = true;
      }
      if (this.education['grade'].length > 10) {
        this.gradeError = 'Grade cannot exceed 10 characters!';
        error = true;
      }
      if (this.education['major'].length > 200) {
        this.majorError = 'Major cannot exceed 200 characters!';
        error = true;
      }
      if (this.education['remarks'].length > 200) {
        this.eRemarksError = 'Remarks cannot exceed 200 characters!';
        error = true;
      }
      return error;
    },
    saveEducation: function () {
      if (this.viewMode) return;
      if (!this.checkEducationFields()) {
        const temp = this.educationList;
        this.educationList = [];

        let highestID = 1;
        for (const e of temp) {
          if (e['ID'] > highestID) {
            highestID = e['ID'];
          }
        }

        const education = {
          Action: this.educationEditIndex > -1 && this.education['seqNo'] != '' ? 'E' : 'N',
          'Company Code': !this.education['companyCode'] ? '' : this.education['companyCode'],
          'Institute Name': !this.education['instituteName'] ? '' : this.education['instituteName'],
          'Institute Category':
            !this.education['instituteCategory'] ? '' : this.education['instituteCategory']['Institute Category'],
          Country: !this.education['country'] ? '' : this.education['country']['Country Code'],
          Qualification: !this.education['qualification'] ? '' : this.education['qualification']['Qualification'],
          From: !this.education['from'] ? '' : this.education['from'].formatString('yyyy-MM-dd'),
          To: !this.education['to'] ? '' : this.education['to'].formatString('yyyy-MM-dd'),
          'Graduate Year':
            !this.education['graduateYear'] ? '' : this.education['graduateYear'].formatString('yyyy-MM-dd'),
          Grade: !this.education['grade'] ? '' : this.education['grade'],
          Major: !this.education['major'] ? '' : this.education['major'],
          Remarks: !this.education['remarks'] ? '' : this.education['remarks'],
          'Sequence No': !this.education['seqNo'] ? '' : this.education['seqNo'],
          ID: !this.education['eduID'] ? ++highestID : this.education['eduID'],
        };
        this.$nextTick(() => {
          if (this.educationEditIndex > -1) {
            temp.splice(this.educationEditIndex, 1, education);
          } else {
            temp.push(education);
          }
          this.educationList = temp;
          this.clearDetails('education');
          this.showEducation = false;
          this.educationEditIndex = -1;
          this.selectedEducation = [];
        });
      }
    },
    deleteEduClicked: function () {
      if (this.selectedEducation.length == 0) {
        this.$showAlert(
          'error',
          'No Education History Selected',
          'Please select at least 1 education history to delete.',
        );
      } else {
        this.showDeleteEduPopupWithRemarks = true;
      }
    },
    deleteEduPopupClicked: async function (e) {
      switch (e) {
        case 'Delete':
          if (!this.education['deleteRemarks']) {
            this.deleteRemarksError = 'Please enter delete remarks!';
            this.entryRequired.push({ key: 'deleteRemarks', value: 'Please enter delete remarks!' });
          } else {
            const tempdeleted = this.deletedEducationList;
            this.deletedEducationList = [];
            for (const e of this.selectedEducation) {
              const education = {
                Action: 'D',
                'Company Code': e['Company Code'],
                'Institute Name': e['Institute Name'],
                'Institute Category': e['Institute Category'],
                Country: e['Country'],
                Qualification: e['Qualification'],
                From: e['From'],
                To: e['To'],
                'Graduate Year': e['Graduate Year'],
                Grade: e['Grade'],
                Major: e['Major'],
                Remarks: this.education['deleteRemarks'],
                'Sequence No': e['Sequence No'],
              };
              if (e['Sequence No'] != '') {
                tempdeleted.push(education);
              }
            }
            const temp = this.educationList;
            this.selectedEducation.forEach((s) => {
              const index = temp.map((n) => n['ID']).indexOf(s['ID']);
              temp.splice(index, 1);
            });
            this.educationList = [];

            await this.$nextTick();
            this.deletedEducationList = tempdeleted;
            this.educationList = temp;
            this.selectedEducation = [];

            this.entryRequired = [];

            this.education['deleteRemarks'] = '';
            this.deleteRemarksError = '';
            this.showDeleteEduPopupWithRemarks = false;
          }
          break;
        case 'Cancel':
          this.education['deleteRemarks'] = '';
          this.deleteRemarksError = '';
          this.selectedEducation = [];
          this.showDeleteEduPopupWithRemarks = false;
      }
    },

    //#endregion
    checkFields: function () {
      this.clearEntryMessages();
      if (!this.empNo) {
        this.empNoError = 'Employee No. is required!';
        this.entryRequired.push({ key: 'employeeno', value: 'Employee No. is required!' });
      } else if (this.empNo.length > 10) {
        this.empNoError = 'Employee No. cannot exceed 10 characters!';
        this.entryRequired.push({ key: 'employeeno', value: 'Employee No. cannot exceed 10 characters!' });
      }
      if (!this.genDetails['empName'].trim()) {
        this.empNameError = 'Employee Name is required!';
        this.entryRequired.push({ key: 'employeename', value: 'Employee Name is required!' });
      } else if (this.genDetails['empName'].length > 50) {
        this.empNameError = 'Employee Name cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'employeename', value: 'Employee Name cannot exceed 50 characters!' });
      }
      if (!this.genDetails['status'].trim()) {
        this.statusError = 'Status is required!';
        this.entryRequired.push({ key: 'status', value: 'Status is required!' });
      }
      if (!this.genDetails['nationality']) {
        this.nationalityError = 'Nationality is required!';
        this.entryRequired.push({ key: 'nationality', value: 'Nationality is required!' });
      }
      if (!this.genDetails['nricNew1'] && !this.genDetails['nricNew2'] && !this.genDetails['nricNew3']) {
        this.nricNewError1 = 'IC No. is required!';
        this.entryRequired.push({ key: 'nricnew1', value: 'IC No. is required!' });
      } else {
        if (!this.genDetails['nricNew1']) {
          this.nricNewError1 = 'IC No. is required!';
          this.entryRequired.push({ key: 'nricnew1', value: 'IC No. is required!' });
        } else if (this.genDetails['nricNew1'].length != 6) {
          this.nricNewError1 = 'Invalid IC No.!';
          this.entryRequired.push({ key: 'nricnew1', value: 'Invalid IC No.!' });
        }
        if (!this.genDetails['nricNew2']) {
          this.nricNewError2 = 'IC No. is required!';
          this.entryRequired.push({ key: 'nricnew2', value: 'IC No. is required!' });
        } else if (this.genDetails['nricNew2'].length != 2) {
          this.nricNewError2 = 'Invalid IC No.!';
          this.entryRequired.push({ key: 'nricnew2', value: 'Invalid IC No.!' });
        }
        if (!this.genDetails['nricNew3']) {
          this.nricNewError3 = 'IC No. is required!';
          this.entryRequired.push({ key: 'nricnew3', value: 'IC No. is required!' });
        } else if (this.genDetails['nricNew3'].length < 4) {
          this.nricNewError3 = 'Invalid IC No.!';
          this.entryRequired.push({ key: 'nricnew3', value: 'Invalid IC No.!' });
        }
      }
      if (!this.otherDetails['employmentType']) {
        this.employmentTypeError = 'Employment Type is required!';
        this.entryRequired.push({ key: 'employmentTypeError', value: 'Employment Type is required!' });
      }
      if (!this.genDetails['gender']) {
        this.genderError = 'Gender is required!';
        this.entryRequired.push({ key: 'gender', value: 'Gender is required!' });
      }
      if (!this.genDetails['race']) {
        this.raceError = 'Race is required!';
        this.entryRequired.push({ key: 'race', value: 'Race is required!' });
      }
      if (!this.otherDetails['dept']) {
        this.deptError = 'Department is required!';
        this.entryRequired.push({ key: 'department', value: 'Department is required!' });
      }
      if (!this.otherDetails['jobTitle'].trim()) {
        this.jobTitleError = 'Job Title is required!';
        this.entryRequired.push({ key: 'jobtitle', value: 'Job Title is required!' });
      } else if (this.otherDetails['jobTitle'].length > 50) {
        this.jobTitleError = 'Job Title cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'jobtitle', value: 'Job Title cannot exceed 50 characters!' });
      }
      if (!this.genDetails['dateofbirth']) {
        this.dateofbirthError = 'Date of Birth is required!';
        this.entryRequired.push({ key: 'dateofbirth', value: 'Date of Birth is required!' });
      }
      if (!this.genDetails['dateJoined']) {
        this.dateJoinedError = 'Date Joined is required!';
        this.entryRequired.push({ key: 'dateJoined', value: 'Date Joined is required!' });
      }
      if (this.genDetails['pob'].length > 100) {
        this.pobError = 'Place of Birth cannot exceed 100 characters!';
        this.entryRequired.push({ key: 'pob', value: 'Place of Birth cannot exceed 100 characters!' });
      }
      if (this.genDetails['nricOld'].length > 10) {
        this.nricOldError = 'Old IC No. cannot exceed 10 characters!';
        this.entryRequired.push({ key: 'nricold', value: 'Old IC No. cannot exceed 10 characters!' });
      }
      if (this.genDetails['spouseName'].length > 50) {
        this.spouseNameError = 'Spouse Name cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'spouseName', value: 'Spouse Name cannot exceed 50 characters!' });
      }
      if (!this.otherDetails['branch']) {
        this.branchError = 'Branch is required!';
        this.entryRequired.push({ key: 'branch', value: 'Branch is required!' });
      }
      if (this.dynamicRequired && !this.otherDetails['drivingLicenseNo'].trim()) {
        this.drivingLicenseNoError = 'Driving License No. is required!';
        this.entryRequired.push({ key: 'drivingLicenseNo', value: 'Driving License No. is required!' });
      } else if (this.otherDetails['drivingLicenseNo'].length > 15) {
        this.drivingLicenseNoError = 'Driving License No. cannot exceed 15 characters!';
        this.entryRequired.push({
          key: 'drivingLicenseNo',
          value: 'Driving License No. cannot exceed 15 characters!',
        });
      }
      if (this.dynamicRequired && !this.otherDetails['expirydatedl']) {
        this.expirydatedlError = 'Driving License Expiry is required!';
        this.entryRequired.push({ key: 'expirydatedl', value: 'Driving License Expiry is required!' });
      }
      if (this.dynamicRequired && this.otherDetails['drivingClass'].length == 0) {
        this.drivingClassError = 'Driving Class No. is required!';
        this.entryRequired.push({ key: 'drivingClass', value: 'Driving Class No. is required!' });
      }
      if (this.dynamicRequired && !this.otherDetails['badgeLicenseNo'].trim()) {
        this.badgeLicenseNoError = 'Badge License is required!';
        this.entryRequired.push({ key: 'badgeLicenseNo', value: 'Badge License is required!' });
      } else if (this.dynamicRequired && this.otherDetails['badgeLicenseNo'].length > 15) {
        this.badgeLicenseNoError = 'Badge License cannot exceed 15 characters!';
        this.entryRequired.push({ key: 'badgeLicenseNo', value: 'Badge License cannot exceed 15 characters!' });
      }
      if (this.dynamicRequired && !this.otherDetails['expirydatebl']) {
        this.expirydateblError = 'Badge License Expiry is required!';
        this.entryRequired.push({ key: 'expirydatebl', value: 'Badge License Expiry is required!' });
      }
      if (this.otherDetails['portPassNo'].length > 25) {
        this.portPassNoError = 'Port Pass No. cannot exceed 25 characters!';
        this.entryRequired.push({ key: 'portPassNo', value: 'Port Pass No. cannot exceed 25 characters!' });
      }
      //date validation
      if (this.genDetails.dateConfirmed && this.genDetails.dateJoined) {
        if (this.genDetails.dateConfirmed < this.genDetails.dateJoined) {
          this.dateConfirmedError = 'Date Confirmed cannot be earlier than Date Joined';
          this.entryRequired.push({ key: 'dateConfirmed', value: 'Date Confirmed cannot be earlier than Date Joined' });
        } else {
          this.dateConfirmedError = '';
        }
      }
      //valid date expiry date
      const currentYear = new Date().getFullYear();
      //maximum year limit, cannot exceed over 10 years, any date within 10 years is considered valid
      const maxYear = currentYear + 10;
      const today = new Date();
      // driving license
      if (this.otherDetails.expirydatedl) {
        const expiryDate = new Date(this.otherDetails.expirydatedl);
        const year = expiryDate.getFullYear();

        if (expiryDate <= today) {
          this.expirydatedlError = 'Driving License Expiry Date must be later than today';
          this.entryRequired.push({
            key: 'expirydatedl',
            value: 'Driving License Expiry Date must be later than today',
          });
        } else if (year > maxYear) {
          this.expirydatedlError = 'Driving License Expiry Date cannot exceed 10 years from now';
          this.entryRequired.push({
            key: 'expirydatedl',
            value: 'Driving License Expiry Date cannot exceed 10 years from now',
          });
        }
      }

      // Business License
      if (this.otherDetails.expirydatebl) {
        const expiryDate = new Date(this.otherDetails.expirydatebl);

        if (expiryDate <= today) {
          this.expirydateblError = 'Business License Expiry Date must be later than today';
          this.entryRequired.push({
            key: 'expirydatebl',
            value: 'Business License Expiry Date must be later than today',
          });
        }
      }

      //Port Pass
      if (this.otherDetails.expirydatepp) {
        const expiryDate = new Date(this.otherDetails.expirydatepp);

        if (expiryDate <= today) {
          this.portPassExpiryError = 'Port Pass Expiry Date must be later than today';
          this.entryRequired.push({ key: 'expirydatepp', value: 'Port Pass Expiry Date must be later than today' });
        }
      }

      if (!this.otherDetails['commisionCode'] && this.dynamicRequired) {
        this.commisionCodeError = 'Commision Code is required!';
        this.entryRequired.push({ key: 'commisionCode', value: 'Commision Code is required!' });
      }
      if (this.chequeChecked && this.otherDetails['payrollAccNo'].length > 25) {
        this.payrollAccNoError = 'Payroll Account No. cannot exceed 25 characters!';
        this.entryRequired.push({ key: 'payrollAccNo', value: 'Payroll Account No. cannot exceed 25 characters!' });
      }
      if (Number(this.otherDetails['totalWorkingHrs']) > 9000000000000000000) {
        this.totalWorkingHrsError = 'Total Working Hour value is too big!';
        this.entryRequired.push({ key: 'totalWorkingHrs', value: 'Total Working Hour value is too big!' });
      }
      if (this.otherDetails['incomeTaxNo'].length > 15) {
        this.incomeTaxNoError = 'Income Tax No. cannot exceed 15 characters!';
        this.entryRequired.push({ key: 'incomeTaxNo', value: 'Income Tax No. cannot exceed 15 characters!' });
      }
      if (this.otherDetails['epfNo'].length > 15) {
        this.epfNoError = 'EPF No. cannot exceed 15 characters!';
        this.entryRequired.push({ key: 'epfNo', value: 'EPF No. cannot exceed 15 characters!' });
      }
      if (this.otherDetails['socsoNo'].length > 15) {
        this.socsoNoError = 'SOCSO No. cannot exceed 15 characters!';
        this.entryRequired.push({ key: 'socsoNo', value: 'SOCSO No. cannot exceed 15 characters!' });
      }
      if (this.contactDetails['defaultAddressData']['addressLine1'].length > 40) {
        this.contactDetails['defaultAddressErrors']['addressLine1'] = 'Address Line 1 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'defaultAddr1', value: 'Default Address Line 1 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['defaultAddressData']['addressLine2'].length > 40) {
        this.contactDetails['defaultAddressErrors']['addressLine2'] = 'Address Line 2 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'defaultAddr2', value: 'Default Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['defaultAddressData']['addressLine3'].length > 40) {
        this.contactDetails['defaultAddressErrors']['addressLine3'] = 'Address Line 3 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'defaultAddr3', value: 'Default Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['defaultAddressData']['addressLine4'].length > 40) {
        this.contactDetails['defaultAddressErrors']['addressLine4'] = 'Address Line 4 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'defaultAddr4', value: 'Default Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['defaultAddressData']['city'].length > 20) {
        this.contactDetails['defaultAddressErrors']['city'] = 'City cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'defaultCity', value: 'Default City cannot exceed 20 characters!' });
      }
      if (this.contactDetails['defaultPhone'].length > 20) {
        this.contactDetails['defaultPhoneError'] = 'Phone No. cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'defaultPhone', value: 'Default Phone No. cannot exceed 20 characters!' });
      }
      if (this.contactDetails['defaultMobile'].length > 20) {
        this.contactDetails['defaultMobileError'] = 'Mobile No. cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'defaultMobile', value: 'Default Mobile No. cannot exceed 20 characters!' });
      }
      if (this.contactDetails['defaultEmail1'].length > 40) {
        this.contactDetails['defaultEmail1Error'] = 'Email (1) cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'defaultEmail1', value: 'Default Email (1) cannot exceed 40 characters!' });
      }
      if (this.contactDetails['defaultEmail2'].length > 40) {
        this.contactDetails['defaultEmail2Error'] = 'Email (2) cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'defaultEmail2', value: 'Default Email (2) cannot exceed 40 characters!' });
      }
      if (this.contactDetails['postalAddressData']['addressLine1'].length > 40) {
        this.contactDetails['postalAddressErrors']['addressLine1'] = 'Address Line 1 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'postalAddr1', value: 'Postal Address Line 1 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['postalAddressData']['addressLine2'].length > 40) {
        this.contactDetails['postalAddressErrors']['addressLine2'] = 'Address Line 2 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'postalAddr2', value: 'Postal Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['postalAddressData']['addressLine3'].length > 40) {
        this.contactDetails['postalAddressErrors']['addressLine3'] = 'Address Line 3 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'postalAddr3', value: 'Postal Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['postalAddressData']['addressLine4'].length > 40) {
        this.contactDetails['postalAddressErrors']['addressLine4'] = 'Address Line 4 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'postalAddr4', value: 'Postal Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['postalAddressData']['city'].length > 20) {
        this.contactDetails['postalAddressErrors']['city'] = 'City cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'postalCity', value: 'Postal City cannot exceed 20 characters!' });
      }
      if (this.contactDetails['postalPhone'].length > 20) {
        this.contactDetails['postalPhoneError'] = 'Phone No. cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'postalPhone', value: 'Postal Phone No. cannot exceed 20 characters!' });
      }
      if (this.contactDetails['postalMobile'].length > 20) {
        this.contactDetails['postalMobileError'] = 'Mobile No. cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'postalMobile', value: 'Postal Mobile No. cannot exceed 20 characters!' });
      }
      if (this.contactDetails['postalEmail1'].length > 40) {
        this.contactDetails['postalEmail1Error'] = 'Email (1) cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'postalEmail1', value: 'Postal Email (1) cannot exceed 40 characters!' });
      }
      if (this.contactDetails['postalEmail2'].length > 40) {
        this.contactDetails['postalEmail2Error'] = 'Email (2) cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'postalEmail2', value: 'Postal Email (2) cannot exceed 40 characters!' });
      }
      if (this.contactDetails['kinName'].length > 50) {
        this.contactDetails['kinNameError'] = 'Name cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'kinName', value: 'Next Of Kin Name cannot exceed 50 characters!' });
      }
      if (this.contactDetails['kinRelationship'].length > 20) {
        this.contactDetails['kinRelationshipError'] = 'Relationship cannot exceed 20 characters!';
        this.entryRequired.push({
          key: 'kinRelationship',
          value: 'Next Of Kin Relationship cannot exceed 20 characters!',
        });
      }
      if (this.contactDetails['kinAddressData']['addressLine1'].length > 40) {
        this.contactDetails['kinAddressErrors']['addressLine1'] = 'Address Line 1 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'kinAddr1', value: 'Next Of Kin Address Line 1 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['kinAddressData']['addressLine2'].length > 40) {
        this.contactDetails['kinAddressErrors']['addressLine2'] = 'Address Line 2 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'kinAddr2', value: 'Next Of Kin Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['kinAddressData']['addressLine3'].length > 40) {
        this.contactDetails['kinAddressErrors']['addressLine3'] = 'Address Line 3 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'kinAddr3', value: 'Next Of Kin Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['kinAddressData']['addressLine4'].length > 40) {
        this.contactDetails['kinAddressErrors']['addressLine4'] = 'Address Line 4 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'kinAddr4', value: 'Next Of Kin Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.contactDetails['kinAddressData']['city'].length > 20) {
        this.contactDetails['kinAddressErrors']['city'] = 'City cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'kinCity', value: 'Next Of Kin City cannot exceed 20 characters!' });
      }
      if (this.contactDetails['kinPhone'].length > 20) {
        this.contactDetails['kinPhoneError'] = 'Phone No. cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'kinPhone', value: 'Next Of Kin Phone No. cannot exceed 20 characters!' });
      }

      if (Number(this.familyDetails['noOfChildren']) < 0 || Number(this.familyDetails['noOfChildren']) > 99) {
        this.noOfChildrenError = 'No. Of Children cannot exceed 99!';
        this.entryRequired.push({ key: 'noOfChildren', value: 'No. Of Children value cannot exceed 99!' });
      }
      if (
        Number(this.familyDetails['noOfChildrenForTaxRebate']) < 0 ||
        Number(this.familyDetails['noOfChildrenForTaxRebate']) > 99
      ) {
        this.noOfChildrenForTaxRebateError = 'No. Of Children for Tax Rebate cannot exceed 99!';
        this.entryRequired.push({
          key: 'noOfChildrenForTaxRebate',
          value: 'No. Of Children for Tax Rebate value cannot exceed 99!',
        });
      }

      if (this.grossSalary && !this.grossSalary.match(/^\$?\d+(,\d{3})*(\.\d{1,4})?$/)) {
        this.grossSalaryError = 'Invalid value or format! Please enter number only.';
        this.entryRequired.push({ key: 'grossSalary', value: 'Invalid value or format! Please enter number only.' });
      } else if (Number(this.grossSalary) > 900000000000000) {
        this.grossSalaryError = 'Gross Salary value too big!';
        this.entryRequired.push({ key: 'grossSalary', value: 'Gross Salary value too big!' });
      }
      if (this.qualification.length > 200) {
        this.qualificationError = 'Qualification cannot exceed 200 characters!';
        this.entryRequired.push({ key: 'qualification', value: 'Qualification cannot exceed 200 characters!' });
      }

      return this.entryRequired.length > 0;
    },
    checkBoxClicked: function (e) {
      switch (e) {
        case 'CS':
          if (this.cashChecked) {
            this.otherDetails['payrollType'] = e;
          }
          break;
        case 'CH':
          if (this.chequeChecked) {
            this.otherDetails['payrollType'] = e;
          }
          break;
        case 'Default':
          // this....[]  = e;
          break;
        case 'Postal':
          break;
        case 'SameDefaultPostal':
          break;
        case 'OKU':
          if (!this.genDetails['disablecheck']) {
            this.genDetails['disableperson'] = 'Y';
          } else {
            this.genDetails['disableperson'] = '';
          }

          break;
        case 'Working':
          if (!this.familyDetails['kinIsWorking']) {
            //for first tick
            if (this.familyDetails['kinIsWorkingCB']) {
              this.familyDetails['kinIsWorkingCB'] = true;
              this.familyDetails['kinIsWorking'] = 'YES';
              break;
            } else {
              this.familyDetails['kinIsWorkingCB'] = false;
              this.familyDetails['kinIsWorking'] = '';
              break;
            }
            // } else if (!this.familyDetails['kinIsWorking']) {
            //     this.familyDetails['kinIsWorkingCB'] = true;
            //     this.familyDetails['kinIsWorking'] = 'YES';
            //     break;
          } else {
            this.familyDetails['kinIsWorkingCB'] = false;
            this.familyDetails['kinIsWorking'] = '';
            break;
          }
        case 'Disabled':
          if (!this.familyDetails['kinIsDisabled']) {
            //for first tick
            if (this.familyDetails['kinIsDisabledCB']) {
              this.familyDetails['kinIsDisabledCB'] = true;
              this.familyDetails['kinIsDisabled'] = 'YES';
              break;
            } else {
              this.familyDetails['kinIsDisabledCB'] = false;
              this.familyDetails['kinIsDisabled'] = '';
              break;
            }
            // } else if (!this.familyDetails['kinIsDisabled']) {
            //     this.familyDetails['kinIsDisabledCB'] = true;
            //     this.familyDetails['kinIsDisabled'] = 'YES';
            //     break;
          } else {
            this.familyDetails['kinIsDisabledCB'] = false;
            this.familyDetails['kinIsDisabled'] = '';
            break;
          }
        case 'Living Together':
          if (!this.familyDetails['kinIsLivingTgt']) {
            //for first tick
            if (this.familyDetails['kinIsLivingTgtCB']) {
              this.familyDetails['kinIsLivingTgtCB'] = true;
              this.familyDetails['kinIsLivingTgt'] = 'YES';
              break;
            } else {
              this.familyDetails['kinIsLivingTgtCB'] = false;
              this.familyDetails['kinIsLivingTgt'] = '';
              break;
            }
            // } else if (!this.familyDetails['kinIsLivingTgt']) {
            //     this.familyDetails['kinIsLivingTgtCB'] = true;
            //     this.familyDetails['kinIsLivingTgt'] = 'YES';
            //     break;
          } else {
            this.familyDetails['kinIsLivingTgtCB'] = false;
            this.familyDetails['kinIsLivingTgt'] = '';
            break;
          }
        case 'Emergency Contact':
          if (!this.familyDetails['kinIsEmergencyContact']) {
            //for first tick
            if (this.familyDetails['kinIsEmergencyContactCB']) {
              this.familyDetails['kinIsEmergencyContactCB'] = true;
              this.familyDetails['kinIsEmergencyContact'] = 'YES';
              break;
            } else {
              this.familyDetails['kinIsEmergencyContactCB'] = false;
              this.familyDetails['kinIsEmergencyContact'] = '';
              break;
            }
            // } else if (!this.familyDetails['kinIsEmergencyContact']) {
            //     this.familyDetails['kinIsEmergencyContactCB'] = true;
            //     this.familyDetails['kinIsEmergencyContact'] = 'YES';
            //     break;
          } else {
            this.familyDetails['kinIsEmergencyContactCB'] = false;
            this.familyDetails['kinIsEmergencyContact'] = '';
            break;
          }
        case 'Diploma/Degree Level':
          if (!this.familyDetails['kinIsEducated']) {
            //for first tick
            if (this.familyDetails['kinIsEducatedCB']) {
              this.familyDetails['kinIsEducatedCB'] = true;
              this.familyDetails['kinIsEducated'] = 'YES';
              break;
            } else {
              this.familyDetails['kinIsEducatedCB'] = false;
              this.familyDetails['kinIsEducated'] = '';
              break;
            }
            // } else if (!this.familyDetails['kinIsEducated']) {
            //     this.familyDetails['kinIsEducatedCB'] = true;
            //     this.familyDetails['kinIsEducated'] = 'YES';
            //     break;
          } else {
            this.familyDetails['kinIsEducatedCB'] = false;
            this.familyDetails['kinIsEducated'] = '';
            break;
          }
      }
    },
    reverseTerminationIsClicked: async function (_e) {
      // update the termination status to api

      const confirmCancel = await this.$showAlert(
        'warning',
        'Reinstate Employee',
        `Are you sure you want to reinstate for this Employee ${this.selectedEmp[0]['Employee ID']} ?`,
        [
          { text: 'Yes', color: 'indianred', textColor: 'white' },
          { text: 'No', color: 'lightgray', textColor: 'black' },
        ],
      );
      switch (confirmCancel) {
        case 'Yes': {
          const result = await this.$apiCallV2('/Employee/SaveEmployee', {
            action: 'R',
            employeeno: this.selectedEmp[0]['Employee ID'],
          });
          this.$nextTick(async () => await this.getEmployees());
          if (result[0]['Results'] == 0) {
            this.$showAlert(
              'success',
              'Reinstated!',
              `Employee ${this.selectedEmp[0]['Employee ID']} was successfully reinstated.`,
            );
            this.genDetails['status'] = 'I = IN/AVAILABLE';
            this.terminationStatusIsDisable = true;
          } else {
            this.$showAlert(
              'error',
              'Reinstate Failed',
              `There was an error occurred while reinstating this employee. Please try again.`,
            );
          }
          break;
        }
        case 'No': {
          break;
        }
      }
    },
    // checkStatus: function (e) {
    //   const myStatus = e;
    // },
    getEmploymentDuration: function (x) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      const currentDate = new Date();

      const utc1 = Date.UTC(x.getFullYear(), x.getMonth(), x.getDate());
      const utc2 = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

      const numOfDays = Math.floor((utc2 - utc1) / _MS_PER_DAY);

      const years = Math.floor(numOfDays / 365);
      const months = Math.floor((numOfDays % 365) / 30);
      const days = Math.floor((numOfDays % 365) % 30);

      const result = `${years} years ${months} months ${days} days`;
      return result;
    },
    // clearImage: function () {
    //   document.getElementById('inputPhoto').value = null;
    //   // $('#inputPhoto').val(null);
    //   this.genDetails['imgSrc'] = '';
    //   this.genDetails['imgDetails'] = 'No Image Inserted';
    //   this.genDetails['hasImage'] = false;
    // },
    // imageDragEnter: function () {
    //   this.genDetails['imgMsg'] = 'Drop Image here';
    //   this.genDetails['imgClickHere'] = '';

    //   this.$refs['msg'].style.border = '5px dotted black';
    // },
    // imageDragLeave: function () {
    //   (this.genDetails['imgMsg'] = ''), (this.genDetails['imgClickHere'] = 'Click Here !');
    //   this.$refs['msg'].style.border = 'none';
    // },
    // fileInsert: function (e) {
    //   this.genDetails['hasImage'] = true;
    //   this.imageDragLeave();

    //   const imageData = [];
    //   const file = e['target']['files'][0];
    //   if (!file['type'].includes('image/')) {
    //     this.clearImage();
    //     this.genDetails['imgDetails'] = 'Please input an Image file!';
    //     setTimeout(() => {
    //       this.genDetails['imgDetails'] = 'No Image Inserted';
    //     }, 3000);
    //   } else {
    //     imageData.push(file);
    //     const image = window.URL.createObjectURL(new Blob(imageData, { type: 'image/*' }));
    //     this.genDetails['imgSrc'] = image;

    //     if (!this.genDetails['imgSrc']) {
    //       this.$showAlert('error', 'Fail to attach image', 'Please try again.');
    //       this.genDetails['imgSrc'] = '';
    //       this.genDetails['hasImage'] = false;
    //     } else {
    //       const imageName = e['target']['files'][0]['name'];
    //       this.genDetails['imgDetails'] = `File name: ${imageName}`;
    //     }
    //   }
    // },
    clearBrandNewAllTabs: function () {
      //#region Gen Det
      this.genDetails['empName'] = '';
      this.genDetails['hasImage'] = false;
      this.genDetails['imgSrc'] = '';
      this.genDetails['imgDetails'] = 'No Image Inserted';
      this.genDetails['imgClickHere'] = 'Click here! ';
      this.genDetails['employeeImage'] = null;
      this.genDetails['savedPhoto'] = '';
      this.genDetails['status'] = '';
      this.genDetails['nationality'] = null;
      this.genDetails['disabled'] = false;
      this.genDetails['nricNew1'] = '';
      this.genDetails['nricNew2'] = '';
      this.genDetails['nricNew3'] = '';
      this.genDetails['nricNew'] = '';
      this.genDetails['nricOld'] = '';
      this.genDetails['pob'] = '';
      this.genDetails['dateofbirth'] = null;
      this.genDetails['age'] = '';
      this.genDetails['gender'] = null;
      this.genDetails['religion'] = null;
      this.genDetails['race'] = null;
      this.genDetails['ethnicity'] = null;
      this.genDetails['maritalStat'] = null;
      this.genDetails['spouseName'] = '';
      this.genDetails['dateJoined'] = null;
      this.genDetails['dateLeft'] = null;
      this.genDetails['dateConfirmed'] = null;
      this.genDetails['employmentDur'] = '';
      this.disabled = false;
      //#endregion

      //#region Other Det
      this.cashChecked = false;
      this.chequeChecked = false;
      this.otherDetails['employmentType'] = null;
      this.otherDetails['contractStart'] = null;
      this.otherDetails['contractEnd'] = null;
      this.otherDetails['branch'] = null;
      this.otherDetails['dept'] = null;
      this.otherDetails['jobTitle'] = '';
      this.otherDetails['superior'] = null;
      this.otherDetails['shift'] = null;
      this.otherDetails['totalWorkingHrs'] = '';
      this.otherDetails['incomeTaxNo'] = '';
      this.otherDetails['epfNo'] = '';
      this.otherDetails['socsoNo'] = '';
      this.otherDetails['incomeTaxCategory'] = null;
      this.otherDetails['epfCategory'] = null;
      this.otherDetails['socsoCategory'] = null;
      this.otherDetails['skbbkCategory'] = null;
      this.otherDetails['drivingLicenseNo'] = '';
      this.otherDetails['expirydatedl'] = null;
      this.otherDetails['drivingClass'] = [];
      this.otherDetails['badgeLicenseNo'] = '';
      this.otherDetails['expirydatebl'] = null;
      this.otherDetails['portPassNo'] = '';
      this.otherDetails['expirydatepp'] = null;
      this.otherDetails['commisionCode'] = null;
      this.otherDetails['payrollTypes'] = '';
      this.otherDetails['payrollBank'] = null;
      this.otherDetails['payrollAccNo'] = '';
      this.otherDetails['otFormula'] = null;

      //#endregion

      //#region Contact Det
      this.contactDetails['defaultAddressData']['addressLine1'] = '';
      this.contactDetails['defaultAddressData']['addressLine2'] = '';
      this.contactDetails['defaultAddressData']['addressLine3'] = '';
      this.contactDetails['defaultAddressData']['addressLine4'] = '';
      this.contactDetails['defaultAddressData']['postcode'] = '';
      this.contactDetails['defaultAddressData']['city'] = '';
      this.contactDetails['defaultAddressData']['state'] = '';
      this.contactDetails['defaultAddressData']['country'] = '';
      this.contactDetails['defaultPhone'] = '';
      this.contactDetails['defaultMobile'] = '';
      this.contactDetails['defaultEmail1'] = '';
      this.contactDetails['defaultEmail2'] = '';
      this.contactDetails['postalAddressData']['addressLine1'] = '';
      this.contactDetails['postalAddressData']['addressLine2'] = '';
      this.contactDetails['postalAddressData']['addressLine3'] = '';
      this.contactDetails['postalAddressData']['addressLine4'] = '';
      this.contactDetails['postalAddressData']['postcode'] = '';
      this.contactDetails['postalAddressData']['city'] = '';
      this.contactDetails['postalAddressData']['state'] = '';
      this.contactDetails['postalAddressData']['country'] = '';
      this.contactDetails['postalPhone'] = '';
      this.contactDetails['postalMobile'] = '';
      this.contactDetails['postalEmail1'] = '';
      this.contactDetails['postalEmail2'] = '';
      this.contactDetails['kinName'] = '';
      this.contactDetails['kinRelationship'] = '';
      this.contactDetails['kinAddressData']['addressLine1'] = '';
      this.contactDetails['kinAddressData']['addressLine2'] = '';
      this.contactDetails['kinAddressData']['addressLine3'] = '';
      this.contactDetails['kinAddressData']['addressLine4'] = '';
      this.contactDetails['kinAddressData']['postcode'] = '';
      this.contactDetails['kinAddressData']['city'] = '';
      this.contactDetails['kinAddressData']['state'] = '';
      this.contactDetails['kinAddressData']['country'] = '';
      this.contactDetails['kinPhone'] = '';
      this.contactDetails['showNominee'] = false;
      this.contactDetails['nomineeName'] = '';
      this.contactDetails['nomineeNRIC'] = '';
      this.contactDetails['nomineeType'] = null;
      this.contactDetails['nomineePercentage'] = '';
      this.contactDetails['nomineeRelationship'] = '';

      //#endregion

      this.grade = null;
      this.grossSalary = '';
      this.qualification = '';
      this.familyDetails['noOfChildren'] = '';
      this.familyDetails['noOfChildrenForTaxRebate'] = '';
    },
    menuClicked: async function (e) {
      this.clearTabFields(); // ?
      this.clearBrandNewAllTabs(); // clear input fields
      this.clearEntryMessages(); // clear popup entry properties
      switch (e['title']) {
        case 'New Employee':
          this.viewBtn = false;
          this.viewModeCareer = false;
          this.popupEntryShow = true;
          this.popupEntryTitle = 'New Employee';
          this.action = 'N';
          this.updatedBy = '';
          this.createdBy = '';
          this.terminationStatusIsDisable = true;
          this.statusField = true;
          this.genDetails['status'] = 'I = IN/AVAILABLE';
          this.nomineeList = [];
          this.employmentList = [];
          this.documentsList = [];
          this.familyDetList = [];
          this.careerList = [];

          this.educationList = [];
          this.deletedNomineeList = [];
          this.deletedEmploymentList = [];
          this.deletedDocumentsList = [];
          this.deletedFamilyDetList = [];
          this.deletedCareerList = [];
          this.deletedEducationList = [];
          break;
        case 'Edit Employee':
          if (this.selectedEmp.length == 0) {
            this.$showAlert('error', 'No Employee Selected', 'Please select an employee to edit');
          } else {
            this.$fullscreenLoading('Getting Employee Details');
            const selectedEmp = this.selectedEmp[0]['Employee ID'];
            this.action = 'E';
            const employeeDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
              masterfile: 'EMPLOYEE',
              recordid: selectedEmp,
            });
            if (
              !['RETIRED', 'RESIGNED', 'DECEASED', 'TERMINATED'].includes(employeeDetails['Employee']['Staff Status'])
            ) {
              this.viewBtn = false;
              this.popupEntryShow = true;
              this.popupEntryTitle = 'Edit Employee';
              this.statusField = false;
              this.nomineeList = [];
              this.employmentList = [];
              this.documentsList = [];
              this.familyDetList = [];
              this.careerList = [];
              this.educationList = [];
              this.deletedNomineeList = [];
              this.deletedEmploymentList = [];
              this.deletedDocumentsList = [];
              this.deletedFamilyDetList = [];
              this.deletedCareerList = [];
              this.deletedEducationList = [];
              this.populateEmployee(employeeDetails);
              this.$fullscreenLoading();
              this.terminationStatusIsDisable = true;
            } else {
              const confirmCancel = await this.$showAlert(
                'warning',
                'Edit Employee',
                `This Employee is ${employeeDetails['Employee']['Staff Status']}.\nAre you sure to edit the employee profile ?`,
                [
                  { text: 'Yes', color: 'indianred', textColor: 'white' },
                  { text: 'No', color: 'lightgray', textColor: 'black' },
                ],
              );
              switch (confirmCancel) {
                case 'Yes':
                  {
                    this.viewModeCareer = true;
                    this.viewBtn = false;
                    this.popupEntryShow = true;
                    this.popupEntryTitle = 'Edit Employee';
                    this.statusField = false;
                    this.nomineeList = [];
                    this.employmentList = [];
                    this.documentsList = [];
                    this.familyDetList = [];
                    this.careerList = [];
                    this.educationList = [];
                    this.deletedNomineeList = [];
                    this.deletedEmploymentList = [];
                    this.deletedDocumentsList = [];
                    this.deletedFamilyDetList = [];
                    this.deletedCareerList = [];
                    this.deletedEducationList = [];
                    this.populateEmployee(employeeDetails);
                    this.$fullscreenLoading();
                    this.terminationStatusIsDisable = true;
                  }

                  break;
                case 'No':
                  {
                    this.populateEmployee(employeeDetails);
                    this.$fullscreenLoading();
                  }
                  break;
              }
            }
          }
          break;
        case 'Delete Employee':
          if (this.selectedEmp.length == 0) {
            this.$showAlert('error', 'No Employee Selected', 'Please select an employee to delete.');
          } else {
            this.showDeletePopup = true;
          }
          break;
        case 'View Employee':
          if (this.selectedEmp.length == 0) {
            this.$showAlert('error', 'No Employee Selected', 'Please select an employee to view.');
          } else {
            this.viewBtn = true;
            this.popupEntryShow = true;
            this.popupEntryTitle = 'View Employee';
            this.viewMode = true;
            this.viewModeCareer = true;
            this.statusField = true;
            this.$fullscreenLoading('Getting Employee Details');
            const selectedEmp = this.selectedEmp[0]['Employee ID'].trim();
            const employeeDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
              masterfile: 'EMPLOYEE',
              recordid: selectedEmp,
            });
            if ('Contact' in employeeDetails['Employee']) {
              if (employeeDetails['Employee']['Contact'].length == 1) this.postalChecked = true;
            }
            this.populateEmployee(employeeDetails);
            this.$fullscreenLoading();
            if (employeeDetails['Employee']['Staff Status'] == 'IN/AVAILABLE') {
              this.terminationStatusIsDisable = true;
            } else {
              this.terminationStatusIsDisable = false;
            }
          }
          break;
        case 'New Duplicate':
          if (this.selectedEmp.length == 0) {
            this.$showAlert('error', 'No Employee Selected', 'Please select an employee to duplicate.');
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = 'New Duplicate Employee';
            this.action = 'N';
            this.$fullscreenLoading('Duplicating Employee Details');
            const selectedEmp = this.selectedEmp[0]['Employee ID'].trim();
            const employeeDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
              masterfile: 'EMPLOYEE',
              recordid: selectedEmp,
            });
            // Added a new parameter for new duplicate
            this.populateEmployee(employeeDetails, 'New Duplicate');

            this.empNo = '';
            this.$refs['employeeno'].setFocus();
            this.$fullscreenLoading();
          }
          break;
        case 'Terminate Employee': {
          if (this.selectedEmp.length == 0) {
            this.$showAlert('error', 'No Employee Selected', 'Please select an employee to terminate.');
            break;
          }
          const selectedEmp = this.selectedEmp[0]['Employee ID'];
          const employeeDetails = await this.$apiCallV2(
            //   `/Employee/GetDetailsMaster?masterfile=employee&module=null&recordid=${selectedEmp}`,
            // );
            '/Master/GetDetailsMaster',
            { masterfile: 'EMPLOYEE', recordid: selectedEmp },
          );

          if (employeeDetails['Employee']['Staff Status'] != 'IN/AVAILABLE') {
            this.$showAlert(
              'error',
              'Employee Already Terminated',
              'This employee has already been terminated and cannot be terminated again.',
            );
          } else {
            this.showTerminatePopup = true;
            this.terminateDate = new Date();
            this.selectedTerminateType = null;
            this.terminateRemarksText = '';
            this.terminateDateError = '';
            this.terminateTypeError = '';
            this.terminateEmployeeNo = this.selectedEmp[0]['Employee ID'];
          }
          break;
        }
        default:
          this.$showAlert('error', 'An error occurred', 'Please try again later');
          break;
      }
    },

    deletePopupButtonClicked: async function (e) {
      switch (e) {
        case 'Delete': {
          this.showDeletePopup = false;
          this.$fullscreenLoading('Deleting Selected Employee');
          const deleteResult = await this.$apiCallV2('/Employee/SaveEmployee', {
            action: 'D',
            employeeno: this.selectedEmp[0]['Employee ID'],
          });
          this.$fullscreenLoading();
          this.deleteRemarks = '';

          if (deleteResult[0]['Results'] == 0) {
            this.$showAlert(
              'success',
              'Deleted!',
              `Employee ${this.selectedEmp[0]['Employee ID']} was successfully deleted.`,
            );

            this.empList = [];
            this.selectedEmp = [];
            this.$nextTick(async () => await this.getEmployees());
          } else {
            this.$showAlert(
              'error',
              'Not Deleted',
              `There was an error occurred while deleting your job. Please try again.`,
            );
            this.empList = [];
            this.selectedEmp = [];
            this.$nextTick(async () => await this.getEmployees());
          }
          break;
        }
        case 'Cancel':
          this.deleteRemarks = '';
          this.selectedEmp = [];
          this.showDeletePopup = false;
          break;
      }
    },

    getEmployees: async function () {
      this.empLoading = true;
      this.$fullscreenLoading('Getting Employees');

      this.empList = [];
      this.selectedEmp = [];
      // await this.$nextTick();
      this.empList = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'EMPLOYEE', module: 'MASTER' });
      this.$fullscreenLoading();
      this.empLoading = false;
    },
    // Added a new parameter 'context' to populateEmployee function.
    // Ensure that 'context' only affects the 'New Duplicate' case,
    // so it does not interfere with the 'New Employee' action.
    // if called action === n will affect the new employee's populate, will empty the array, which is a bug.
    populateEmployee: async function (employeeDetails, context) {
      const filename = employeeDetails['Employee']['Staff Photo'].trim();
      const selectedrefno = employeeDetails['Employee']['Staff No'].trim();
      this.newAttachments = await this.$apiCallV2(
        `/Employee/GetMasterFileAttachments?tablename=EMPLOYEE&refno=${selectedrefno}&filename=${filename}`,
      );

      if (this.newAttachments.length != 0) {
        this.genDetails['employeeImage64'] = await this.newAttachments['0']['Attachment'];
        this.genDetails['employeeImageID'] = this.newAttachments['0']['ID'];
        this.genDetails['employeeImage'] = 'data:image/png;base64,' + this.genDetails['employeeImage64'];
      }

      this.contactDetails['showNominee'] = false;
      this.createdBy = `${
        !employeeDetails['Employee']['Created By'] ? ''
        : employeeDetails['Employee']['Created By'] ? employeeDetails['Employee']['Created By'].trim()
        : ''
      } ${employeeDetails['Employee']['Date Created'] ? new Date(employeeDetails['Employee']['Date Created']).formatString('dd/MM/yyyy HH:mm').trim() : ''}`;
      this.updatedBy = `${!employeeDetails['Employee']['Updated By'] ? '' : employeeDetails['Employee']['Updated By'].trim()} ${new Date(employeeDetails['Employee']['Last Update']).formatString('dd/MM/yyyy HH:mm')}`;

      this.lastUpdate = `${new Date(employeeDetails['Employee']['Last Update']).formatString('yyyy-MM-dd HH:mm:ss')}`;
      //#region General Details
      this.empNo = !employeeDetails['Employee']['Staff No'] ? '' : employeeDetails['Employee']['Staff No'];
      this.genDetails['empName'] =
        !employeeDetails['Employee']['Staff Name'] ? '' : employeeDetails['Employee']['Staff Name'];
      this.genDetails['status'] =
        !employeeDetails['Employee']['Staff Status'] ? '' : employeeDetails['Employee']['Staff Status'];
      this.genDetails['dateLeft'] =
        employeeDetails['Employee']['Staff End Date'] ? new Date(employeeDetails['Employee']['Staff End Date']) : null;
      this.genDetails['nationality'] =
        !employeeDetails['Employee']['Staff Nationality'] ?
          null
        : this.genDetailsData['nationality'].find((i) => {
            return (
              i['Country'].trim() == employeeDetails['Employee']['Staff Nationality'].trim() ||
              i['Country'].trim().startsWith(employeeDetails['Employee']['Staff Nationality'])
            );
          });
      this.genDetails['nricNew'] =
        !employeeDetails['Employee']['Staff NRIC'] ? '' : employeeDetails['Employee']['Staff NRIC'];
      if (this.genDetails['nricNew']) {
        const nric = this.genDetails['nricNew'].split('-');
        this.genDetails['nricNew1'] = nric[0];
        this.genDetails['nricNew2'] = nric[1];
        this.genDetails['nricNew3'] = nric[2];
      } else {
        this.genDetails['nricNew1'] = '';
        this.genDetails['nricNew2'] = '';
        this.genDetails['nricNew3'] = '';
      }
      this.genDetails['dateofbirth'] =
        employeeDetails['Employee']['Staff Birthday'] ? new Date(employeeDetails['Employee']['Staff Birthday']) : null;
      this.genDetails['gender'] =
        !employeeDetails['Employee']['Staff Gender'] ?
          null
        : this.genDetailsData['gender'].find((i) => {
            return (
              i['Gender'].trim() == employeeDetails['Employee']['Staff Gender'].trim() ||
              i['Gender'].trim().startsWith(employeeDetails['Employee']['Staff Gender'].trim())
            );
          });
      this.genDetails['race'] =
        !employeeDetails['Employee']['Staff Race'] ?
          null
        : this.genDetailsData['race'].find((i) => {
            return (
              i['Race'].trim() == employeeDetails['Employee']['Staff Race'].trim() ||
              i['Race'].trim().startsWith(employeeDetails['Employee']['Staff Race'].trim())
            );
          });
      this.genDetails['maritalStat'] =
        !employeeDetails['Employee']['Staff Marital'] ?
          null
        : this.genDetailsData['maritalStat'].find((i) => {
            return (
              i['Marital Status'].trim() == employeeDetails['Employee']['Staff Marital'].trim() ||
              i['Marital Status'].trim().startsWith(employeeDetails['Employee']['Staff Marital'].trim())
            );
          });
      this.genDetails['dateJoined'] =
        employeeDetails['Employee']['Staff Start Date'] ?
          new Date(employeeDetails['Employee']['Staff Start Date'])
        : null;
      this.genDetails['dateConfirmed'] =
        employeeDetails['Employee']['Date Confirmed'] ? new Date(employeeDetails['Employee']['Date Confirmed']) : null;
      this.genDetails['pob'] =
        !employeeDetails['Employee']['Staff Birthplace'] ? '' : employeeDetails['Employee']['Staff Birthplace'];
      this.genDetails['nricOld'] =
        !employeeDetails['Employee']['Staff Old NRIC'] ? '' : employeeDetails['Employee']['Staff Old NRIC'];
      this.genDetails['age'] =
        !employeeDetails['Employee']['Staff Birthday'] ? '' : employeeDetails['Employee']['Staff Birthday'];

      this.genDetails['religion'] =
        !employeeDetails['Employee']['Staff Religion'] ?
          null
        : this.genDetailsData['religion'].find((i) => {
            return (
              i['Religion'].trim() == employeeDetails['Employee']['Staff Religion'].trim() ||
              i['Religion'].trim().startsWith(employeeDetails['Employee']['Staff Religion'].trim())
            );
          });

      let tempethnicity = '';
      if (employeeDetails['Employee']['Ethnic'] == 'Y') tempethnicity = 'BUMI';
      else if (employeeDetails['Employee']['Ethnic'] == 'N') tempethnicity = 'Non-Bumi';
      else tempethnicity = '';

      this.genDetails['ethnicity'] =
        !employeeDetails['Employee']['Ethnic'] ?
          null
        : this.genDetailsData['ethnicity'].find((i) => {
            return i['Ethnic'].trim() == tempethnicity.trim() || i['Ethnic'].trim().startsWith(tempethnicity.trim());
          });
      this.genDetails['spouseName'] =
        !employeeDetails['Employee']['Staff Spouse'] ? '' : employeeDetails['Employee']['Staff Spouse'];
      this.genDetails['employmentDur'] =
        this.genDetails['dateJoined'] ? this.getEmploymentDuration(this.genDetails['dateJoined']) : null;
      if (employeeDetails['Employee']['Disabled'] == 'Y') {
        this.genDetails['disablecheck'] = true;
      } else {
        this.genDetails['disablecheck'] = false;
      }
      this.eInvoiceTIN = employeeDetails['Employee']['Tin'] ?? '';
      //#endregion View General Details

      //#region  View Other Details
      this.otherDetails['employmentType'] =
        !employeeDetails['Employee']['Staff Temp'] ?
          null
        : this.otherDetailsData['employmentType'].find((i) => {
            return (
              i['EmploymentType'].trim() == employeeDetails['Employee']['Staff Temp'].trim() ||
              i['EmploymentType'].trim().startsWith(employeeDetails['Employee']['Staff Temp'].trim())
            );
          });
      this.otherDetails['contractStart'] =
        employeeDetails['Employee']['Contract Start'] ? new Date(employeeDetails['Employee']['Contract Start']) : null;
      this.otherDetails['contractEnd'] =
        employeeDetails['Employee']['Contract End'] ? new Date(employeeDetails['Employee']['Contract End']) : null;
      this.otherDetails['branch'] =
        !employeeDetails['Employee']['Branch Code'] ?
          null
        : this.otherDetailsData['branch'].find((i) => {
            return (
              i['Branch Code'].trim() == employeeDetails['Employee']['Branch Code'].trim() ||
              i['Branch Code'].trim().startsWith(employeeDetails['Employee']['Branch Code'].trim())
            );
          });
      this.otherDetails['dept'] =
        !employeeDetails['Employee']['Staff Department'] ?
          null
        : this.otherDetailsData['dept'].find((i) => {
            return (
              i['ID'].trim() == employeeDetails['Employee']['Staff Department'].trim() ||
              i['ID'].trim().startsWith(employeeDetails['Employee']['Staff Department'].trim())
            );
          });
      this.otherDetails['jobTitle'] =
        !employeeDetails['Employee']['Staff Position'] ? '' : employeeDetails['Employee']['Staff Position'];
      this.otherDetails['superior'] =
        !employeeDetails['Employee']['Staff No'] ?
          null
        : this.otherDetailsData['superior'].find((i) => {
            return (
              (i['EmployeeID'] ?? '').trim() ==
                (employeeDetails['Employee']['Stoptional Staff Superior No'] ?? '').trim() ||
              (i['EmployeeID'] ?? '')
                .trim()
                .startsWith((employeeDetails['Employee']['Stoptional Staff Superior No'] ?? '').trim())
            );
          });
      this.otherDetails['shift'] =
        !employeeDetails['Employee']['Staff Shift Option'] ?
          null
        : this.otherDetailsData['shift'].find((i) => {
            return (
              i['Shift'].trim() == employeeDetails['Employee']['Staff Shift Option'].trim() ||
              i['Shift'].trim().startsWith(employeeDetails['Employee']['Staff Shift Option'].trim())
            );
          });
      this.otherDetails['totalWorkingHrs'] =
        !employeeDetails['Employee']['Staff Work Hours'] ? '' : employeeDetails['Employee']['Staff Work Hours'];
      this.otherDetails['incomeTaxNo'] =
        !employeeDetails['Employee']['Staff Income Tax'] ? '' : employeeDetails['Employee']['Staff Income Tax'];
      this.otherDetails['epfNo'] =
        !employeeDetails['Employee']['Staff EPFNo'] ? '' : employeeDetails['Employee']['Staff EPFNo'];
      this.otherDetails['socsoNo'] =
        !employeeDetails['Employee']['Staff SOCSO'] ? '' : employeeDetails['Employee']['Staff SOCSO'];
      this.otherDetails['incomeTaxCategory'] =
        !employeeDetails['Employee']['Income Tax Category'] ?
          null
        : this.otherDetailsData['incomeTaxCategory'].find((i) => {
            return (
              i['IncTaxCategory'].trim() == employeeDetails['Employee']['Income Tax Category'].trim() ||
              i['IncTaxCategory'].trim().startsWith(employeeDetails['Employee']['Income Tax Category'].trim())
            );
          });
      this.otherDetails['epfCategory'] =
        !employeeDetails['Employee']['EPF Category'] ?
          null
        : this.otherDetailsData['epfCategory'].find((i) => {
            return (
              i['EPFCategory'].trim() == employeeDetails['Employee']['EPF Category'].trim() ||
              i['EPFCategory'].trim().startsWith(employeeDetails['Employee']['EPF Category'].trim())
            );
          });
      this.otherDetails['socsoCategory'] =
        !employeeDetails['Employee']['SOCSO Category'] ?
          null
        : this.otherDetailsData['socsoCategory'].find((i) => {
            return (
              i['SocsoCategory'].trim() == employeeDetails['Employee']['SOCSO Category'].trim() ||
              i['SocsoCategory'].trim().startsWith(employeeDetails['Employee']['SOCSO Category'].trim())
            );
          });
      this.otherDetails['skbbkCategory'] =
        !employeeDetails['Employee']['SKBBK Category'] ?
          null
        : this.otherDetailsData['skbbkCategory'].find((i) => { // Using same data as socscoCategory hence i['SocsoCategory']
            return (
              i['SocsoCategory'].trim() == employeeDetails['Employee']['SKBBK Category'].trim() ||
              i['SocsoCategory'].trim().startsWith(employeeDetails['Employee']['SKBBK Category'].trim())
            );
          });
      this.otherDetails['drivingLicenseNo'] =
        !employeeDetails['Employee']['Staff Driving License'] ?
          ''
        : employeeDetails['Employee']['Staff Driving License'];
      this.otherDetails['expirydatedl'] =
        employeeDetails['Employee']['Staff Driving License EXP Date'] ?
          new Date(employeeDetails['Employee']['Staff Driving License EXP Date'])
        : null;
      // this.otherDetails['drivingClass']  = !employeeDetails['Employee']['Staff Driving Classes'] ? null : this.otherDetailsData['drivingClass'].find(i => {
      //   return i['Class'].trim() == employeeDetails['Employee']['Staff Driving Classes'].trim() || i['Class'].trim().startsWith(employeeDetails['Employee']['Staff Driving Classes'].trim())
      // });
      this.otherDetails['badgeLicenseNo'] =
        !employeeDetails['Employee']['Staff Badge License'] ? '' : employeeDetails['Employee']['Staff Badge License'];
      this.otherDetails['expirydatebl'] =
        employeeDetails['Employee']['Staff Badge License EXP Date'] ?
          new Date(employeeDetails['Employee']['Staff Badge License EXP Date'])
        : null;
      this.otherDetails['portPassNo'] =
        !employeeDetails['Employee']['Staff Port Pass No'] ? '' : employeeDetails['Employee']['Staff Port Pass No'];
      this.otherDetails['expirydatepp'] =
        employeeDetails['Employee']['Staff Port Pass EXP Date'] ?
          new Date(employeeDetails['Employee']['Staff Port Pass EXP Date'])
        : null;
      this.otherDetails['commisionCode'] =
        !employeeDetails['Employee']['Commision Code'] ?
          null
        : this.otherDetailsData['commisionCode'].find((i) => {
            return (
              i['Com Code'].trim() == employeeDetails['Employee']['Commision Code'].trim() ||
              i['Com Code'].trim().startsWith(employeeDetails['Employee']['Commision Code'].trim())
            );
          });
      const paymentType =
        !employeeDetails['Employee']['Pay Payment Type'] ? '' : employeeDetails['Employee']['Pay Payment Type'];
      if (paymentType == 'CS') {
        this.cashChecked = true;
        this.chequeChecked = false;
        this.otherDetails['payrollTypes'] = paymentType;
      } else if (paymentType == 'CH') {
        this.cashChecked = false;
        this.chequeChecked = true;
        this.otherDetails['payrollTypes'] = paymentType;
      }
      this.otherDetails['payrollBank'] =
        !employeeDetails['Employee']['Pay Bank Code'] ?
          null
        : this.otherDetailsData['payrollBank'].find((i) => {
            return (
              i['Bank Code'].trim() == employeeDetails['Employee']['Pay Bank Code'].trim() ||
              i['Bank Code'].trim().startsWith(employeeDetails['Employee']['Pay Bank Code'].trim())
            );
          });
      this.otherDetails['payrollAccNo'] = employeeDetails['Employee']['Pay Bank Account No'] || '';
      this.otherDetails['otFormula'] =
        !employeeDetails['Employee']['OT Formula Code'] ?
          null
        : this.otherDetailsData['otFormula'].find((i) => {
            return (
              i['Formula Code'].trim() == employeeDetails['Employee']['OT Formula Code'].trim() ||
              i['Formula Code'].trim().startsWith(employeeDetails['Employee']['OT Formula Code'].trim())
            );
          });

      //default
      this.contactDetails['defaultAddressData']['addressLine1'] =
        !employeeDetails['Employee']['Staff Addr1'] ? '' : employeeDetails['Employee']['Staff Addr1'];
      this.contactDetails['defaultAddressData']['addressLine2'] =
        !employeeDetails['Employee']['Staff Addr2'] ? '' : employeeDetails['Employee']['Staff Addr2'];
      this.contactDetails['defaultAddressData']['addressLine3'] =
        !employeeDetails['Employee']['Staff Addr3'] ? '' : employeeDetails['Employee']['Staff Addr3'];
      this.contactDetails['defaultAddressData']['addressLine4'] =
        !employeeDetails['Employee']['Staff Addr4'] ? '' : employeeDetails['Employee']['Staff Addr4'];
      this.contactDetails['defaultAddressData']['city'] =
        !employeeDetails['Employee']['Staff Addr City'] ? '' : employeeDetails['Employee']['Staff Addr City'];

      this.contactDetails['defaultAddressData']['country'] =
        !employeeDetails['Employee']['Staff Addr Country'] ? '' : employeeDetails['Employee']['Staff Addr Country'];
      // this.contactDetails['defaultAddressData']['selectedCountry'] = !employeeDetails['Employee']['Staff Addr Country'] ? null : this.contactDetails['defaultAddressData']['countryItems'].find(i => {
      //   return i['Country'].trim() == employeeDetails['Employee']['Staff Addr Country'].trim() || i['Country'].trim().startsWith(employeeDetails['Employee']['Staff Default Addr Country'])
      // });

      this.contactDetails['defaultAddressData']['postcode'] =
        !employeeDetails['Employee']['Staff Addr Postcode'] ? '' : employeeDetails['Employee']['Staff Addr Postcode'];
      // this.contactDetails['defaultAddressData']['selectedPostcode'] = !employeeDetails['Employee']['Staff Addr Postcode'] ? null : this.contactDetails['defaultAddressData']['postcodeItems'].find(i => {
      //   return i['PostCode'].trim() == employeeDetails['Employee']['Staff Addr Postcode'].trim() || i['PostCode'].trim().startsWith(employeeDetails['Employee']['Staff Addr Postcode'])
      // });

      this.contactDetails['defaultAddressData']['state'] =
        !employeeDetails['Employee']['Staff Addr State'] ? '' : employeeDetails['Employee']['Staff Addr State'];
      // this.contactDetails['defaultAddressData']['selectedState'] = !employeeDetails['Employee']['Staff Addr State'] ? null : this.contactDetails['defaultAddressData']['stateItems'].find(i => {
      //   return i['State'].trim() == employeeDetails['Employee']['Staff Addr State'].trim() || i['State'].trim().startsWith(employeeDetails['Employee']['Staff Addr State'])
      // });

      this.contactDetails['defaultPhone'] =
        !employeeDetails['Employee']['Staff Tel No'] ? '' : employeeDetails['Employee']['Staff Tel No'];
      this.contactDetails['defaultMobile'] =
        !employeeDetails['Employee']['Staff Mobile No'] ? '' : employeeDetails['Employee']['Staff Mobile No'];
      this.contactDetails['defaultEmail1'] =
        !employeeDetails['Employee']['Staff Email1'] ? '' : employeeDetails['Employee']['Staff Email1'];
      this.contactDetails['defaultEmail2'] =
        !employeeDetails['Employee']['Staff Email2'] ? '' : employeeDetails['Employee']['Staff Email2'];

      //postal
      if ('Contact' in employeeDetails['Employee']) {
        this.contactDetails['postalAddressData']['addressLine1'] =
          !employeeDetails['Employee']['Contact']['0']['Addr1'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Addr1'];
        this.contactDetails['postalAddressData']['addressLine2'] =
          !employeeDetails['Employee']['Contact']['0']['Addr2'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Addr2'];
        this.contactDetails['postalAddressData']['addressLine3'] =
          !employeeDetails['Employee']['Contact']['0']['Addr3'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Addr3'];
        this.contactDetails['postalAddressData']['addressLine4'] =
          !employeeDetails['Employee']['Contact']['0']['Addr4'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Addr4'];
        this.contactDetails['postalAddressData']['city'] =
          !employeeDetails['Employee']['Contact']['0']['City'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['City'];

        this.contactDetails['postalAddressData']['country'] =
          !employeeDetails['Employee']['Contact']['0']['Country'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Country'];
        // this.contactDetails['postalAddressData']['selectedCountry'] = !employeeDetails['Employee']['Contact']['0']['Country'] ? null : this.contactDetails['defaultAddressData']['countryItems'].find(i => {
        //   return i['Country'].trim() == employeeDetails['Employee']['Contact']['0']['Country'].trim() || i['Country'].trim().startsWith(employeeDetails['Employee']['Contact']['0']['Country'].trim())
        // });

        this.contactDetails['postalAddressData']['postcode'] =
          !employeeDetails['Employee']['Contact']['0']['PostCode'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['PostCode'];
        // this.contactDetails['postalAddressData']['selectedPostcode'] = !employeeDetails['Employee']['Contact']['0']['Postcode'] ? null : this.contactDetails['defaultAddressData']['postcodeItems'].find(i => {
        //   return i['PostCode'].trim() == employeeDetails['Employee']['Contact']['0']['Postcode'].trim() || i['PostCode'].trim().startsWith(employeeDetails['Employee']['Contact']['0']['Postcode'].trim())
        // });

        this.contactDetails['postalAddressData']['country'] =
          !employeeDetails['Employee']['Contact']['0']['State'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['State'];
        // this.contactDetails['postalAddressData']['selectedState'] = !employeeDetails['Employee']['Contact']['0']['State'] ? null : this.contactDetails['defaultAddressData']['stateItems'].find(i => {
        //   return i['State'].trim() == employeeDetails['Employee']['Contact']['0']['State'].trim() || i['State'].trim().startsWith(employeeDetails['Employee']['Contact']['0']['State'].trim())
        // });

        this.contactDetails['postalPhone'] =
          !employeeDetails['Employee']['Contact']['0']['TelNo'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['TelNo'];
        this.contactDetails['postalMobile'] =
          !employeeDetails['Employee']['Contact']['0']['MobileNo'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['MobileNo'];
        this.contactDetails['postalEmail1'] =
          !employeeDetails['Employee']['Contact']['0']['Email'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Email'];
        this.contactDetails['postalEmail2'] =
          !employeeDetails['Employee']['Contact']['0']['Email2'] ?
            ''
          : employeeDetails['Employee']['Contact']['0']['Email2'];
      }

      this.contactDetails['kinName'] =
        !employeeDetails['Employee']['Staff Kin Name'] ? '' : employeeDetails['Employee']['Staff Kin Name'];
      this.contactDetails['kinRelationship'] =
        !employeeDetails['Employee']['Staff Kin Relationship'] ?
          ''
        : employeeDetails['Employee']['Staff Kin Relationship'];
      this.contactDetails['kinAddressData']['addressLine1'] =
        !employeeDetails['Employee']['Staff Kin Addr1'] ? '' : employeeDetails['Employee']['Staff Kin Addr1'];
      this.contactDetails['kinAddressData']['addressLine2'] =
        !employeeDetails['Employee']['Staff Kin Addr2'] ? '' : employeeDetails['Employee']['Staff Kin Addr2'];
      this.contactDetails['kinAddressData']['addressLine3'] =
        !employeeDetails['Employee']['Staff Kin Addr3'] ? '' : employeeDetails['Employee']['Staff Kin Addr3'];
      this.contactDetails['kinAddressData']['addressLine4'] =
        !employeeDetails['Employee']['Staff Kin Addr4'] ? '' : employeeDetails['Employee']['Staff Kin Addr4'];
      this.contactDetails['kinAddressData']['city'] =
        !employeeDetails['Employee']['Staff Kin Addr City'] ? '' : employeeDetails['Employee']['Staff Kin Addr City'];
      this.contactDetails['kinAddressData']['state'] =
        !employeeDetails['Employee']['Staff Kin Addr State'] ? '' : employeeDetails['Employee']['Staff Kin Addr State'];
      this.contactDetails['kinAddressData']['postcode'] =
        !employeeDetails['Employee']['Staff Kin Addr Postcode'] ?
          ''
        : employeeDetails['Employee']['Staff Kin Addr Postcode'];
      this.contactDetails['kinAddressData']['country'] =
        !employeeDetails['Employee']['Staff Kin Addr Country'] ?
          ''
        : employeeDetails['Employee']['Staff Kin Addr Country'];
      this.contactDetails['kinPhone'] =
        !employeeDetails['Employee']['Staff Kin Tel No'] ? '' : employeeDetails['Employee']['Staff Kin Tel No'];

      this.grade =
        !employeeDetails['Employee']['Grade'] ?
          null
        : this.careerData['grade'].find((i) => {
            return i['Grade Type'].trim() == employeeDetails['Employee']['Grade'].trim();
          });
      this.grossSalary = !employeeDetails['Employee']['Salary'] ? '' : employeeDetails['Employee']['Salary'];
      this.qualification =
        !employeeDetails['Employee']['Qualification'] ? '' : employeeDetails['Employee']['Qualification'];
      this.familyDetails['noOfChildren'] =
        !employeeDetails['Employee']['Children'] ? '' : employeeDetails['Employee']['Children'];
      this.familyDetails['noOfChildrenForTaxRebate'] =
        !employeeDetails['Employee']['Children Tax Rebate'] ? '' : employeeDetails['Employee']['Children Tax Rebate'];

      //#endregion

      let tempNomineeList = [];
      tempNomineeList = !employeeDetails['Employee']['Nominee'] ? [] : employeeDetails['Employee']['Nominee'];
      // const check = tempNomineeList['UserID'] ? 'Y' : '';
      // ensure the empty array only affected to new duplicate
      if (tempNomineeList.length == 0 || context === 'New Duplicate') this.nomineeList = [];
      else
        this.nomineeList = tempNomineeList.map((n) => {
          return {
            Name: n['NomineeName'],
            NRIC: n['NomineeNRIC'],
            Percentage: n['Percentage'],
            Type: n['NominationType'],
            Relationship: n['Relationship'],
          };
        });

      let tempEmplotmentList = [];
      let eID = 1;
      tempEmplotmentList = !employeeDetails['Employee']['Employment'] ? [] : employeeDetails['Employee']['Employment'];
      // ensure the empty array only affected to new duplicate
      if (tempEmplotmentList.length == 0 || context === 'New Duplicate') this.employmentList = [];
      else
        this.employmentList = tempEmplotmentList.map((n) => {
          return {
            Company: n['PrevCompany'],
            Position: n['PrevPosition'],
            'Reason Leaving': n['ReasonLeaving'],
            Remarks: n['Remarks'],
            'Date Joined': !n['DateStart'] ? '' : `${new Date(n['DateStart']).formatString('yyyy-MM-dd')}`,
            'Date Left': !n['DateEnd'] ? '' : `${new Date(n['DateEnd']).formatString('yyyy-MM-dd')}`,
            'Job Responsibilities': n['JobResponsibility'],
            'Company Tel No': n['PrevCompanyTelNo'],
            'Sequence No': n['Seq_No'],
            //temporary id
            ID: eID++,
          };
        });
      let tempFamilyDetList = [];
      tempFamilyDetList = !employeeDetails['Employee']['Kin'] ? [] : employeeDetails['Employee']['Kin'];
      // ensure the empty array only affected to new duplicate
      if (tempFamilyDetList.length == 0 || context === 'New Duplicate') this.familyDetList = [];
      else
        this.familyDetList = tempFamilyDetList.map((n) => {
          return {
            Relationship: n['Relationship'],
            Name: n['Name'],
            NRIC: n['NRIC'],
            'Date of Birth': n['DOB'] ? `${new Date(n['DOB']).formatString('yyyy-MM-dd')}` : '',
            'Tel No': n['TelNo'],
            'Mobile No': n['MobileNo'],
            Working: n['Working'] == 'Y' ? 'YES' : 'NO',
            Disabled: n['Disabled'] == 'Y' ? 'YES' : 'NO',
            'Living Together': n['LivingTogether'] == 'Y' ? 'YES' : 'NO',
            'Emergency Contact': n['EmergencyContact'] == 'Y' ? 'YES' : 'NO',
            Gender:
              n['Gender'] ?
                n['Gender'] == 'F' ? 'FEMALE'
                : n['Gender'] == 'M' ? 'MALE'
                : ''
              : '',
            'Birth Certificate No': n['BirthCertNo'],
            'Diploma/Degree Level': n['DiplomaDegree'] == 'Y' ? 'YES' : 'NO',
            'Kin ID': n['ID'],
          };
        });

      // this.careerList = employeeDetails['Employee']['Career'];
      let tempCareerList = [];
      tempCareerList = !employeeDetails['Employee']['Career'] ? [] : employeeDetails['Employee']['Career'];
      // ensure the empty array only affected to new duplicate
      if (tempCareerList.length == 0 || context === 'New Duplicate') this.careerList = [];
      else
        this.careerList = tempCareerList.map((n) => {
          return {
            'Effective Date': !n['DateCreated'] ? '' : `${new Date(n['DateCreated']).formatString('yyyy-MM-dd')}`,
            'Career ID': n['CareerID'],
            'Career Code': n['CareerCode'],
            Remarks: n['Remarks'],
            Notes: n['Notes1'],
            'Date Update': !n['DateUpdated'] ? '' : `${new Date(n['DateUpdated']).formatString('yyyy-MM-dd')}`,
            UserID: n['UserID'],
          };
        });

      let tempDocumentsList = [];
      let dID = 1;
      tempDocumentsList = !employeeDetails['Employee']['Document'] ? [] : employeeDetails['Employee']['Document'];
      // ensure the empty array only affected to new duplicate
      if (tempDocumentsList.length == 0 || context === 'New Duplicate') this.documentsList = [];
      else
        this.documentsList = tempDocumentsList.map((n) => {
          return {
            'Date Received': !n['Doc_RecDate'] ? '' : `${new Date(n['Doc_RecDate']).formatString('yyyy-MM-dd')}`,
            'Time Received': !n['Doc_RecTime'] ? '' : n['Doc_RecTime'],
            'Document Code': n['Doc_Code'],
            'Ref No': n['staff_no'],
            'Expiry Date': !n['DateClaimed'] ? '' : `${new Date(n['DateClaimed']).formatString('yyyy-MM-dd')}`,
            'Document Type':
              n['Doc_type'] == 'C' ? 'Copy'
              : n['Doc_type'] == 'F' ? 'Fax'
              : n['Doc_type'] == 'O' ? 'Original'
              : n['Doc_type'] == 'P' ? 'Photocopy'
              : n['Doc_type'] == 'S' ? 'Scanned File'
              : '',
            'Document Name': n['DocAtt'],
            'Document Date': !n['DocDate'] ? '' : `${new Date(n['DocDate']).formatString('yyyy-MM-dd')}`,
            Remarks: n['Remark'],
            'Attachment File': n['Image1'],
            'Sequence No': n['Seq_No'],
            'Document GUID': n['DocumentGUID'],
            // 'File Type' : n['ImageType'] ? '' : (n['DocAtt']).substring((n['DocAtt']).indexOf('.') ),
            'File Type': !n['ImageType'] ? '' : n['ImageType'],
            //temporary id
            ID: dID++,
          };
        });

      let tempEducationList = [];
      let edID = 1;
      tempEducationList = !employeeDetails['Employee']['Education'] ? [] : employeeDetails['Employee']['Education'];
      // ensure the empty array only affected to new duplicate
      if (tempEducationList.length == 0 || context === 'New Duplicate') this.educationList = [];
      else
        this.educationList = tempEducationList.map((n) => {
          return {
            'Company Code': n['Company_Code'],
            'Institute Name': n['InstituteName'],
            'Institute Category': n['InstituteCategory'],
            Qualification:
              !n['Qualification'] ? null
              : n['Qualification'].trim() == '1' ? 'PMR'
              : n['Qualification'].trim() == '2' ? 'SPM/O-Level'
              : n['Qualification'].trim() == '3' ? 'STPM/A-Level/STAM'
              : n['Qualification'].trim() == '4' ? 'Diploma Degree'
              : n['Qualification'].trim() == '5' ? 'Bachelor`s Degree'
              : n['Qualification'].trim() == '6' ? 'Master`s Degree'
              : n['Qualification'].trim() == '7' ? 'Professional Degree'
              : n['Qualification'].trim() == '8' ? 'Doctoral Degree'
              : '',
            Major: n['Major'],
            Grade: n['Grade'],
            'Graduate Year': !n['GraduateYear'] ? '' : `${new Date(n['GraduateYear']).formatString('yyyy-MM-dd')}`,
            From: !n['StartDate'] ? '' : `${new Date(n['StartDate']).formatString('yyyy-MM-dd')}`,
            To: !n['EndDate'] ? '' : `${new Date(n['EndDate']).formatString('yyyy-MM-dd')}`,
            Country: n['Country'],
            Remarks: n['Remarks'],
            'Sequence No': n['SeqNo'],
            //temporary id
            ID: edID++,
          };
        });
      //#region Employment History
      //#endregion

      //#region Document
      //#endregion

      //#region Family Details
      //#endregion

      //#region Career
      //#endregion

      //#region Education
      //#endregion
      //populate drivingClass start
      const drivingClass = employeeDetails['Employee']['Staff Driving Classes']
        .split(',')
        .map((element) => element.trim());
      this.otherDetails['drivingClass'] = this.otherDetailsData['drivingClass'].filter((item) =>
        drivingClass.includes(item['Class']),
      );
    },
    clearTabFields: function () {
      this.viewMode = false;
      this.lastUpdate = '';

      this.currentTab = 0;

      this.empNo = '';
      this.empNoError = '';
      this.empNameError = '';
      this.statusError = '';
      this.nationalityError = '';
      this.nricNewError1 = '';
      this.nricNewError2 = '';
      this.nricNewError3 = '';
      this.grossSalaryError = '';
      this.employmentTypeError = '';
      this.genderError = '';
      this.raceError = '';
      this.deptError = '';
      this.jobTitleError = '';
      this.dateofbirthError = '';
      this.dateJoinedError = '';
      this.branchError = '';
      this.drivingLicenseNoError = '';
      this.expirydatedlError = '';
      this.drivingClassError = '';
      this.badgeLicenseNoError = '';
      this.expirydateblError = '';
      this.portPassNoError = '';
      this.portPassExpiryError = '';
      this.commisionCodeError = '';
      this.payrollAccNoError = '';
      this.pobError = '';
      this.nricOldError = '';
      this.spouseNameError = '';
      this.incomeTaxNoError = '';
      this.epfNoError = '';
      this.socsoNoError = '';
      this.noOfChildrenError = '';
      this.noOfChildrenForTaxRebateError = '';
      this.lastUpdate = '';

      this.contactDetails['defaultAddressErrors']['addressLine1'] = '';
      this.contactDetails['defaultAddressErrors']['addressLine2'] = '';
      this.contactDetails['defaultAddressErrors']['addressLine3'] = '';
      this.contactDetails['defaultAddressErrors']['addressLine4'] = '';
      this.contactDetails['defaultAddressErrors']['postcode'] = '';
      this.contactDetails['defaultAddressErrors']['city'] = '';
      this.contactDetails['defaultAddressErrors']['state'] = '';
      this.contactDetails['defaultAddressErrors']['country'] = '';
      this.contactDetails['defaultPhoneError'] = '';
      this.contactDetails['defaultMobileError'] = '';
      this.contactDetails['defaultEmail1Error'] = '';
      this.contactDetails['defaultEmail2Error'] = '';
      this.contactDetails['postalAddressErrors']['addressLine1'] = '';
      this.contactDetails['postalAddressErrors']['addressLine2'] = '';
      this.contactDetails['postalAddressErrors']['addressLine3'] = '';
      this.contactDetails['postalAddressErrors']['addressLine4'] = '';
      this.contactDetails['postalAddressErrors']['postcode'] = '';
      this.contactDetails['postalAddressErrors']['city'] = '';
      this.contactDetails['postalAddressErrors']['state'] = '';
      this.contactDetails['postalAddressErrors']['country'] = '';
      this.contactDetails['postalPhoneError'] = '';
      this.contactDetails['postalMobileError'] = '';
      this.contactDetails['postalEmail1Error'] = '';
      this.contactDetails['postalEmail2Error'] = '';
      this.contactDetails['kinNameError'] = '';
      this.contactDetails['kinRelationshipError'] = '';
      this.contactDetails['kinAddressErrors']['addressLine1'] = '';
      this.contactDetails['kinAddressErrors']['addressLine2'] = '';
      this.contactDetails['kinAddressErrors']['addressLine3'] = '';
      this.contactDetails['kinAddressErrors']['addressLine4'] = '';
      this.contactDetails['kinAddressErrors']['postcode'] = '';
      this.contactDetails['kinAddressErrors']['city'] = '';
      this.contactDetails['kinAddressErrors']['state'] = '';
      this.contactDetails['kinAddressErrors']['country'] = '';
      this.contactDetails['kinPhoneError'] = '';

      this.showNomineeDetails = false;
      this.showDetails = false;
      this.showDocDetails = false;
      this.showFamilyDetails = false;
      this.showCareer = false;
      this.showEducation = false;

      this.selectedNominee = [];
      this.selectedEmployment = [];
      this.selectedDoc = [];
      this.selectedFamilyDet = [];
      this.selectedcareer = [];
      this.selectedEducation = [];

      this.eInvoiceTIN = '';

      // #region General Details data
      // #endregion

      // #region Employment History data
      // #endregion

      // #region Documents data
      // #endregion

      // #region Family Details data
      // #endregion

      // #region Career data
      // #endregion

      // #region Education data
      // #endregion
    },
    clearDetails: function (tab) {
      switch (tab) {
        case 'nominee':
          this.contactDetails['nomineeName'] = '';
          this.contactDetails['nomineeType'] = null;
          this.contactDetails['nomineeNRIC'] = '';
          this.contactDetails['nomineeNRIC1'] = '';
          this.contactDetails['nomineeNRIC2'] = '';
          this.contactDetails['nomineeNRIC3'] = '';
          this.contactDetails['nomineePercentage'] = '';
          this.contactDetails['nomineeRelationship'] = '';
          this.nomNameError = '';
          this.nomNRICError1 = '';
          this.nomNRICError2 = '';
          this.nomNRICError3 = '';
          this.nomPercentageError = '';
          this.nomineeTypeError = '';
          this.nomRelationshipError = '';
          break;
        case 'employment history':
          this.employmentHistory['companyName'] = '';
          this.employmentHistory['phoneNo'] = '';
          this.employmentHistory['position'] = '';
          this.employmentHistory['responsibilities'] = '';
          this.employmentHistory['reasonForLeaving'] = '';
          this.employmentHistory['remarks'] = '';
          this.employmentHistory['dateJoined'] = null;
          this.employmentHistory['dateLeft'] = null;
          this.employmentHistory['seqNo'] = '';
          this.employmentHistory['empID'] = '';
          this.companyNameError = '';
          this.phoneNoError = '';
          this.positionError = '';
          this.responsibilitiesError = '';
          this.reasonForLeavingError = '';
          this.remarksError = '';
          this.eDateJoinedError = '';
          this.eDateLeftError = '';
          break;
        case 'documents':
          this.documents['dateReceived'] = null;
          this.documents['expiryDate'] = null;
          this.documents['docCode'] = null;
          this.documents['docType'] = null;
          this.documents['refNo'] = '';
          this.documents['docDate'] = null;
          this.documents['docName'] = '';
          this.documents['docGuid'] = '';
          this.documents['filetype'] = null;
          this.documents['attachmentFile'] = null;
          this.documents['timeReceive'] = null;
          //this.$refs.docFile.clearAttachmentClicked();
          this.documents['remarks'] = '';
          this.documents['docID'] = '';
          this.docCodeError = '';
          this.docTypeError = '';
          this.refNoError = '';
          this.dRemarksError = '';
          break;
        case 'family details':
          this.familyDetails['kinName'] = '';
          this.familyDetails['kinNric'] = '';
          this.familyDetails['kinNric1'] = '';
          this.familyDetails['kinNric2'] = '';
          this.familyDetails['kinNric3'] = '';
          this.familyDetails['kinRelationship'] = null;
          this.familyDetails['kinGender'] = null;
          this.familyDetails['kinTel'] = '';
          this.familyDetails['kinMobile'] = '';
          this.familyDetails['kindob'] = null;
          this.familyDetails['kinBirthCertNo'] = '';
          this.familyDetails['kinIsWorking'] = '';
          this.familyDetails['kinIsDisabled'] = '';
          this.familyDetails['kinIsLivingTgt'] = '';
          this.familyDetails['kinIsEmergencyContact'] = '';
          this.familyDetails['kinIsWorkingCB'] = false;
          this.familyDetails['kinIsDisabledCB'] = false;
          this.familyDetails['kinIsLivingTgtCB'] = false;
          this.familyDetails['kinIsEmergencyContactCB'] = false;
          this.familyDetails['kinIsEducatedCB'] = false;
          this.familyDetails['kinIsEducated'] = '';
          this.familyDetails['seqNo'] = '';
          this.famNameError = '';
          this.famNRICError1 = '';
          this.famNRICError2 = '';
          this.famNRICError3 = '';
          this.famTelError = '';
          this.famMobileError = '';
          this.famBirthCertNoError = '';
          break;
        case 'career':
          this.career['notes'] = '';
          this.career['remarks'] = '';
          this.career['effectiveDate'] = null;
          this.career['code'] = null;
          this.career['seqNo'] = '';
          break;
        case 'education':
          this.education['companyCode'] = '';
          this.education['instituteName'] = '';
          this.education['instituteCategory'] = null;
          this.education['country'] = null;
          this.education['qualification'] = null;
          this.education['from'] = null;
          this.education['to'] = null;
          this.education['graduateYear'] = null;
          this.education['grade'] = '';
          this.education['major'] = '';
          this.education['remarks'] = '';
          this.education['seqNo'] = '';
          this.education['eduID'] = '';
          this.companyCodeError = '';
          this.instituteNameError = '';
          this.instituteCategoryError = '';
          this.countryError = '';
          this.fromError = '';
          this.toError = '';
          this.graduateError = '';
          this.gradeError = '';
          this.majorError = '';
          this.eRemarksError = '';
          break;
      }
    },
    clearEntryMessages: function () {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },
    entryRequiredClicked: function (item) {
      const tab = this.refToTabIndex[item] ? this.refToTabIndex[item] : 0;

      if (this.currentTab != tab && tab >= 0) {
        this.currentTab = tab;
      }

      this.$nextTick(() => {
        switch (item) {
          case 'defaultAddr1':
            this.$refs['defaultAddressForm'].setFocus('address1');
            break;
          case 'defaultAddr2':
            this.$refs['defaultAddressForm'].setFocus('address2');
            break;
          case 'defaultAddr3':
            this.$refs['defaultAddressForm'].setFocus('address3');
            break;
          case 'defaultAddr4':
            this.$refs['defaultAddressForm'].setFocus('address4');
            break;
          case 'defaultCity':
            this.$refs['defaultAddressForm'].setFocus('city');
            break;
          case 'postalAddr1':
            this.$refs['postalAddressForm'].setFocus('address1');
            break;
          case 'postalAddr2':
            this.$refs['postalAddressForm'].setFocus('address2');
            break;
          case 'postalAddr3':
            this.$refs['postalAddressForm'].setFocus('address3');
            break;
          case 'postalAddr4':
            this.$refs['postalAddressForm'].setFocus('address4');
            break;
          case 'postalCity':
            this.$refs['postalAddressForm'].setFocus('city');
            break;
          case 'kinAddr1':
            this.$refs['kinAddressForm'].setFocus('address1');
            break;
          case 'kinAddr2':
            this.$refs['kinAddressForm'].setFocus('address2');
            break;
          case 'kinAddr3':
            this.$refs['kinAddressForm'].setFocus('address3');
            break;
          case 'kinAddr4':
            this.$refs['kinAddressForm'].setFocus('address4');
            break;
          case 'kinCity':
            this.$refs['kinAddressForm'].setFocus('city');
            break;
          case 'drivingClass':
            this.$refs.filtersRef.showTableBoxPopup();
            break;
          default:
            this.$refs[item].setFocus();
            break;
        }
      });
    },
    saveClicked: function () {
      if (this.checkFields()) {
        return;
      }
      this.genDetails['nricNew'] =
        `${this.genDetails['nricNew1']}-${this.genDetails['nricNew2'].length == 1 ? '0' + this.genDetails['nricNew2'] : this.genDetails['nricNew2']}-${this.genDetails['nricNew3']}`;
      const newNomineeList = this.deletedNomineeList.concat(this.nomineeList);
      const newEmploymentList = this.deletedEmploymentList.concat(this.employmentList);
      const newDocumentsList = this.deletedDocumentsList.concat(this.documentsList);
      const newFamilyDetList = this.deletedFamilyDetList.concat(this.familyDetList);
      const newCareerList = this.deletedCareerList.concat(this.careerList);
      const newEducationList = this.deletedEducationList.concat(this.educationList);

      const userage = this.ageValue.toString();
      const employmentDur = this.employmentValue.toString();
      const dataToPost = {
        // overall
        employeeno: !this.empNo.trim() ? '' : this.empNo.trim(),
        //#region general details
        employeename: !this.genDetails['empName'] ? '' : this.genDetails['empName'],
        status: 'I', // I = IN/AVAILABLE, O = OUT OF OFFICE, T = TERMINATED
        nationality: !this.genDetails['nationality'] ? '' : this.genDetails['nationality']['Country'],
        nricnew: !this.genDetails['nricNew'] ? '' : this.genDetails['nricNew'],
        gender:
          this.genDetails['gender'] ?
            this.genDetails['gender'] == 'FEMALE' ?
              'F'
            : 'M'
          : '',
        race:
          this.genDetails['race'] ?
            this.genDetails['race']['Race'] == 'MALAY' ? 'M'
            : this.genDetails['race']['Race'] == 'CHINESE' ? 'C'
            : this.genDetails['race']['Race'] == 'INDIAN' ? 'I'
            : 'O'
          : '',
        religion: !this.genDetails['religion'] ? '' : this.genDetails['religion']['Religion'],
        dateofbirth:
          !this.genDetails['dateofbirth'] ? '' : this.genDetails['dateofbirth'].formatString('yyyy-MM-dd HH:mm'),
        maritalstatus: !this.genDetails['maritalStat'] ? '' : this.genDetails['maritalStat']['Marital Status'],
        placeofbirth: !this.genDetails['pob'] ? '' : this.genDetails['pob'],
        nricold: !this.genDetails['nricOld'] ? '' : this.genDetails['nricOld'],
        age: userage,
        ethnicity:
          this.genDetails['ethnicity'] ?
            this.genDetails['ethnicity']['Ethnic'] == 'Non-Bumi' ? 'N'
            : this.genDetails['ethnicity']['Ethnic'] == 'BUMI' ? 'Y'
            : ''
          : '',
        spousename: !this.genDetails['spouseName'] ? '' : this.genDetails['spouseName'],
        employmentDur: employmentDur,
        datejoined:
          this.genDetails['dateJoined'] ? this.genDetails['dateJoined'].formatString('yyyy-MM-dd HH:mm') : null,

        dateleft: this.genDetails['dateLeft'] ? this.genDetails['dateLeft'].formatString('yyyy-MM-dd HH:mm') : null,
        dateconfirmed:
          this.genDetails['dateConfirmed'] ? this.genDetails['dateConfirmed'].formatString('yyyy-MM-dd HH:mm') : null,
        photofile: !this.genDetails['employeeImage64'] ? '' : this.genDetails['employeeImage64'],
        photoaction: !this.genDetails['employeeImageAction'] ? 'N' : this.genDetails['employeeImageAction'],
        photoid: !this.genDetails['employeeImageID'] ? '' : this.genDetails['employeeImageID'],
        disabled: !this.genDetails['disableperson'] ? '' : this.genDetails['disableperson'],
        //#endregion
        //#region other details
        employmenttype:
          !this.otherDetails['employmentType'] ? '' : this.otherDetails['employmentType']['EmploymentType'],
        contractstartdate:
          this.otherDetails['contractStart'] ?
            this.otherDetails['contractStart'].formatString('yyyy-MM-dd HH:mm')
          : null,
        contractenddate:
          this.otherDetails['contractEnd'] ? this.otherDetails['contractEnd'].formatString('yyyy-MM-dd HH:mm') : null,
        branch: !this.otherDetails['branch'] ? '' : this.otherDetails['branch']['Branch Code'].trim(),
        department: !this.otherDetails['dept'] ? '' : this.otherDetails['dept']['ID'],
        jobtitle: !this.otherDetails['jobTitle'] ? '' : this.otherDetails['jobTitle'],
        superior: !this.otherDetails['superior'] ? '' : this.otherDetails['superior']['empNo'],
        shift:
          !this.otherDetails['shift'] ? ''
          : this.otherDetails['shift']['Shift'] === 'Night' ? 'N'
          : this.otherDetails['shift']['Shift'] === 'Morning' ? 'M'
          : this.otherDetails['shift']['Shift'],
        totalworkinghour: !this.otherDetails['totalWorkingHrs'] ? '' : this.otherDetails['totalWorkingHrs'],
        incometaxno: !this.otherDetails['incomeTaxNo'] ? '' : this.otherDetails['incomeTaxNo'],
        epfno: !this.otherDetails['epfNo'] ? '' : this.otherDetails['epfNo'],
        socsono: !this.otherDetails['socsoNo'] ? '' : this.otherDetails['socsoNo'],
        incometaxcategory:
          !this.otherDetails['incomeTaxCategory'] ? '' : this.otherDetails['incomeTaxCategory']['IncTaxCategory'],
        epfcategory: !this.otherDetails['epfCategory'] ? '' : this.otherDetails['epfCategory']['EPFCategory'],
        socsocategory: !this.otherDetails['socsoCategory'] ? '' : this.otherDetails['socsoCategory']['SocsoCategory'],
        skbbkcategory: !this.otherDetails['skbbkCategory'] ? '' : this.otherDetails['skbbkCategory']['SocsoCategory'],
        drivinglicenseno: !this.otherDetails['drivingLicenseNo'] ? '' : this.otherDetails['drivingLicenseNo'],
        expirydatedl:
          this.otherDetails['expirydatedl'] ? this.otherDetails['expirydatedl'].formatString('yyyy-MM-dd HH:mm') : null,

        badgelicenseno: !this.otherDetails['badgeLicenseNo'] ? '' : this.otherDetails['badgeLicenseNo'],

        expirydatebl:
          this.otherDetails['expirydatebl'] ? this.otherDetails['expirydatebl'].formatString('yyyy-MM-dd HH:mm') : null,
        portpassno: !this.otherDetails['portPassNo'] ? '' : this.otherDetails['portPassNo'],
        expirydatepp:
          this.otherDetails['expirydatepp'] ? this.otherDetails['expirydatepp'].formatString('yyyy-MM-dd HH:mm') : null,
        commisioncode: !this.otherDetails['commisionCode'] ? '' : this.otherDetails['commisionCode']['Com Code'].trim(),
        payrooltype: !this.otherDetails['payrollType'] ? '' : this.otherDetails['payrollType'],
        payrollbank: !this.otherDetails['payrollBank'] ? '' : this.otherDetails['payrollBank']['Bank Code'].trim(),
        payrollaccountno: !this.otherDetails['payrollAccNo'] ? '' : this.otherDetails['payrollAccNo'],
        drivingclass:
          this.otherDetails['drivingClass'] && this.otherDetails['drivingClass'].length ?
            this.otherDetails['drivingClass'].map((obj) => obj['Class']).join(',')
          : '',
        overtimeformula: !this.otherDetails['otFormula'] ? '' : this.otherDetails['otFormula']['Formula Code'].trim(),
        //#endregion

        //#region contact details

        //default
        addr1:
          !this.contactDetails['defaultAddressData']['addressLine1'] ?
            ''
          : this.contactDetails['defaultAddressData']['addressLine1'],
        addr2:
          !this.contactDetails['defaultAddressData']['addressLine2'] ?
            ''
          : this.contactDetails['defaultAddressData']['addressLine2'],
        addr3:
          !this.contactDetails['defaultAddressData']['addressLine3'] ?
            ''
          : this.contactDetails['defaultAddressData']['addressLine3'],
        addr4:
          !this.contactDetails['defaultAddressData']['addressLine4'] ?
            ''
          : this.contactDetails['defaultAddressData']['addressLine4'],
        postcode:
          !this.contactDetails['defaultAddressData']['postcode'] ?
            ''
          : this.contactDetails['defaultAddressData']['postcode'],
        city:
          !this.contactDetails['defaultAddressData']['city'] ? '' : this.contactDetails['defaultAddressData']['city'],
        state:
          !this.contactDetails['defaultAddressData']['state'] ? '' : this.contactDetails['defaultAddressData']['state'],
        country:
          !this.contactDetails['defaultAddressData']['country'] ?
            ''
          : this.contactDetails['defaultAddressData']['country'],
        phoneno: !this.contactDetails['defaultPhone'] ? '' : this.contactDetails['defaultPhone'],
        mobileno: !this.contactDetails['defaultMobile'] ? '' : this.contactDetails['defaultMobile'],
        email1: !this.contactDetails['defaultEmail1'] ? '' : this.contactDetails['defaultEmail1'],
        email2: !this.contactDetails['defaultEmail2'] ? '' : this.contactDetails['defaultEmail2'],

        //postal

        p_addr1:
          !this.contactDetails['postalAddressData']['addressLine1'] ?
            ''
          : this.contactDetails['postalAddressData']['addressLine1'],
        p_addr2:
          !this.contactDetails['postalAddressData']['addressLine2'] ?
            ''
          : this.contactDetails['postalAddressData']['addressLine2'],
        p_addr3:
          !this.contactDetails['postalAddressData']['addressLine3'] ?
            ''
          : this.contactDetails['postalAddressData']['addressLine3'],
        p_addr4:
          !this.contactDetails['postalAddressData']['addressLine4'] ?
            ''
          : this.contactDetails['postalAddressData']['addressLine4'],
        p_postcode:
          !this.contactDetails['postalAddressData']['postcode'] ?
            ''
          : this.contactDetails['postalAddressData']['postcode'],
        p_city:
          !this.contactDetails['postalAddressData']['city'] ? '' : this.contactDetails['postalAddressData']['city'],
        p_state:
          !this.contactDetails['postalAddressData']['state'] ? '' : this.contactDetails['postalAddressData']['state'],
        p_country:
          !this.contactDetails['postalAddressData']['country'] ?
            ''
          : this.contactDetails['postalAddressData']['country'],
        p_phoneno: !this.contactDetails['postalPhone'] ? '' : this.contactDetails['postalPhone'],
        p_mobileno: !this.contactDetails['postalMobile'] ? '' : this.contactDetails['postalMobile'],
        p_email1: !this.contactDetails['postalEmail1'] ? '' : this.contactDetails['postalEmail1'],
        p_email2: !this.contactDetails['postalEmail2'] ? '' : this.contactDetails['postalEmail2'],

        kinname: !this.contactDetails['kinName'] ? '' : this.contactDetails['kinName'],
        relationship: !this.contactDetails['kinRelationship'] ? '' : this.contactDetails['kinRelationship'],
        kinaddr1:
          !this.contactDetails['kinAddressData']['addressLine1'] ?
            ''
          : this.contactDetails['kinAddressData']['addressLine1'],
        kinaddr2:
          !this.contactDetails['kinAddressData']['addressLine2'] ?
            ''
          : this.contactDetails['kinAddressData']['addressLine2'],
        kinaddr3:
          !this.contactDetails['kinAddressData']['addressLine3'] ?
            ''
          : this.contactDetails['kinAddressData']['addressLine3'],
        kinaddr4:
          !this.contactDetails['kinAddressData']['addressLine4'] ?
            ''
          : this.contactDetails['kinAddressData']['addressLine4'],
        k_city: !this.contactDetails['kinAddressData']['city'] ? '' : this.contactDetails['kinAddressData']['city'],
        k_state: !this.contactDetails['kinAddressData']['state'] ? '' : this.contactDetails['kinAddressData']['state'],
        k_postcode:
          !this.contactDetails['kinAddressData']['postcode'] ? '' : this.contactDetails['kinAddressData']['postcode'],

        k_country:
          !this.contactDetails['kinAddressData']['country'] ? '' : this.contactDetails['kinAddressData']['country'],
        kinphoneno: !this.contactDetails['kinPhone'] ? '' : this.contactDetails['kinPhone'],
        action: this.action,
        // 'cocode' : cocode,
        //#endregion

        nominee: newNomineeList.map((n) => {
          return {
            nom_action: !n['Action'] ? 'E' : n['Action'],
            nom_name: n['Name'],
            nom_nric: n['NRIC'],
            percentage: n['Percentage'],
            nom_relationship: n['Relationship'],
            nom_type: n['Type'],
          };
        }),

        education: newEducationList.map((n) => {
          return {
            edu_action: !n['Action'] ? 'E' : n['Action'],
            edu_seqno: n['Sequence No'],
            institutename: n['Institute Name'],
            institutecategory: n['Institute Category'],
            edu_qualification:
              n['Qualification'] == 'PMR' ? '1'
              : n['Qualification'] == 'SPM/O-Level' ? '2'
              : n['Qualification'] == 'STPM/A-Level/STAM' ? '3'
              : n['Qualification'] == 'Diploma Degree' ? '4'
              : n['Qualification'] == 'Bachelor`s Degree' ? '5'
              : n['Qualification'] == 'Master`s Degree' ? '6'
              : n['Qualification'] == 'Professional Degree' ? '7'
              : n['Qualification'] == 'Doctoral Degree' ? '8'
              : '',
            major: n['Major'],
            edu_grade: n['Grade'],
            graduateyear: n['Graduate Year'],
            edu_startdate: n['From'],
            edu_endate: n['To'],
            edu_country: n['Country'],
            edu_remarks: n['Remarks'],
            cocode: n['Company Code'],
            edu_deleteremarks: !n['Remarks'] ? '' : n['Remarks'],
          };
        }),

        kin: newFamilyDetList.map((f) => {
          return {
            kinaction: !f['Action'] ? 'E' : f['Action'],
            kin_id: f['Kin ID'],
            kin_relationship: f['Relationship'],
            kin_name: f['Name'],
            kin_nric: f['NRIC'],
            kin_dob: f['Date of Birth'],
            kin_telno: f['Tel No'],
            kin_mobileno: f['Mobile No'],
            kin_working: f['Working'] == 'YES' ? 'Y' : '',
            kin_disabled: f['Disabled'] == 'YES' ? 'Y' : '',
            livingtogether: f['Living Together'] == 'YES' ? 'Y' : '',
            emergencycontact: f['Emergency Contact'] == 'YES' ? 'Y' : '',
            kin_diplomadegree: f['Diploma/Degree Level'] == 'YES' ? 'Y' : 'N',
            kin_gender:
              f['Gender'] == 'MALE' ? 'M'
              : f['Gender'] == 'FEMALE' ? 'F'
              : '',
            birthcertno: f['Birth Certificate No'],
          };
        }),

        employment: newEmploymentList.map((e) => {
          return {
            employmentaction: !e['Action'] ? 'E' : e['Action'],
            emp_seqno: e['Sequence No'],
            prevcompany: e['Company'],
            prevposition: e['Position'],
            reasonleaving: !e['Reason Leaving'] ? '' : e['Reason Leaving'],
            emp_remarks: !e['Remarks'] ? '' : e['Remarks'],
            datestart: e['Date Joined'],
            dateend: e['Date Left'],
            jobresponsibility: !e['Job Responsibilities'] ? '' : e['Job Responsibilities'],
            prevcompanytelno: e['Company Tel No'],
          };
        }),

        document: newDocumentsList.map((e) => {
          return {
            doc_action: !e['Action'] ? 'E' : e['Action'],
            doc_recdate: !e['Date Received'] ? '' : e['Date Received'],
            doc_rectime: e['Time Received'],
            doc_expdate: !e['Expiry Date'] ? '' : e['Expiry Date'],
            doc_date: !e['Document Date'] ? '' : e['Document Date'],
            doc_code: e['Document Code'],
            doc_type:
              e['Document Type'] == 'Copy' ? 'C'
              : e['Document Type'] == 'Fax' ? 'F'
              : e['Document Type'] == 'Original' ? 'O'
              : e['Document Type'] == 'Photocopy' ? 'P'
              : e['Document Type'] == 'Scanned File' ? 'S'
              : '',
            doc_refno: e['Ref No'],
            doc_remarks: !e['Remarks'] ? '' : e['Remarks'],
            doc_att: e['Document Name'],
            doc_guid: e['Document GUID'],
            filetype: e['File Type'],
            attfile: e['Attachment File'],
          };
        }),

        career: newCareerList.map((e) => {
          return {
            career_action: !e['career_action'] ? 'E' : e['career_action'],
            careerid: !e['Career ID'] ? '' : e['Career ID'],
            careernote: !e['Notes'] ? '' : e['Notes'],
            careerdate: !e['Date Update'] ? '' : e['Date Update'],
            careerdeleteremarks: !e['Delete remarks'] ? '' : e['Delete remarks'],
          };
        }),

        grade: !this.grade ? '' : this.grade['Grade Type'],
        salary: !this.grossSalary ? '' : this.grossSalary,
        qualification: !this.qualification ? '' : this.qualification,
        // 'career_id' : this.career['Sequence No'],
        children: !this.familyDetails['noOfChildren'] ? '' : this.familyDetails['noOfChildren'],
        childrentaxrebate:
          !this.familyDetails['noOfChildrenForTaxRebate'] ? '' : this.familyDetails['noOfChildrenForTaxRebate'],
        lastupdate: this.lastUpdate,
        tin: this.eInvoiceTIN,
      };
      this.saveButton(dataToPost);
    },
    saveButton: async function (data) {
      this.$fullscreenLoading('Saving Employee');
      const result = await this.$apiCallV2(`/Employee/SaveEmployee`, data);
      this.$fullscreenLoading();
      if (result[0]['Results'] == 0) {
        if (this.action == 'N') {
          this.entrySuccess.push(`Successfully Created Employee!`);
        } else {
          this.entrySuccess.push(`Successfully Edited Employee!`);
        }
        this.entrySuccess.push(`${result[0]['ErrMsg']}`);
        this.viewMode = true;
        this.viewModeCareer = true;
        this.deletedNomineeList = [];
        this.deletedEmploymentList = [];
        this.deletedDocumentsList = [];
        this.deletedFamilyDetList = [];
        this.deletedCareerList = [];
        this.deletedEducationList = [];
        this.getEmployees();
      } else if (result[0]['Results'] > 0) {
        this.entryError.push(`An Error has occurred. The error is ${result[0]['ErrMsg']}`);
      }
    },
    handleFileUpload: async function (file) {
      if (file.length == 0) {
        this.documents['docName'] = '';
        this.documents['filetype'] = '';
        this.documents['attachmentFile'] = null;
      } else {
        this.$fullscreenLoading('Adding Image');
        this.documents['docName'] = file[0].name;
        this.documents['filetype'] = file[0].name.substring(file[0].name.indexOf('.'));
        const tempAtt = await file[0].toBase64();
        this.documents['attachmentFile'] = tempAtt.substring(tempAtt.indexOf(',') + 1);
        this.$fullscreenLoading();
      }
    },
    imageChanged: async function (file) {
      if (file.length == 0) {
        this.genDetails['employeeImage'] = '';
      } else if (!file[0]['type'].includes('image')) {
        this.$showAlert('error', 'Invalid File Type', 'Please choose an image only');
        this.$nextTick(() => {
          this.$refs['imageInput'].clearAttachmentClicked();
        });
      } else {
        if (this.genDetails['employeeImage64']) this.genDetails['employeeImageAction'] = 'E';
        if (this.popupEnteryTitle == 'Edit Employee' && !this.genDetails['employeeImage64'])
          this.genDetails['employeeImageAction'] = 'D';
        this.$fullscreenLoading('Adding Image');
        const tempAtt = await file[0].toBase64();
        this.genDetails['employeeImage64'] = tempAtt.substring(tempAtt.indexOf(',') + 1);
        // let tempAtt = await file[0].toBase64();
        this.genDetails['employeeImage'] = await file[0].toBase64();
        this.$fullscreenLoading();
      }
    },

    validateTaxPayerTin: async function () {
      if (!this.eInvoiceTIN.startsWith('EI') && (this.genDetails['nricNew1'] == '' || this.genDetails['nricNew2'] == '' || this.genDetails['nricNew3'] == '')) {
        this.$showAlert('error', 'Missing ID Number', 'Please key in NRIC (New)');
        return;
      }
      this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/LoadingCircle.gif';
      this.validateTINMsg = 'Validating';

      const jsonBody = {
        tin: this.eInvoiceTIN,
        brn: `${this.genDetails['nricNew1']}${this.genDetails['nricNew2']}${this.genDetails['nricNew3']}`, //new ic #
      };
      const result = await this.$apiCallV2('/ARInvoice/ValidateTaxpayerTin', jsonBody);
      if (result?.[0]?.['Results'] == 0) {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Save.png';
        this.validateTINMsg = 'Valid Taxpayer TIN';
      } else {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Cancel.png';
        this.validateTINMsg = `Invalid Taxpayer TIN (${result?.[0]?.['ErrMsg']})`;
      }
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Employee') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });

    // this.getEmployees();
    const mountedPromises = [];
    let promisesFulfilled = 0;

    mountedPromises.push(
      this.getEmployees().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COUNTRY', module: 'null' }).then((result) => {
        this.genDetailsData['nationality'] = result;
        this.educationData['country'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'GENDER', module: 'null' }).then((result) => {
        this.genDetailsData['gender'] = result;
        this.familyDetailsData['kinGender'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'RACE', module: 'null' }).then((result) => {
        this.genDetailsData['race'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'MARITALSTATUS', module: 'null' }).then((result) => {
        this.genDetailsData['maritalStat'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'RELIGION', module: 'null' }).then((result) => {
        this.genDetailsData['religion'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'ETHNIC', module: 'null' }).then((result) => {
        this.genDetailsData['ethnicity'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMPLOYMENTTYPE', module: 'null' }).then((result) => {
        this.otherDetailsData['employmentType'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BRANCH', module: 'null' }).then((result) => {
        this.otherDetailsData['branch'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DEPARTMENT', module: 'null' }).then((result) => {
        this.otherDetailsData['dept'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIFT', module: 'null' }).then((result) => {
        this.otherDetailsData['shift'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'INCOMETAXCATEGORY', module: 'null' }).then((result) => {
        this.otherDetailsData['incomeTaxCategory'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EPFCATEGORY', module: 'null' }).then((result) => {
        this.otherDetailsData['epfCategory'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SOCSOCATEGORY', module: 'null' }).then((result) => {
        this.otherDetailsData['socsoCategory'] = result;
        this.otherDetailsData['skbbkCategory'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DRIVINGCLASS', module: 'null' }).then((result) => {
        this.otherDetailsData['drivingClass'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'LORRYCOMISSION', module: 'null' }).then((result) => {
        this.otherDetailsData['commisionCode'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    const payrollTypeData = [
      {
        '#': '1',
        'Payroll Type': 'Cash',
      },
      {
        '#': '2',
        'Payroll Type': 'Cheque/Bank Transfer',
      },
    ];
    this.otherDetailsData['payrollTypes'] = payrollTypeData;

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'GIROBANK', module: 'null' }).then((result) => {
        this.otherDetailsData['payrollBank'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'OVERTIMEFORMULA', module: 'null' }).then((result) => {
        this.otherDetailsData['otFormula'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'NOMINEETYPE', module: 'null' }).then((result) => {
        this.contactDetailsData['nomineeType'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'RELATIONSHIP', module: 'null' }).then((result) => {
        this.familyDetailsData['kinRelationship'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMPLOYEEGRADE', module: 'null' }).then((result) => {
        this.careerData['grade'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'INSTITUTECATEGORY', module: 'null' }).then((result) => {
        this.educationData['instituteCategory'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'QUALIFICATION', module: 'null' }).then((result) => {
        this.educationData['qualification'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TERMINATETYPE', module: 'null' }).then((result) => {
        this.terminateType = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DOC', module: 'null' }).then((result) => {
        this.getDocData['docCode'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    // // #endregion
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DOCTYPE', module: 'null' }).then((result) => {
        this.getDocData['docType'] = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    //allow user to quickly creates a new employee in other pages
    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Employee' });
    }

    await Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menus = this.menus.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.emp-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  #box-container {
    flex-direction: row;
  }

  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}

.emp-no {
  display: flex;

  > :last-child {
    margin-left: 5px;
  }
}

.details-3-column {
  width: calc(100% / 3);
  margin-right: 5px;
}

.employee-image {
  width: 80%;
  height: 55%;
  background-color: gray;
  object-fit: contain;
  display: flex;
  flex-direction: column;

  > img {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
}

.details-2-column {
  width: calc(100% / 2);
  margin-right: 5px;
}

.container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* fraction*/
}
.details-1-column {
  width: 100%;
  margin-right: 5px;
}

.details-2-column {
  width: calc(100% / 2);
  margin-right: 5px;
}

.details-1-column {
  width: 100%;
  margin-right: 5px;
}

.tab-container {
  display: flex;
  width: 100%;
  margin-bottom: 5px;
  position: relative;
  padding-top: 10px;
  padding-left: 5px;
  height: 350px;

  > :nth-child(1) {
    /* border: 1px solid green; */
    width: 100%;
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  > .content-3-column {
    width: calc(100% / 3);
    margin-right: 5px;
  }

  > .content-2-column {
    width: 50%;
    margin-right: 5px;
  }

  > .content-1-column {
    width: 100%;
    margin-right: 5px;
  }
}

.photo-input {
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;

  > .photo-label,
  > .photo-details {
    width: 100%;
    height: 20px;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    > img {
      width: 15px;
      height: 15px;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      transition: transform 0.3s;
    }
    > img:hover {
      transform: scale(1.5);
    }
  }

  > .photo-content {
    /* cursor: pointer; */
    border: 1px solid rgba(0, 0, 0, 0.5);
    /* border: 1px solid black; */
    height: 100%;
    max-width: 210px;
    position: relative;

    > input {
      height: 100%;
      width: 100%;
      opacity: 0;
      cursor: pointer;
    }

    > img,
    > .image-message {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
      object-fit: contain;
    }

    > .image-message {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }

  > .view-mode-image {
    opacity: 0.8;
    background-color: rgba(200, 200, 200, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.checkbox-container {
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;

  > .checkbox-title {
    margin-right: 15px;
  }

  > .checkbox-content {
    display: flex;
    width: auto;
    padding: 0 5px;
    border: solid 1px lightgray;
    border-radius: 3px;
  }
}

.bottom-left-align {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 5px;
}

.clear-all-button,
.save-button,
.cancel-button {
  color: white;
}

.save-button {
  background-color: green;
  margin-left: 5px;
}

.cancel-button {
  background-color: red;
  margin-left: 5px;
}

.details-popup {
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(128, 128, 128, 0.5);
  height: 100%;
  width: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  > .details-popup-content {
    width: 90%;
    height: auto;
    max-width: 500px;
    background-color: white;
    padding: 10px;
    border-radius: 5px;

    > .title {
      font-weight: bold;
      font-size: 13px;
      margin-bottom: 5px;
    }

    > .button-section {
      display: flex;
      justify-content: flex-end;

      > button {
        margin-left: 5px;
      }
    }
  }
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}
.slotWithTableBox {
  height: calc(100% - 10px);
}

.divWithTableBox {
  height: calc(100% - 28px);
}

.contact-details-main {
  height: calc(100%);
  width: 100%;
  display: flex;

  > .left-container {
    width: 100%;

    > .contact-tabulator {
      height: calc(100% - 95px) !important;
    }

    > .add-remove-contact {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 3px;
    }
  }
}

.filters {
  height: 50%;
}

.lhdn-tin {
  display: flex;
  flex-direction: row;
}
</style>
